webpackJsonp([1],{

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPromotionAmount = exports.deleteVoucher = exports.updateVoucher = exports.addVoucher = exports.getVoucherList = exports.deleteVoucherActivity = exports.updateVoucherActivity = exports.addVoucherActivity = exports.getVoucherActivityList = exports.queryWaybill = exports.u8orderidInter = exports.batchDelLogistics = exports.editOrderWaybillcode = exports.enableLogistics = exports.editLogistics = exports.getLogisticsList = exports.deleteProcesslabelinventory = exports.deleteProcesslabel = exports.deletePromotionstep = exports.deletePromotion = exports.orderDetailByPage = exports.orderDetail = exports.findwaybill = exports.enableOrder = exports.editPaystatus = exports.editOrder = exports.getOrderList = exports.enableProcesslabelInventory = exports.editProcesslabelInventory = exports.addProcesslabelInventory = exports.getProcesslabelInventoryList = exports.sortProcesslabel = exports.enableProcesslabel = exports.editProcesslabel = exports.addProcesslabel = exports.getProcesslabelList = exports.sortPromotionstep = exports.enablePromotionstep = exports.editPromotionstep = exports.addPromotionstep = exports.getPromotionstepList = exports.promotionCopy = exports.sortPromotion = exports.enablePromotion = exports.editPromotion = exports.addPromotion = exports.getPromotionList = exports.enablecombinationinventory = exports.addCombinationinventory = exports.combinationinventoryList = exports.enableCombination = exports.addCombination = exports.combinationList = exports.updateInventory = exports.enableInventory = exports.enableInventoryimage = exports.editInventoryimage = exports.addInventoryimage = exports.getInventoryList = exports.inventoryVague = exports.getInventoryClassList = exports.areabyroleList = exports.batchAddClient = exports.deleteClient = exports.enableClient = exports.editClient = exports.addClient = exports.getClientList = exports.clientVague = exports.deleteVideo = exports.enableVideo = exports.editVideo = exports.getVideoList = exports.sortBanner = exports.deleteBanner = exports.enableBanner = exports.editBanner = exports.addBanner = exports.getBannerList = exports.deleteArea = exports.enableArea = exports.editArea = exports.addArea = exports.getAreaConfig = exports.resetUserPass = exports.changePassword = exports.deleteUser = exports.enableUser = exports.editUser = exports.addUser = exports.getUserList = exports.requestLoginOut = exports.requestLogin = undefined;

var _http = __webpack_require__(338);

var _http2 = _interopRequireDefault(_http);

var _http3 = __webpack_require__(339);

var _http4 = _interopRequireDefault(_http3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var requestLogin = exports.requestLogin = function requestLogin(params, _this) {
  return _http2.default.post('/system/login', params, _this);
};
var requestLoginOut = exports.requestLoginOut = function requestLoginOut(params, _this) {
  return _http2.default.post('/system/loginOut', params, _this);
};

var getUserList = exports.getUserList = function getUserList(params, _this) {
  return _http2.default.post('/system/userList', params, _this);
};
var addUser = exports.addUser = function addUser(params, _this) {
  return _http2.default.post('/system/addUser', params, _this);
};
var editUser = exports.editUser = function editUser(params, _this) {
  return _http2.default.post('/system/editUser', params, _this);
};
var enableUser = exports.enableUser = function enableUser(params, _this) {
  return _http2.default.post('/system/enableUser', params, _this);
};
var deleteUser = exports.deleteUser = function deleteUser(params, _this) {
  return _http2.default.post('/system/deleteUser', params, _this);
};
var changePassword = exports.changePassword = function changePassword(params, _this) {
  return _http2.default.post('/system/changePassword', params, _this);
};
var resetUserPass = exports.resetUserPass = function resetUserPass(params, _this) {
  return _http2.default.post('/system/resetUserPass', params, _this);
};

var getAreaConfig = exports.getAreaConfig = function getAreaConfig(params, _this) {
  return _http2.default.post('/system/areaConfig', params, _this);
};
var addArea = exports.addArea = function addArea(params, _this) {
  return _http2.default.post('/system/addArea', params, _this);
};
var editArea = exports.editArea = function editArea(params, _this) {
  return _http2.default.post('/system/editArea', params, _this);
};
var enableArea = exports.enableArea = function enableArea(params, _this) {
  return _http2.default.post('/system/enableArea', params, _this);
};
var deleteArea = exports.deleteArea = function deleteArea(params, _this) {
  return _http2.default.post('/system/deleteArea', params, _this);
};

var getBannerList = exports.getBannerList = function getBannerList(params, _this) {
  return _http2.default.post('/system/bannerList', params, _this);
};
var addBanner = exports.addBanner = function addBanner(params, _this) {
  return _http2.default.post('/system/addBanner', params, _this);
};var editBanner = exports.editBanner = function editBanner(params, _this) {
  return _http2.default.post('/system/editBanner', params, _this);
};
var enableBanner = exports.enableBanner = function enableBanner(params, _this) {
  return _http2.default.post('/system/enableBanner', params, _this);
};
var deleteBanner = exports.deleteBanner = function deleteBanner(params, _this) {
  return _http2.default.post('/system/deleteBanner', params, _this);
};
var sortBanner = exports.sortBanner = function sortBanner(params, _this) {
  return _http2.default.post('/system/sortBanner', params, _this);
};

var getVideoList = exports.getVideoList = function getVideoList(params, _this) {
  return _http2.default.post('/video/videoList', params, _this);
};
var editVideo = exports.editVideo = function editVideo(params, _this) {
  return _http2.default.post('/video/addVideo', params, _this);
};
var enableVideo = exports.enableVideo = function enableVideo(params, _this) {
  return _http2.default.post('/video/enableVideo', params, _this);
};
var deleteVideo = exports.deleteVideo = function deleteVideo(params, _this) {
  return _http2.default.post('/video/deleteVideo', params, _this);
};

var clientVague = exports.clientVague = function clientVague(params, _this) {
  return _http2.default.post('/client/clientVague', params, _this);
};
var getClientList = exports.getClientList = function getClientList(params, _this) {
  return _http2.default.post('/client/clientList', params, _this);
};
var addClient = exports.addClient = function addClient(params, _this) {
  return _http2.default.post('/client/addClient', params, _this);
};
var editClient = exports.editClient = function editClient(params, _this) {
  return _http2.default.post('/client/editClient', params, _this);
};
var enableClient = exports.enableClient = function enableClient(params, _this) {
  return _http2.default.post('/client/enableClient', params, _this);
};
var deleteClient = exports.deleteClient = function deleteClient(params, _this) {
  return _http2.default.post('/client/deleteClient', params, _this);
};
var batchAddClient = exports.batchAddClient = function batchAddClient(params, _this) {
  return _http2.default.post('/client/batchAddClient', params, _this);
};
var areabyroleList = exports.areabyroleList = function areabyroleList(params, _this) {
  return _http2.default.post('/system/areabyroleList', params, _this);
};

var getInventoryClassList = exports.getInventoryClassList = function getInventoryClassList(params, _this) {
  return _http2.default.post('/inventory/inventoryclassList', params, _this);
};
var inventoryVague = exports.inventoryVague = function inventoryVague(params, _this) {
  return _http2.default.post('/inventory/inventoryVague', params, _this);
};
var getInventoryList = exports.getInventoryList = function getInventoryList(params, _this) {
  return _http2.default.post('/inventory/inventoryList', params, _this);
};
var addInventoryimage = exports.addInventoryimage = function addInventoryimage(params, _this) {
  return _http2.default.post('/inventory/addInventoryimage', params, _this);
};
var editInventoryimage = exports.editInventoryimage = function editInventoryimage(params, _this) {
  return _http2.default.post('/inventory/editInventoryimage', params, _this);
};
var enableInventoryimage = exports.enableInventoryimage = function enableInventoryimage(params, _this) {
  return _http2.default.post('/inventory/enableInventoryimage', params, _this);
};
var enableInventory = exports.enableInventory = function enableInventory(params, _this) {
  return _http2.default.post('/inventory/enableInventory', params, _this);
};
var updateInventory = exports.updateInventory = function updateInventory(params, _this) {
  return _http2.default.post('/inventory/updateInventory', params, _this);
};

var combinationList = exports.combinationList = function combinationList(params, _this) {
  return _http2.default.post('/inventory/combinationList', params, _this);
};
var addCombination = exports.addCombination = function addCombination(params, _this) {
  return _http2.default.post('/inventory/addCombination', params, _this);
};
var enableCombination = exports.enableCombination = function enableCombination(params, _this) {
  return _http2.default.post('/inventory/enableCombination', params, _this);
};

var combinationinventoryList = exports.combinationinventoryList = function combinationinventoryList(params, _this) {
  return _http2.default.post('/inventory/combinationinventoryList', params, _this);
};
var addCombinationinventory = exports.addCombinationinventory = function addCombinationinventory(params, _this) {
  return _http2.default.post('/inventory/addCombinationinventory', params, _this);
};
var enablecombinationinventory = exports.enablecombinationinventory = function enablecombinationinventory(params, _this) {
  return _http2.default.post('/inventory/enablecombinationinventory', params, _this);
};

var getPromotionList = exports.getPromotionList = function getPromotionList(params, _this) {
  return _http2.default.post('/promotion/promotionList', params, _this);
};
var addPromotion = exports.addPromotion = function addPromotion(params, _this) {
  return _http2.default.post('/promotion/addPromotion', params, _this);
};
var editPromotion = exports.editPromotion = function editPromotion(params, _this) {
  return _http2.default.post('/promotion/editPromotion', params, _this);
};
var enablePromotion = exports.enablePromotion = function enablePromotion(params, _this) {
  return _http2.default.post('/promotion/enablePromotion', params, _this);
};
var sortPromotion = exports.sortPromotion = function sortPromotion(params, _this) {
  return _http2.default.post('/promotion/sortPromotion', params, _this);
};
var promotionCopy = exports.promotionCopy = function promotionCopy(params, _this) {
  return _http2.default.post('/promotion/promotionCopy', params, _this);
};

var getPromotionstepList = exports.getPromotionstepList = function getPromotionstepList(params, _this) {
  return _http2.default.post('/promotion/promotionstepList', params, _this);
};
var addPromotionstep = exports.addPromotionstep = function addPromotionstep(params, _this) {
  return _http2.default.post('/promotion/addPromotionstep', params, _this);
};
var editPromotionstep = exports.editPromotionstep = function editPromotionstep(params, _this) {
  return _http2.default.post('/promotion/editPromotionstep', params, _this);
};
var enablePromotionstep = exports.enablePromotionstep = function enablePromotionstep(params, _this) {
  return _http2.default.post('/promotion/enablePromotionstep', params, _this);
};
var sortPromotionstep = exports.sortPromotionstep = function sortPromotionstep(params, _this) {
  return _http2.default.post('/promotion/sortPromotionstep', params, _this);
};

var getProcesslabelList = exports.getProcesslabelList = function getProcesslabelList(params, _this) {
  return _http2.default.post('/promotion/processlabelList', params, _this);
};
var addProcesslabel = exports.addProcesslabel = function addProcesslabel(params, _this) {
  return _http2.default.post('/promotion/addProcesslabel', params, _this);
};
var editProcesslabel = exports.editProcesslabel = function editProcesslabel(params, _this) {
  return _http2.default.post('/promotion/editProcesslabel', params, _this);
};
var enableProcesslabel = exports.enableProcesslabel = function enableProcesslabel(params, _this) {
  return _http2.default.post('/promotion/enableProcesslabel', params, _this);
};
var sortProcesslabel = exports.sortProcesslabel = function sortProcesslabel(params, _this) {
  return _http2.default.post('/promotion/sortProcesslabel', params, _this);
};

var getProcesslabelInventoryList = exports.getProcesslabelInventoryList = function getProcesslabelInventoryList(params, _this) {
  return _http2.default.post('/promotion/processlabelInventoryList', params, _this);
};
var addProcesslabelInventory = exports.addProcesslabelInventory = function addProcesslabelInventory(params, _this) {
  return _http2.default.post('/promotion/addProcesslabelInventory', params, _this);
};
var editProcesslabelInventory = exports.editProcesslabelInventory = function editProcesslabelInventory(params, _this) {
  return _http2.default.post('/promotion/editProcesslabelInventory', params, _this);
};
var enableProcesslabelInventory = exports.enableProcesslabelInventory = function enableProcesslabelInventory(params, _this) {
  return _http2.default.post('/promotion/enableProcesslabelInventory', params, _this);
};

var getOrderList = exports.getOrderList = function getOrderList(params, _this) {
  return _http4.default.post('/admin/order_list', params, _this);
};
var editOrder = exports.editOrder = function editOrder(params, _this) {
  return _http2.default.post('/order/editOrder', params, _this);
};
var editPaystatus = exports.editPaystatus = function editPaystatus(params, _this) {
  return _http2.default.post('/order/editPaystatus_new_2', params, _this);
};
var enableOrder = exports.enableOrder = function enableOrder(params, _this) {
  return _http2.default.post('/order/enableOrder', params, _this);
};

var findwaybill = exports.findwaybill = function findwaybill(params, _this) {
  return _http2.default.post('/order/waybill', params, _this);
};
var orderDetail = exports.orderDetail = function orderDetail(params, _this) {
  return _http2.default.post('/order/orderDetail', params, _this);
};
var orderDetailByPage = exports.orderDetailByPage = function orderDetailByPage(params, _this) {
  return _http2.default.post('/order/orderDetailByPage', params, _this);
};

var deletePromotion = exports.deletePromotion = function deletePromotion(params, _this) {
  return _http2.default.post('/promotion/deletePromotion', params, _this);
};
var deletePromotionstep = exports.deletePromotionstep = function deletePromotionstep(params, _this) {
  return _http2.default.post('/promotion/deletePromotionstep', params, _this);
};
var deleteProcesslabel = exports.deleteProcesslabel = function deleteProcesslabel(params, _this) {
  return _http2.default.post('/promotion/deleteProcesslabel', params, _this);
};
var deleteProcesslabelinventory = exports.deleteProcesslabelinventory = function deleteProcesslabelinventory(params, _this) {
  return _http2.default.post('/promotion/deleteProcesslabelinventory', params, _this);
};

var getLogisticsList = exports.getLogisticsList = function getLogisticsList(params, _this) {
  return _http2.default.post('/logistics/logisticsList', params, _this);
};
var editLogistics = exports.editLogistics = function editLogistics(params, _this) {
  return _http2.default.post('/logistics/addLogistics', params, _this);
};
var enableLogistics = exports.enableLogistics = function enableLogistics(params, _this) {
  return _http2.default.post('/logistics/enableLogistics', params, _this);
};
var editOrderWaybillcode = exports.editOrderWaybillcode = function editOrderWaybillcode(params, _this) {
  return _http2.default.post('/logistics/editOrderWaybillcode', params, _this);
};
var batchDelLogistics = exports.batchDelLogistics = function batchDelLogistics(params, _this) {
  return _http2.default.post('/logistics/batchDelLogistics', params, _this);
};

var u8orderidInter = exports.u8orderidInter = function u8orderidInter(params, _this) {
  return _http2.default.post('/order/u8orderid', params, _this);
};

var queryWaybill = exports.queryWaybill = function queryWaybill(params, _this) {
  return _http4.default.post('/admin/query_waybill', params, _this);
};

var getVoucherActivityList = exports.getVoucherActivityList = function getVoucherActivityList(params, _this) {
  return _http2.default.post('/voucher/activity/list', params, _this);
};
var addVoucherActivity = exports.addVoucherActivity = function addVoucherActivity(params, _this) {
  return _http2.default.post('/voucher/activity/add', params, _this);
};
var updateVoucherActivity = exports.updateVoucherActivity = function updateVoucherActivity(params, _this) {
  return _http2.default.post('/voucher/activity/update', params, _this);
};
var deleteVoucherActivity = exports.deleteVoucherActivity = function deleteVoucherActivity(params, _this) {
  return _http2.default.post('/voucher/activity/delete', params, _this);
};

var getVoucherList = exports.getVoucherList = function getVoucherList(params, _this) {
  return _http2.default.post('/voucher/list', params, _this);
};
var addVoucher = exports.addVoucher = function addVoucher(params, _this) {
  return _http2.default.post('/voucher/add', params, _this);
};
var updateVoucher = exports.updateVoucher = function updateVoucher(params, _this) {
  return _http2.default.post('/voucher/update', params, _this);
};
var deleteVoucher = exports.deleteVoucher = function deleteVoucher(params, _this) {
  return _http2.default.post('/voucher/delete', params, _this);
};
var getPromotionAmount = exports.getPromotionAmount = function getPromotionAmount(params, _this) {
  return _http2.default.post('/promotion/get', params, _this);
};

/***/ }),

/***/ 114:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAfCAYAAACGVs+MAAAAWklEQVRYR2NkoAwIQLV/INcYRnI1QvUJQ+m35Joz6oDREBgNgdEQGA2B0RAYFCHAy8DAIElmbUZpdfx8UIQAmZ4HaxttD4yGwGgIjIbAaAiMhsCAhwCl1TEDAGapIC07YfDPAAAAAElFTkSuQmCC"

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(652)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(717),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 256:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Login = __webpack_require__(670);

var _Login2 = _interopRequireDefault(_Login);

var _ = __webpack_require__(668);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(669);

var _Home2 = _interopRequireDefault(_Home);

var _Banner = __webpack_require__(672);

var _Banner2 = _interopRequireDefault(_Banner);

var _Video = __webpack_require__(673);

var _Video2 = _interopRequireDefault(_Video);

var _Client = __webpack_require__(674);

var _Client2 = _interopRequireDefault(_Client);

var _InventoryClass = __webpack_require__(678);

var _InventoryClass2 = _interopRequireDefault(_InventoryClass);

var _Inventory = __webpack_require__(677);

var _Inventory2 = _interopRequireDefault(_Inventory);

var _Combination = __webpack_require__(675);

var _Combination2 = _interopRequireDefault(_Combination);

var _CombinationInventory = __webpack_require__(676);

var _CombinationInventory2 = _interopRequireDefault(_CombinationInventory);

var _Order = __webpack_require__(680);

var _Order2 = _interopRequireDefault(_Order);

var _OrderView = __webpack_require__(681);

var _OrderView2 = _interopRequireDefault(_OrderView);

var _Promotion = __webpack_require__(684);

var _Promotion2 = _interopRequireDefault(_Promotion);

var _PromotionStep = __webpack_require__(685);

var _PromotionStep2 = _interopRequireDefault(_PromotionStep);

var _ProcessLabel = __webpack_require__(682);

var _ProcessLabel2 = _interopRequireDefault(_ProcessLabel);

var _ProcessLabelInventory = __webpack_require__(683);

var _ProcessLabelInventory2 = _interopRequireDefault(_ProcessLabelInventory);

var _User = __webpack_require__(689);

var _User2 = _interopRequireDefault(_User);

var _ChangePwd = __webpack_require__(687);

var _ChangePwd2 = _interopRequireDefault(_ChangePwd);

var _Logout = __webpack_require__(688);

var _Logout2 = _interopRequireDefault(_Logout);

var _Area = __webpack_require__(686);

var _Area2 = _interopRequireDefault(_Area);

var _Logistics = __webpack_require__(679);

var _Logistics2 = _interopRequireDefault(_Logistics);

var _VoucherActivity = __webpack_require__(691);

var _VoucherActivity2 = _interopRequireDefault(_VoucherActivity);

var _Voucher = __webpack_require__(690);

var _Voucher2 = _interopRequireDefault(_Voucher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    path: '/login',
    component: _Login2.default,
    name: '',
    hidden: true
}, {
    path: '/404',
    component: _2.default,
    name: '',
    hidden: true
}, {
    path: '/home',
    component: _Home2.default,
    name: '',
    hidden: true
}, {
    path: '/',
    component: _Home2.default,
    name: '广告管理',
    iconCls: 'iconfont icon-bell hzp-icon hzp-gg-icon-color',
    children: [{ path: '/banner', component: _Banner2.default, name: '广告清单' }, { path: '/video', component: _Video2.default, name: '视频清单' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'iconfont icon-user hzp-icon hzp-kh-icon-color',
    leaf: true,
    children: [{ path: '/client', component: _Client2.default, name: '客户管理' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '商品管理',
    iconCls: 'iconfont icon-appstore hzp-icon hzp-sp-icon-color',
    children: [{ path: '/inventoryClass', component: _InventoryClass2.default, name: '商品分类' }, { path: '/inventory', component: _Inventory2.default, name: '商品清单' }, { path: '/combination', component: _Combination2.default, name: '组合清单' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    hidden: true,
    leaf: true,
    children: [{ path: '/combinationInventory', component: _CombinationInventory2.default, name: '组合商品' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'iconfont icon-detail hzp-icon hzp-dd-icon-color',
    leaf: true,
    children: [{ path: '/order', component: _Order2.default, name: '订单管理' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    hidden: true,
    leaf: true,
    children: [{ path: '/orderView', component: _OrderView2.default, name: '查看订单' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'iconfont icon-insertrowabove hzp-icon hzp-cx-icon-color',
    leaf: true,
    children: [{ path: '/promotion', component: _Promotion2.default, name: '促销管理' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    hidden: true,
    leaf: true,
    children: [{ path: '/promotionStep', component: _PromotionStep2.default, name: '促销步骤' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    hidden: true,
    leaf: true,
    children: [{ path: '/processLabel', component: _ProcessLabel2.default, name: '促销标签' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    hidden: true,
    leaf: true,
    children: [{ path: '/processLabelInventory', component: _ProcessLabelInventory2.default, name: '编辑促销标签' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '系统管理',
    iconCls: 'iconfont icon-setting hzp-icon hzp-xt-icon-color',
    children: [{ path: '/user', component: _User2.default, name: '用户管理' }, { path: '/area', component: _Area2.default, name: '区域管理' }, { path: '/changePwd', component: _ChangePwd2.default, name: '修改密码' }, { path: '/logout', component: _Logout2.default, name: '退出登录' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'el-icon-aim hzp-icon hzp-wl-icon-color',
    leaf: true,
    children: [{ path: '/logistics', component: _Logistics2.default, name: '物流管理' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '返单券管理',
    iconCls: 'el-icon-present hzp-icon hzp-fdq-icon-color',
    children: [{ path: '/VoucherActivity', component: _VoucherActivity2.default, name: '返单券活动' }, { path: '/Voucher', component: _Voucher2.default, name: '返单券明细' }]
}, {
    path: '*',
    component: _Home2.default,
    hidden: true,
    redirect: { path: '/home' }
}];

exports.default = routes;

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(643)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(708),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(646)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(711),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}
};

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _Pagination = __webpack_require__(37);

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		Pagination: _Pagination2.default
	},
	data: function data() {
		return {
			courseSchedule: [{
				"days": "20190418",
				"data": [{
					"courseId": 1,
					"courseScheduleId": 1,
					"camId": 1,
					"courseName": "数学",
					"campusName": "普陀校区",
					"teacherName": "Hakim",
					"starTime": "2019-04-18 10:00:00",
					"endTime": "2019-04-18 11:00:00",
					"days": "20190418"
				}]
			}, {
				"days": "20190422",
				"data": [{
					"courseId": 1,
					"courseScheduleId": 2,
					"camId": 1,
					"courseName": "数学",
					"campusName": "普陀校区",
					"teacherName": "Hakim",
					"starTime": "2019-04-22 19:49:29",
					"endTime": "2019-04-22 19:49:34",
					"days": "20190422"
				}]
			}],
			tableHead: _emEnum2.default.courseScheduleHead,

			tableData: _emEnum2.default.courseSchedule60min,

			containerHeight: 0,

			pageSize: 100,
			pageNum: 1,
			totalNum: 0
		};
	},

	methods: {
		exportExcel: function exportExcel() {
			this.$router.push({ path: '/404' });
		},
		handlePageSizeChange: function handlePageSizeChange(val) {
			this.pageSize = val;
		},
		handlePageCurrentChange: function handlePageCurrentChange(val) {
			this.pageNum = val;
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		this.containerHeight = this.$refs.usercontainer.offsetHeight;

		var _this = this;
		window.onresize = function () {
			return function () {
				if (!_this2.timer && !!_this.$refs.usercontainer) {
					_this2.timer = true;
					_this.containerHeight = _this.$refs.usercontainer.offsetHeight;
					var that = _this2;
					setTimeout(function () {
						that.timer = false;
					}, 100);
				}
			}();
		};
	}
};

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  methods: {
    returnHomePage: function returnHomePage() {
      this.$router.push({ path: '/home' });
    }
  }
};

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(11);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			sysCnName: _emEnum2.default.cnName,
			sysEnName: _emEnum2.default.enName,
			version: _emEnum2.default.version,
			baseURL: _emEnum2.default.url.baseURL.replace('ybn.api.hyfun', '***.api.*****').replace('shhzp', '*****'),

			logoUrl: __webpack_require__(667),

			userName: '',
			role: '',

			rootMenuArray: _emEnum2.default.rootMenuArray,
			adminMenuArray: _emEnum2.default.adminMenuArray,
			receptionMenuArray: _emEnum2.default.receptionMenuArray,
			logisticsMenuArray: _emEnum2.default.logisticsMenuArray,
			unAddMenuArray: _emEnum2.default.unAddMenuArray,
			menuArray: [],

			dialogVisible: false,
			isCollapse: false };
	},

	methods: {
		spreadOrCollapse: function spreadOrCollapse(e) {
			if (e.srcElement.tagName === 'UL') {
				this.isCollapse = !this.isCollapse;
			}
		},
		handleopen: function handleopen() {},
		handleclose: function handleclose() {},

		handleselect: function handleselect(key, keyPath) {
			if (key === '/logout') {
				this.logout();
			} else {
				_util2.default.editStore.ClearEditValue();
			}
		},

		logout: function logout() {
			var _this = this;
			_this.$confirm('确认退出？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.dialogVisible = true;
				_this.logining = true;

				var params = {};
				(0, _api.requestLoginOut)(params, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.logining = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
						_this.dialogVisible = false;
					} else {
						_util2.default.userData.reLogin(_this, false);
						_this.dialogVisible = false;
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		changePwd: function changePwd() {
			var _this2 = this;

			var _this = this;
			_this.$confirm('修改密码后需重新登录，是否继续修改密码？', '提示', {
				type: 'warning'
			}).then(function () {
				_this2.$router.push({ path: '/changePwd' });
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		}
	},
	mounted: function mounted() {
		this.userName = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.username, this);

		this.role = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.role, this);
		if (this.role === 1) this.menuArray = this.rootMenuArray;else if (this.role === 2) this.menuArray = this.adminMenuArray;else if (this.role === 3) this.menuArray = this.receptionMenuArray;else if (this.role === 4) this.menuArray = this.logisticsMenuArray;
	}
};

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			rootLayer: '促销管理',
			firstLayerData: [],
			firstLayerVal: '',
			secondLayerData: [],
			secondLayerVal: '',
			thirdLayerData: [],
			thirdLayerVal: '',
			callFunc: false };
	},

	methods: {
		rootClick: function rootClick() {
			this.$router.push({ path: '/promotion' });
		},

		firstLayerChange: function firstLayerChange(rowId) {
			var _this = this;
			var row = _this.firstLayerData.find(function (item) {
				return item.id === rowId;
			});

			_this.callFunc = false;
			_this.$emit("promotionChange", row.id);
			if (!_this.callFunc) {
				_this.$router.push({ path: '/promotionStep', query: { pid: row.id } });
			}
		},

		secondLayerChange: function secondLayerChange(rowId) {
			var _this = this;
			var row = _this.secondLayerData.find(function (item) {
				return item.id === rowId;
			});

			_this.callFunc = false;
			_this.$emit("promotionStepChange", _this.firstLayerVal, row.id, row.steptitle, row.steptype);
			if (!_this.callFunc) {
				this.$router.push({ path: '/processLabel', query: { pid: _this.firstLayerVal, sid: row.id, st: row.steptitle, sp: row.steptype } });
			}
		},

		thirdLayerChange: function thirdLayerChange(rowId) {
			var _this = this;
			var row = _this.thirdLayerData.find(function (item) {
				return item.id === rowId;
			});
			var rowsec = _this.secondLayerData.find(function (item) {
				return item.id === _this.secondLayerVal;
			});

			_this.callFunc = false;
			_this.$emit("promotionLabelChange", _this.firstLayerVal, _this.secondLayerVal, row.steptitle, rowsec.steptype, row.id, row.labelname, row.startime, row.endtime, row.remark);
			if (!_this.callFunc) {
				var q = {
					pid: _this.firstLayerVal,
					sid: _this.secondLayerVal,
					st: row.steptitle,
					sp: rowsec.steptype,
					plid: row.id,
					ln: row.labelname,

					s: row.startime,
					e: row.endtime,
					r: row.remark
				};
				this.$router.push({ path: '/processLabelInventory', query: q });
			}
		},

		callBack: function callBack() {
			this.callFunc = true;
		},

		changeData: function changeData(layer, data) {
			if (layer === 1) {
				this.firstLayerData = data;
				sessionStorage.setItem('firstLayerData', (0, _stringify2.default)(data));
			} else if (layer === 2) {
				this.secondLayerData = data;
				sessionStorage.setItem('secondLayerData', (0, _stringify2.default)(data));
			} else if (layer === 3) {
				this.thirdLayerData = data;
				sessionStorage.setItem('thirdLayerData', (0, _stringify2.default)(data));
			}
		},

		changeVal: function changeVal(layer, val) {
			if (layer === 0) {
				rootLayer = val;
			} else if (layer === 1) {
				this.firstLayerVal = val;
			} else if (layer === 2) {
				this.secondLayerVal = val;
			} else if (layer === 3) {
				this.thirdLayerVal = val;
			}
		}
	},

	created: function created() {
		var fl = sessionStorage.getItem('firstLayerData');
		if (!!fl) {
			this.firstLayerData = JSON.parse(fl);
		}
		var sl = sessionStorage.getItem('secondLayerData');
		if (!!sl) {
			this.secondLayerData = JSON.parse(sl);
		}
		var tl = sessionStorage.getItem('thirdLayerData');
		if (!!tl) {
			this.thirdLayerData = JSON.parse(tl);
		}
	},

	mounted: function mounted() {}
};

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(11);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      sysCnName: _emEnum2.default.cnName,
      sysEnName: _emEnum2.default.enName,

      logining: false,
      ruleForm: {
        account: '',
        checkPass: '',
        autoLogin: false },
      rules: {
        account: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        checkPass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    };
  },

  methods: {
    handleReset: function handleReset() {
      this.$refs.ruleForm.resetFields();

      var ele = document.getElementById('focus-ele');
      if (!!ele) {
        ele.focus();
      }
    },
    handleSubmit: function handleSubmit(ev) {
      var _this = this;
      if (!!_this.$refs.ruleForm) {
        _this.$refs.ruleForm.validate(function (valid) {
          if (valid) {
            _this.logining = true;

            _util2.default.userData.clearSessionStorage();

            var loginParams = {
              username: _this.ruleForm.account,
              password: _this.ruleForm.checkPass
            };
            (0, _api.requestLogin)(loginParams, _this).then(function (res) {
              return res.data;
            }).then(function (data) {
              _this.logining = false;
              var _data = data,
                  msg = _data.msg,
                  code = _data.code;

              if (code !== "0") {
                _this.$message({
                  message: msg,
                  type: 'error'
                });
              } else {
                data = data.data;

                if (_emEnum2.default.allowLoginRole.indexOf(data.role) > -1) {
                  sessionStorage.setItem('user', (0, _stringify2.default)(data));
                  if (!!data.pwdOriginal && data.pwdOriginal == "1") {
                    _this.$router.push({ path: '/changePwd' });
                  } else {
                    if (data.role === 1) _this.$router.push({ path: '/user' });else if (data.role === 2) _this.$router.push({ path: '/order' });else if (data.role === 3) _this.$router.push({ path: '/order' });else if (data.role === 4) _this.$router.push({ path: '/logistics' });
                  }
                } else {
                  _this.$message({
                    message: '当前角色不允许登录，请联系管理员！',
                    type: 'warning'
                  });
                }
              }
            });
          } else {
            return false;
          }
        });
      }
    }
  },
  mounted: function mounted() {
    this.handleReset();
  },

  created: function created() {
    var _this = this;
    document.onkeydown = function (e) {
      var key = window.event.keyCode;
      if (key === 13) {
        _this.handleSubmit();
      }
    };
  }
};

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	props: ["pageNum", "pageSize", "totalNum"], data: function data() {
		return {
			pNum: 1,
			pSize: 10,
			pTotal: 0 };
	},

	methods: {
		handlePageSizeChange: function handlePageSizeChange(val) {
			this.pSize = val;

			this.$emit("handlePageSizeChange", val);
		},
		handlePageCurrentChange: function handlePageCurrentChange(val) {
			this.pNum = val;

			this.$emit("handlePageCurrentChange", val);
		},

		resetFilter: function resetFilter() {
			var Obj = _util2.default.editStore.GetEditObject();
			if (!!Obj && !!Obj.filter) {
				this.pSize = Obj.filter.pageSize;
				this.pNum = Obj.filter.pageNum;
				this.$emit("handlePageChange", this.pSize, this.pNum);
			}
		}
	},

	created: function created() {
		this.pSize = this.$parent.pageSize;
		this.pNum = this.$parent.pageNum;

		this.resetFilter();
	},
	mounted: function mounted() {}
};

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _cosJsSdkV = __webpack_require__(240);

var _cosJsSdkV2 = _interopRequireDefault(_cosJsSdkV);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Bucket = 'hx-new-shop-1256701284';
var Region = 'ap-shanghai';
var Thum = '?imageView2/1/w/100/h/100/q/85!';
var MaxMSize = 3;
var cos = new _cosJsSdkV2.default({
	SecretId: 'AKIDiDWaOw20A4i6PSqsTotiHchW5QWMjWBc',
	SecretKey: 'KOFtISQ8crqdFckgNq43qPimwqXzTlsl' });

exports.default = {
	props: ["imgUrl"], data: function data() {
		return {
			loading: false,

			addImg: __webpack_require__(114),
			fileUrl: __webpack_require__(114),
			btnText: '上传图片' };
	},

	methods: {
		uploadFile: function uploadFile(e) {
			var file = e.target.files[0];
			if (!file) return;

			var f = document.getElementById('file');
			f.value = '';

			var _this = this;

			var isLimit = file.size / 1024 / 1024 > MaxMSize;
			if (isLimit) {
				this.$message({
					message: '图片过大，请选择大小在 ' + MaxMSize + 'M 内的图片！',
					type: 'error'
				});
				return;
			}

			cos.putObject({
				Bucket: Bucket,
				Region: Region,
				Key: file.name,
				Body: file,
				onProgress: function onProgress(progressData, callback) {
					_this.loading = true;
					if (progressData.percent === 1) {
						_this.loading = false;

						cos.getObjectUrl({
							Bucket: Bucket,
							Region: Region,
							Key: file.name,
							Sign: false
						}, function (err, data) {
							_this.fileUrl = data.Url + Thum;

							_this.$emit("getFileUrl", data.Url, _this.fileUrl);
						});
					}
				}
			}, function (err, data) {
				_this.loading = false;
			});
		},

		changeFileUrl: function changeFileUrl(url, txt) {
			if (!url) {
				this.fileUrl = this.addImg;
			} else {
				this.fileUrl = url;
			}
			this.btnText = txt;
		}
	},

	created: function created() {},

	mounted: function mounted() {}
};

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _cosJsSdkV = __webpack_require__(240);

var _cosJsSdkV2 = _interopRequireDefault(_cosJsSdkV);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Bucket = 'hx-new-shop-1256701284';
var Region = 'ap-shanghai';

var MaxMSize = 20;
var cos = new _cosJsSdkV2.default({
	SecretId: 'AKIDiDWaOw20A4i6PSqsTotiHchW5QWMjWBc',
	SecretKey: 'KOFtISQ8crqdFckgNq43qPimwqXzTlsl' });

exports.default = {
	props: ["videoUrl"], data: function data() {
		return {
			loading: false,

			addImg: __webpack_require__(114),
			fileUrl: __webpack_require__(114),
			btnText: '上传视频' };
	},

	methods: {
		uploadFile: function uploadFile(e) {
			var file = e.target.files[0];
			if (!file) return;

			var _this = this;

			var isLimit = file.size / 1024 / 1024 > MaxMSize;
			if (isLimit) {
				this.$message({
					message: '视频过大，请选择大小在 ' + MaxMSize + 'M 内的视频！',
					type: 'error'
				});
				return;
			}

			cos.putObject({
				Bucket: Bucket,
				Region: Region,
				Key: file.name,
				Body: file,
				onProgress: function onProgress(progressData, callback) {
					_this.loading = true;
					if (progressData.percent === 1) {
						_this.loading = false;

						cos.getObjectUrl({
							Bucket: Bucket,
							Region: Region,
							Key: file.name,
							Sign: false
						}, function (err, data) {
							_this.fileUrl = data.Url;

							_this.$emit("getVideoUrl", _this.fileUrl);
						});
					}
				}
			}, function (err, data) {
				_this.loading = false;
			});
		},

		changeVideoUrl: function changeVideoUrl(url, txt) {
			if (!url) {
				this.fileUrl = this.addImg;
			} else {
				this.fileUrl = url;
			}
			this.btnText = txt;
		}
	},

	created: function created() {},

	mounted: function mounted() {}
};

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(11);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _sortablejs = __webpack_require__(68);

var _sortablejs2 = _interopRequireDefault(_sortablejs);

var _UploadFile = __webpack_require__(52);

var _UploadFile2 = _interopRequireDefault(_UploadFile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		UploadFile: _UploadFile2.default
	},
	data: function data() {
		return {
			sysCnName: _emEnum2.default.cnName,
			sysEnName: _emEnum2.default.enName,

			loginId: '',

			submitSortDisabled: true,
			idArr: [],
			sequenceArr: [],

			loading: false,
			containerHeight: 0,
			datas: [],


			areaDatas: [],
			roleOptions: _emEnum2.default.roleOptions,
			dialogTitle: '',
			dialogBtnVal: '',
			editDialogVisible: false,
			formData: {
				bid: '',
				highimage: '',
				thumimage: '',
				remark: '' },
			rules: {
				username: [{ required: true, message: '请输入用户账号', trigger: 'blur' }],
				role: [{ required: true, message: '请选择用户角色', trigger: 'change' }],
				areaid: [{ required: true, message: '请选择所属区域', trigger: 'change' }]
			}
		};
	},

	methods: {
		formatStatus: function formatStatus(row, column) {
			return row.status === 0 ? "已打开" : "已禁用";
		},

		formatCreatTime: function formatCreatTime(row, column) {
			if (!!row.creattime) {
				return _util2.default.formatDate.format(new Date(row.creattime.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:ss');
			} else return row.creattime;
		},

		getData: function getData() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {};
			(0, _api.getBannerList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data = data,
				    code = _data.code,
				    msg = _data.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;
					_this.datas = data;

					_this.idArr = [];
					_this.sequenceArr = [];
					_this.datas.forEach(function (item) {
						_this.sequenceArr.push(item.sequence);
					});
				}
			});
		},

		delData: function delData(index, row) {
			var _this = this;
			_this.$confirm('确认删除该广告？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					bid: row.id
				};
				(0, _api.deleteBanner)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		enableData: function enableData(index, row) {
			var _this = this;
			_this.$confirm('确认' + (row.status === 0 ? '禁用' : '启用') + '该广告？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					bid: row.id,
					status: row.status === 0 ? '1' : '0'
				};
				(0, _api.enableBanner)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		resetForm: function resetForm(formName) {
			this.$refs[formName].resetFields();
		},

		editData: function editData(index, row) {
			var formName = 'formData';

			this.editDialogVisible = true;

			if (!row) {
				this.dialogTitle = "添加";
				this.dialogBtnVal = "上传图片";
				if (this.$refs[formName]) this.$refs[formName].resetFields();
				this.formData.bid = '';
				this.formData.highimage = "";
				this.formData.thumimage = "";
				this.formData.remark = "";
			} else {
				this.dialogTitle = "编辑";
				this.dialogBtnVal = "重新上传";
				this.formData.bid = row.id;
				this.formData.highimage = row.highimage;
				this.formData.thumimage = row.thumimage;
				this.formData.remark = row.remark;
			}
		},

		openDialog: function openDialog() {
			this.$refs.UploadFile.changeFileUrl(this.formData.thumimage, this.dialogBtnVal);

			var ele = document.getElementById('focus-ele');
			if (!!ele) {
				ele.focus();
			}
		},

		closeDialog: function closeDialog() {
			this.editDialogVisible = false;
		},

		choseImage: function choseImage(file) {
			this.formData.thumimage = file.url;
		},

		handleSubmit: function handleSubmit(formName) {
			var _this2 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					var _this = _this2;
					_this.$confirm('确认' + _this.dialogTitle + '广告图？', '提示', {
						type: 'warning'
					}).then(function () {
						_this.loading = true;
						if (!_this.formData.bid) {
							var para = {
								highimage: _this.formData.highimage,
								thumimage: _this.formData.highimage,
								remark: _this.formData.remark
							};
							(0, _api.addBanner)(para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						} else {
							var _para = {
								bid: _this.formData.bid,
								highimage: _this.formData.highimage,
								thumimage: _this.formData.highimage,
								remark: _this.formData.remark
							};
							(0, _api.editBanner)(_para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						}
					}).catch(function (error) {
						if (error !== 'cancel') {
							_this.$message({
								message: error.message ? error.message : error,
								type: 'error'
							});
						}
					});
				} else {
					return false;
				}
			});
		},

		rowDrop: function rowDrop() {
			var tbody = document.querySelector('.el-table__body-wrapper tbody');
			var _this = this;
			_sortablejs2.default.create(tbody, {
				onEnd: function onEnd(_ref) {
					var newIndex = _ref.newIndex,
					    oldIndex = _ref.oldIndex;

					if (_this.sequenceArr.length > 1) {
						var currRow = _this.datas.splice(oldIndex, 1)[0];
						_this.datas.splice(newIndex, 0, currRow);
						_this.submitSortDisabled = false;

						for (var i = 0; i < _this.datas.length; i++) {
							_this.datas[i].sequence = _this.sequenceArr[i];
						}
					}
				}
			});
		},

		submitSort: function submitSort() {
			var _this = this;

			_this.idArr = _this.datas.map(function (item) {
				return item.id;
			});

			if (!!_this.idArr && !!_this.sequenceArr && _this.idArr.length === _this.sequenceArr.length) {
				_this.$confirm('确认提交排序结果？', '提示', {
					type: 'warning'
				}).then(function () {
					_this.loading = true;
					var para = {
						bid: _this.idArr,
						sequence: _this.sequenceArr
					};
					(0, _api.sortBanner)(para, _this).then(function (res) {
						return res.data;
					}).then(function (data) {
						_this.loading = false;
						var msg = data.msg,
						    code = data.code;

						if (code !== "0") {
							_this.$message({
								message: msg,
								type: 'error'
							});
						} else {
							_this.$message({
								message: msg,
								type: 'success'
							});
							_this.getData();
						}
					});
				}).catch(function (error) {
					if (error !== 'cancel') {
						_this.$message({
							message: error.message ? error.message : error,
							type: 'error'
						});
					}
				});
			} else {
				_this.$message({
					message: '广告排序数据出现问题，请刷新后重试！',
					type: 'error'
				});
			}
		},

		getFileUrl: function getFileUrl(high, thum) {
			this.formData.highimage = high;
			this.formData.thumimage = thum;
		}
	},

	created: function created() {
		this.loginId = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.uid, this);
	},

	mounted: function mounted() {
		var _this3 = this;

		var _this = this;
		_this.containerHeight = _this.$refs.bannercontainer.offsetHeight;

		_this.getData();

		document.body.ondrop = function (event) {
			event.preventDefault();
			event.stopPropagation();
		};

		_this.rowDrop();

		window.onresize = function () {
			return function () {
				if (!_this3.timer && !!_this.$refs.bannercontainer) {
					_this3.timer = true;
					_this.containerHeight = _this.$refs.bannercontainer.offsetHeight;
					var that = _this3;
					setTimeout(function () {
						that.timer = false;
					}, 100);
				}
			}();
		};
	}
};

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(11);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _Pagination = __webpack_require__(37);

var _Pagination2 = _interopRequireDefault(_Pagination);

var _UploadFile = __webpack_require__(52);

var _UploadFile2 = _interopRequireDefault(_UploadFile);

var _UploadFileVideo = __webpack_require__(671);

var _UploadFileVideo2 = _interopRequireDefault(_UploadFileVideo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		Pagination: _Pagination2.default,
		UploadFile: _UploadFile2.default,
		UploadFileVideo: _UploadFileVideo2.default
	},
	data: function data() {
		return {
			sysCnName: _emEnum2.default.cnName,
			sysEnName: _emEnum2.default.enName,

			loginId: '',

			loading: false,
			containerHeight: 0,
			datas: [],

			pageSize: 100,
			pageNum: 1,
			totalNum: 0,

			dialogTitle: '',
			dialogVideoBtnVal: '',
			dialogBtnVal: '',
			editDialogVisible: false,
			formData: {
				vid: '',
				name: '',
				url: '',
				highimage: '',
				thumimage: '',
				remark: '' },
			rules: {
				name: [{ required: true, message: '请输入视频名称', trigger: 'blur' }]
			},

			videoDialogTitle: '',
			videoDialogVisible: false,
			videoUrl: '',
			videoRemark: '' };
	},

	methods: {
		formatStatus: function formatStatus(row, column) {
			return row.status === "0" ? "启用" : row.status === "1" ? "禁用" : "";
		},

		getData: function getData() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {
				pageNum: _this.pageNum,
				pageSize: _this.pageSize
			};
			(0, _api.getVideoList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data = data,
				    code = _data.code,
				    msg = _data.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					var _data$data = data.data,
					    pageSize = _data$data.pageSize,
					    pageNum = _data$data.pageNum,
					    totalNum = _data$data.totalNum;

					data = data.data.list;
					_this.datas = data;

					_this.pageSize = pageSize;
					_this.pageNum = pageNum;
					_this.totalNum = totalNum;
				}
			});
		},

		delData: function delData(index, row) {
			var _this = this;
			_this.$confirm('确认删除该视频？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					vid: row.id
				};
				(0, _api.deleteVideo)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		enableData: function enableData(index, row) {
			var _this = this;
			_this.$confirm('确认' + (row.status === "0" ? '禁用' : '启用') + '该视频？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					vid: row.id,
					status: row.status === "0" ? '1' : '0'
				};
				(0, _api.enableVideo)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		resetForm: function resetForm(formName) {
			this.$refs[formName].resetFields();
		},

		editData: function editData(index, row) {
			var formName = 'formData';

			this.editDialogVisible = true;

			if (!row) {
				this.dialogTitle = "添加";
				this.dialogVideoBtnVal = "上传视频";
				this.dialogBtnVal = "上传图片";
				if (this.$refs[formName]) this.$refs[formName].resetFields();
				this.formData.vid = "";
				this.formData.name = "";
				this.formData.url = "";
				this.formData.highimage = "";
				this.formData.thumimage = "";
				this.formData.remark = "";
			} else {
				this.dialogTitle = "编辑";
				this.dialogVideoBtnVal = "重新上传";
				this.dialogBtnVal = "重新上传";
				this.formData.vid = row.id;
				this.formData.name = row.name;
				this.formData.url = row.url;
				this.formData.highimage = row.highimage;
				this.formData.thumimage = row.thumimage;
				this.formData.remark = row.remark;
			}
		},

		cellClick: function cellClick(row, column, cell, event) {
			if (column.property === 'url' && !!row.url) {
				this.videoDialogTitle = row.name;
				this.videoUrl = row.url;
				this.videoRemark = row.remark;

				this.videoDialogVisible = true;
			}
		},

		handleClose: function handleClose(done) {
			var videoSec = document.getElementById("videoSec");

			if (!videoSec.paused) {
				videoSec.pause();
			}
			done();
		},

		closeVideoDialog: function closeVideoDialog() {
			this.videoDialogVisible = false;
		},

		openDialog: function openDialog() {
			this.$refs.UploadFileVideo.changeVideoUrl(this.formData.url, this.dialogVideoBtnVal);

			this.$refs.UploadFile.changeFileUrl(this.formData.thumimage, this.dialogBtnVal);

			var ele = document.getElementById('focus-ele');
			if (!!ele) {
				ele.focus();
			}
		},

		closeDialog: function closeDialog() {
			this.editDialogVisible = false;
		},

		handleSubmit: function handleSubmit(formName) {
			var _this2 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					var _this = _this2;
					_this.$confirm('确认' + _this.dialogTitle + '视频？', '提示', {
						type: 'warning'
					}).then(function () {
						_this.loading = true;
						var para = {
							name: _this.formData.name,
							url: _this.formData.url,
							highimage: _this.formData.highimage,
							thumimage: _this.formData.thumimage,
							remark: _this.formData.remark
						};
						if (!!_this.formData.vid) para["vid"] = _this.formData.vid;

						(0, _api.editVideo)(para, _this).then(function (res) {
							return res.data;
						}).then(function (data) {
							_this.loading = false;
							var msg = data.msg,
							    code = data.code;

							if (code !== "0") {
								_this.$message({
									message: msg,
									type: 'error'
								});
							} else {
								_this.$message({
									message: msg,
									type: 'success'
								});
								_this.getData();
							}
						});
					}).catch(function (error) {
						if (error !== 'cancel') {
							_this.$message({
								message: error.message ? error.message : error,
								type: 'error'
							});
						}
					});
				} else {
					return false;
				}
			});
		},

		exportExcel: function exportExcel() {
			var outTable = document.querySelector("#out-table");
			if (!!outTable) {
				var fileName = this.sysCnName + "_" + _util2.default.formatDate.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "_" + this.$root.$route.name;

				_util2.default.exportExcel(fileName, outTable);
			} else {
				this.$message({
					message: "未找到需要导出数据的表格",
					type: 'warning'
				});
			}
		},

		getVideoUrl: function getVideoUrl(url) {
			this.formData.url = url;
		},

		getFileUrl: function getFileUrl(high, thum) {
			this.formData.highimage = high;
			this.formData.thumimage = thum;
		},
		handlePageSizeChange: function handlePageSizeChange(val) {
			this.pageSize = val;
			this.getData();
		},
		handlePageCurrentChange: function handlePageCurrentChange(val) {
			this.pageNum = val;
			this.getData();
		}
	},

	created: function created() {
		this.loginId = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.uid, this);
	},

	mounted: function mounted() {
		var _this3 = this;

		var _this = this;
		_this.containerHeight = _this.$refs.combinationcontainer.offsetHeight;

		_this.getData();

		window.onresize = function () {
			return function () {
				if (!_this3.timer && !!_this.$refs.combinationcontainer) {
					_this3.timer = true;
					_this.containerHeight = _this.$refs.combinationcontainer.offsetHeight;
					var that = _this3;
					setTimeout(function () {
						that.timer = false;
					}, 100);
				}
			}();
		};
	}
};

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _api = __webpack_require__(11);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _Pagination = __webpack_require__(37);

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		Pagination: _Pagination2.default
	},
	data: function data() {
		var _this2 = this;

		return {
			sysCnName: _emEnum2.default.cnName,
			sysEnName: _emEnum2.default.enName,
			pageName: 'client',

			role: '',
			loginId: '',
			loginAreaid: '',

			loading: false,
			containerHeight: 0,
			datas: [],

			pageSize: 100,
			pageNum: 1,
			totalNum: 0,

			allAreaDatas: [],
			areaDatas: [],
			agencyDatas: [],
			agencyRoleOptions: _emEnum2.default.agencyRoleOptions,
			statusOptions: _emEnum2.default.statusOptions,
			statusKey: '',

			startTime: '',
			endTime: '',
			orderStartStamp: '',
			orderEndStamp: '',
			startPickerOptions: {
				disabledDate: function disabledDate(time) {
					if (!!_this2.endTime) {
						return time.getTime() > new Date(_this2.endTime);
					}
					return false;
				}
			},
			endPickerOptions: {
				disabledDate: function disabledDate(time) {
					if (!!_this2.startTime) {
						return time.getTime() < new Date(_this2.startTime);
					}
					return false;
				}
			},

			dialogTitle: '',
			editDialogVisible: false,
			codeDisabled: true,

			agencyShow: true,
			pagencyShow: true,
			cagencyShow: true,
			tagencyShow: true,

			sortAreaId: '',
			vagueContent: '',

			formData: {
				cid: '',
				code: '',
				reallyname: '',
				areaid: '',
				aagencyid: '',
				agencyrole: '',
				aagencyname: '',
				pagencyname: '',
				cagencyname: '',
				tagencyname: '',
				linkphone: '',
				region: {
					province: '',
					city: '',
					district: '' },
				address: '' },
			rules: {
				code: [{ required: true, message: '请输入客户编码', trigger: 'blur' }],
				reallyname: [{ required: true, message: '请输入客户名称', trigger: 'blur' }],
				areaid: [{ required: true, message: '请选择所属区域', trigger: 'change' }],

				aagencyid: [{ required: true, message: '请选择培训公司', trigger: 'blur,change' }],
				pagencyname: [{ required: true, message: '请输入销售公司', trigger: 'blur' }],
				cagencyname: [{ required: true, message: '请输入代理1', trigger: 'blur' }],
				tagencyname: [{ required: true, message: '请输入代理2', trigger: 'blur' }],
				linkphone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }]
			},
			fixedPos: 'right',
			colDialogVisible: false,
			colDatas: [{ key: 'code', label: '客户编码' }, { key: 'reallyname', label: '客户姓名' }, { key: 'areaname', label: '所属区域' }, { key: 'aagencyname', label: '培训公司' }, { key: 'pagencyname', label: '销售公司' }, { key: 'cagencyname', label: '代理1' }, { key: 'tagencyname', label: '代理2' }, { key: 'province', label: '省' }, { key: 'city', label: '市' }, { key: 'district', label: '县（区）' }, { key: 'address', label: '详细地址' }, { key: 'linkphone', label: '联系电话' }, { key: 'agencyrole', label: '代理级别' }, { key: 'status', label: '状态' }, { key: 'creattime', label: '注册时间' }],
			colUnShowKeys: [] };
	},

	methods: {
		formatStatus: function formatStatus(row, column) {
			return row.status === 0 ? "启用" : row.status === 1 ? "禁用" : "待审核";
		},

		formatAgencyRole: function formatAgencyRole(row, column) {
			var roleOp = _emEnum2.default.agencyRoleOptions.find(function (item) {
				return item.key === row.agencyrole;
			});
			if (!roleOp) return '';else return roleOp.value;
		},

		formatCreatTime: function formatCreatTime(row, column) {
			if (isNaN(row.creattime) && !isNaN(Date.parse(row.creattime))) {
				return _util2.default.formatDate.format(new Date(row.creattime.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:ss');
			} else return row.creattime;
		},

		createTimeChange: function createTimeChange() {
			var _this = this;
			_this.orderStartStamp = '';
			_this.orderEndStamp = '';
			if (!!_this.startTime && !!_this.endTime) {
				_this.startTime = _util2.default.formatDate.format(new Date(_this.startTime), 'yyyy-MM-dd') + ' 00:00:00';
				_this.endTime = _util2.default.formatDate.format(new Date(_this.endTime), 'yyyy-MM-dd') + ' 23:59:59';
				_this.orderStartStamp = new Date(_this.startTime).getTime();
				_this.orderEndStamp = new Date(_this.endTime).getTime();
			}

			_this.areaFilter();
		},

		searchList: function searchList() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {
				vague: _this.vagueContent,
				pageNum: _this.pageNum,
				pageSize: _this.pageSize
			};

			if (!!_this.sortAreaId) para['areaid'] = _this.sortAreaId;

			if (!!_this.orderStartStamp && !!_this.orderEndStamp) {
				para['starTime'] = _this.orderStartStamp;
				para['endTime'] = _this.orderEndStamp;
			}

			if (_this.statusKey !== '') para['status'] = _this.statusKey;

			(0, _api.clientVague)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data = data,
				    code = _data.code,
				    msg = _data.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					var _data$data = data.data,
					    pageSize = _data$data.pageSize,
					    pageNum = _data$data.pageNum,
					    totalNum = _data$data.totalNum;

					data = data.data.list;
					_this.datas = data;

					_this.pageSize = pageSize;
					_this.pageNum = pageNum;
					_this.totalNum = totalNum;
				}
			});
		},

		areaFilter: function areaFilter() {
			var _this = this;
			if (!!_this.vagueContent) {
				_this.searchList();
			} else {
				_this.getData();
			}
		},

		downloadTemplate: function downloadTemplate() {
			window.open(_emEnum2.default.url.clientsTemplateURL);
		},

		getData: function getData() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {
				pageNum: _this.pageNum,
				pageSize: _this.pageSize
			};

			if (!!_this.sortAreaId) para['areaid'] = _this.sortAreaId;

			if (!!_this.orderStartStamp && !!_this.orderEndStamp) {
				para['starTime'] = _this.orderStartStamp;
				para['endTime'] = _this.orderEndStamp;
			}

			if (_this.statusKey !== '') para['status'] = _this.statusKey;

			(0, _api.getClientList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data2 = data,
				    code = _data2.code,
				    msg = _data2.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					var _data$data2 = data.data,
					    pageSize = _data$data2.pageSize,
					    pageNum = _data$data2.pageNum,
					    totalNum = _data$data2.totalNum;

					data = data.data.list;
					_this.datas = data;

					_this.pageSize = pageSize;
					_this.pageNum = pageNum;
					_this.totalNum = totalNum;
				}
			});
		},

		delData: function delData(index, row) {
			var _this = this;
			_this.$confirm('确认删除该客户？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					cid: row.id
				};
				(0, _api.deleteClient)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		enableData: function enableData(index, row) {
			var _this = this;
			_this.$confirm('确认' + (row.status === 1 || row.status === 2 ? '启用' : '禁用') + '该客户？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					cid: row.id,
					status: row.status === 1 || row.status === 2 ? '0' : '1'
				};
				(0, _api.enableClient)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		resetForm: function resetForm(formName) {
			this.$refs[formName].resetFields();
		},

		editData: function editData(index, row) {
			var formName = 'formData';

			this.editDialogVisible = true;

			if (!row) {
				this.dialogTitle = "添加";
				if (this.$refs[formName]) this.$refs[formName].resetFields();
				this.formData.cid = "";
				this.formData.code = "";
				this.formData.reallyname = "";

				if (!!this.areaDatas && this.areaDatas.length > 0) {
					this.formData.areaid = this.areaDatas[0].areaId;
				}

				this.formData.agencyrole = "";
				if (!!this.agencyDatas && this.agencyDatas.length > 0) {
					this.formData.aagencyid = this.agencyDatas[0].aagencyid;
				}
				this.formData.pagencyname = "";
				this.formData.cagencyname = "";
				this.formData.tagencyname = "";
				this.formData.linkphone = "";
				this.formData.region.province = "";
				this.formData.region.city = "";
				this.formData.region.district = "";
				this.formData.address = "";
			} else {
				this.dialogTitle = "编辑";
				this.formData.cid = row.id;
				this.formData.code = row.code;
				this.formData.reallyname = row.reallyname;

				var areaOp = this.areaDatas.find(function (item) {
					return item.areaId === row.areaid;
				});
				if (!areaOp) {
					this.formData.areaid = this.areaDatas[0].areaId;
				} else {
					this.formData.areaid = row.areaid;
				}

				this.formData.agencyrole = row.agencyrole;

				var agencyOp = this.agencyDatas.find(function (item) {
					return item.aagencyid === row.aagencyid + '';
				});
				if (!agencyOp) {
					this.formData.aagencyid = this.areaDatas[0].aagencyid;
				} else {
					this.formData.aagencyid = row.aagencyid + '';
				}
				this.formData.aagencyname = row.aagencyname;
				this.formData.pagencyname = row.pagencyname;
				this.formData.cagencyname = row.cagencyname;
				this.formData.tagencyname = row.tagencyname;
				this.formData.linkphone = row.linkphone;
				this.formData.region.province = row.province;
				this.formData.region.city = row.city;
				this.formData.region.district = row.district;
				this.formData.address = row.address;

				if (this.$refs[formName]) this.$refs[formName].validate();
			}

			this.roleChange();
		},

		openDialog: function openDialog() {
			var ele = document.getElementById('focus-ele');
			if (!!ele) {
				ele.focus();
			}
		},

		closeDialog: function closeDialog() {
			this.editDialogVisible = false;
		},

		handleSubmit: function handleSubmit(formName) {
			var _this3 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					var _this = _this3;
					_this.$confirm('确认' + _this.dialogTitle + '客户？', '提示', {
						type: 'warning'
					}).then(function () {
						_this.loading = true;
						if (!_this.formData.cid) {
							var para = {
								reallyname: _this.formData.reallyname,
								linkphone: _this.formData.linkphone,
								address: _this.formData.address,
								areaid: _this.formData.areaid,
								aagencyid: _this.formData.agencyrole === 1 ? '' : _this.formData.aagencyid,
								agencyrole: _this.formData.agencyrole,
								pagencyname: _this.formData.agencyrole === 2 ? _this.formData.reallyname : _this.formData.pagencyname,
								cagencyname: _this.formData.agencyrole === 3 ? _this.formData.reallyname : _this.formData.cagencyname,
								tagencyname: _this.formData.agencyrole === 4 ? _this.formData.reallyname : _this.formData.tagencyname,
								province: _this.formData.region.province,
								city: _this.formData.region.city,
								district: _this.formData.region.district };
							(0, _api.addClient)(para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						} else {
							var _para = {
								cid: _this.formData.cid,
								reallyname: _this.formData.reallyname,
								linkphone: _this.formData.linkphone,
								address: _this.formData.address,
								areaid: _this.formData.areaid,
								aagencyid: _this.formData.agencyrole === 1 ? _this.formData.cid : _this.formData.aagencyid,
								agencyrole: _this.formData.agencyrole,
								pagencyname: _this.formData.agencyrole === 2 ? _this.formData.reallyname : _this.formData.pagencyname,
								cagencyname: _this.formData.agencyrole === 3 ? _this.formData.reallyname : _this.formData.cagencyname,
								tagencyname: _this.formData.agencyrole === 4 ? _this.formData.reallyname : _this.formData.tagencyname,
								province: _this.formData.region.province,
								city: _this.formData.region.city,
								district: _this.formData.region.district };
							(0, _api.editClient)(_para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						}
					}).catch(function (error) {
						if (error !== 'cancel') {
							_this.$message({
								message: error.message ? error.message : error,
								type: 'error'
							});
						}
					});
				} else {
					return false;
				}
			});
		},

		importExcel: function importExcel(e) {
			var file = e.target.files[0];

			if (!file) {
				this.$message({
					message: '请选择导入的文件！',
					type: 'warning'
				});
				return;
			}

			var types = file.name.split('.')[1];
			var fileType = ['xlsx', 'xls', 'csv'].some(function (item) {
				return item === types;
			});
			if (!fileType) {
				this.$message({
					message: '格式错误，请重新选择！',
					type: 'warning'
				});
				return;
			} else {
				var _this = this;

				var xlsxJson = void 0;

				var dataArray = [];
				_util2.default.file2Xce(file).then(function (tabJson) {
					var f = document.getElementById('file');
					f.value = '';

					if (tabJson && tabJson.length > 0) {
						xlsxJson = tabJson;

						if (!!xlsxJson && xlsxJson.length > 0) {
							var sheetItem = xlsxJson[0];
							if (!!sheetItem && !!sheetItem.sheet && sheetItem.sheet.length > 0) {
								sheetItem.sheet.forEach(function (item) {
									var clientData = {};
									var i = 0;
									(0, _keys2.default)(item).forEach(function (col) {
										if (i === 1) clientData['reallyname'] = item[col];else if (i === 2) clientData['areaid'] = item[col];else if (i === 3) clientData['agencyrole'] = item[col];else if (i === 4) clientData['aagencyid'] = item[col];else if (i === 5) clientData['pagencyname'] = item[col];else if (i === 6) clientData['cagencyname'] = item[col];else if (i === 7) clientData['tagencyname'] = item[col];else if (i === 8) clientData['linkphone'] = item[col];else if (i === 9) clientData['province'] = item[col];else if (i === 10) clientData['city'] = item[col];else if (i === 11) clientData['district'] = item[col];else if (i === 12) clientData['address'] = item[col];

										i++;
									});
									dataArray.push(clientData);
								});
							}

							if (!!dataArray && dataArray.length > 0) {
								_this.loading = true;
								var para = {
									list: dataArray
								};
								(0, _api.batchAddClient)(para, _this).then(function (res) {
									return res.data;
								}).then(function (data) {
									_this.loading = false;
									var code = data.code,
									    msg = data.msg;

									if (code !== "0") {
										_this.$message({
											message: msg,
											type: 'error'
										});
									} else {
										_this.getData();
									}
								});
							} else {
								_this.$message({
									message: '未读取到有效数据，请确认数据格式后重新导入！',
									type: 'warning'
								});
							}
						}
					} else {
						_this.$message({
							message: '导入文件的数据为空！',
							type: 'warning'
						});
					}
				});
			}
		},

		exportExcel: function exportExcel() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {
				pageNum: 1,
				pageSize: _this.totalNum
			};

			if (!!_this.sortAreaId) para['areaid'] = _this.sortAreaId;

			if (!!_this.orderStartStamp && !!_this.orderEndStamp) {
				para['starTime'] = _this.orderStartStamp;
				para['endTime'] = _this.orderEndStamp;
			}

			if (_this.statusKey !== '') para['status'] = _this.statusKey;

			if (!!_this.vagueContent) {
				para['vague'] = _this.vagueContent;
				(0, _api.clientVague)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var _data3 = data,
					    code = _data3.code,
					    msg = _data3.msg;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						data = data.data.list;
						_this.doExport(data);
					}
				});
			} else {
				(0, _api.getClientList)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var _data4 = data,
					    code = _data4.code,
					    msg = _data4.msg;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						data = data.data.list;
						_this.doExport(data);
					}
				});
			}
		},

		doExport: function doExport(tabData) {
			var _this = this;

			if (!!tabData && tabData.length > 0) {
				var i = 1;
				tabData.forEach(function (item) {
					item.id = i;
					item.agencyrole = _this.formatAgencyRole(item);
					item.status = _this.formatStatus(item);
					item.creattime = _this.formatCreatTime(item);
					i++;
				});

				var fileName = _this.sysCnName + "_" + _util2.default.formatDate.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "_" + _this.$root.$route.name;

				var tHeader = ['序号', '客户编码', '客户姓名', '所属团队', '培训公司', '销售公司', '代理1', '代理2', '省', '市', '县（区）', '详细地址', '联系电话', '代理级别', '状态', '注册时间'];
				var filterVal = ['id', 'code', 'reallyname', 'areaname', 'aagencyname', 'pagencyname', 'cagencyname', 'tagencyname', 'province', 'city', 'district', 'address', 'linkphone', 'agencyrole', 'status', 'creattime'];
				_util2.default.exportJsonToExcel(fileName, (0, _stringify2.default)(tabData), tHeader, filterVal);
			} else {
				this.$message({
					message: "没有需要导出的数据",
					type: 'warning'
				});
			}
		},

		editCol: function editCol() {
			this.colDialogVisible = true;
		},

		closeColSet: function closeColSet() {
			this.fixedPos = "none";

			_util2.default.editStore.SetUnShowCols(this.pageName, this.colUnShowKeys);
			this.fixedPos = "right";
		},

		roleChange: function roleChange() {
			this.formData.aagencyid = this.formData.agencyrole > 1 ? this.formData.aagencyid : '';
			this.formData.pagencyname = this.formData.agencyrole > 2 ? this.formData.pagencyname : '';
			this.formData.cagencyname = this.formData.agencyrole > 3 ? this.formData.cagencyname : '';
			this.formData.tagencyname = this.formData.agencyrole > 4 ? this.formData.tagencyname : '';
			this.agencyShow = this.formData.agencyrole > 1;
			this.pagencyShow = this.formData.agencyrole > 2;
			this.cagencyShow = this.formData.agencyrole > 3;
			this.tagencyShow = this.formData.agencyrole > 4;
			this.rules.aagencyid[0].required = this.formData.agencyrole > 1;
			this.rules.pagencyname[0].required = this.formData.agencyrole > 2;
			this.rules.cagencyname[0].required = this.formData.agencyrole > 3;
			this.rules.tagencyname[0].required = this.formData.agencyrole > 4;
		},

		regionChange: function regionChange(val) {
			this.formData.region.province = val.province;
			this.formData.region.city = val.city;
			this.formData.region.district = val.district;
		},

		getAllAreas: function getAllAreas() {
			var _this = this;
			_this.loading = true;
			var para = {};

			(0, _api.areabyroleList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				var code = data.code,
				    msg = data.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					var areaData = data.data.list2;
					var agencyData = data.data.list;

					_this.areaDatas = areaData.filter(function (item) {
						return item.status === 0;
					});

					if (!!_this.loginAreaid) {
						var areas = _this.loginAreaid.split(',');
						_this.areaDatas.forEach(function (item) {
							areas.forEach(function (a) {
								if (a + '' === item.areaId + '') {
									_this.allAreaDatas.push({ id: item.areaId, areaname: item.areaName });
								}
							});
						});
						if (!!_this.allAreaDatas && _this.allAreaDatas.length > 0) {
							_this.sortAreaId = _this.allAreaDatas[0].id;
						}
					} else {
						_this.allAreaDatas.push({ id: '', areaname: '全部' });
						_this.areaDatas.forEach(function (item) {
							_this.allAreaDatas.push({ id: item.areaId, areaname: item.areaName });
						});
					}

					_this.agencyDatas = agencyData;
					_this.loading = false;

					_this.getData();
				}
			});
		},
		handlePageSizeChange: function handlePageSizeChange(val) {
			this.pageSize = val;
			this.getData();
		},
		handlePageCurrentChange: function handlePageCurrentChange(val) {
			this.pageNum = val;
			this.getData();
		}
	},

	created: function created() {
		this.role = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.role, this);

		this.loginId = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.uid, this);

		this.loginAreaid = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.areaid, this);

		var unShowCols = _util2.default.editStore.GetUnShowCols(this.pageName);
		if (!!unShowCols && unShowCols !== 'none') {
			this.colUnShowKeys = unShowCols;
		}
	},

	mounted: function mounted() {
		var _this4 = this;

		var _this = this;
		_this.containerHeight = _this.$refs.clientcontainer.offsetHeight;

		var query = _this.$route.query;
		if (!!query && !!query.id) {
			_this.sortAreaId = parseInt(query.id);
		}

		this.getAllAreas();

		window.onresize = function () {
			return function () {
				if (!_this4.timer && !!_this.$refs.clientcontainer) {
					_this4.timer = true;
					_this.containerHeight = _this.$refs.clientcontainer.offsetHeight;
					var that = _this4;
					setTimeout(function () {
						that.timer = false;
					}, 100);
				}
			}();
		};
	}
};

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(11);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _Pagination = __webpack_require__(37);

var _Pagination2 = _interopRequireDefault(_Pagination);

var _UploadFile = __webpack_require__(52);

var _UploadFile2 = _interopRequireDefault(_UploadFile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		Pagination: _Pagination2.default,
		UploadFile: _UploadFile2.default
	},
	data: function data() {
		return {
			sysCnName: _emEnum2.default.cnName,
			sysEnName: _emEnum2.default.enName,

			loginId: '',

			submitSortDisabled: true,

			pagePosition: '>',

			loading: false,
			containerHeight: 0,
			datas: [],

			pageSize: 100,
			pageNum: 1,
			totalNum: 0,

			dialogTitle: '',
			dialogBtnVal: '',
			editDialogVisible: false,
			formData: {
				cid: '',
				name: '',
				price: '',
				highimage: '',
				thumimage: '',
				remark: '' },
			rules: {
				name: [{ required: true, message: '请输入组合名称', trigger: 'blur' }],
				price: [{ required: true, message: '请输入组合价格', trigger: 'blur' }]
			}
		};
	},

	methods: {
		formatStatus: function formatStatus(row, column) {
			return row.status === "0" ? "启用" : row.status === "1" ? "禁用" : "";
		},

		cash: function cash() {
			this.formData.price = this.formData.price.replace(/[^\.\d]/g, '');
			this.formData.price = this.formData.price.replace(/^\./g, '');
			var temp = this.formData.price.replace(/\./g, '');
			if (this.formData.price.length >= temp.length + 2) {
				this.formData.price = this.formData.price.substr(0, this.formData.price.length - 1);
			}
		},

		getData: function getData() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {
				pageNum: _this.pageNum,
				pageSize: _this.pageSize
			};
			(0, _api.combinationList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data = data,
				    code = _data.code,
				    msg = _data.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					var _data$data = data.data,
					    pageSize = _data$data.pageSize,
					    pageNum = _data$data.pageNum,
					    totalNum = _data$data.totalNum;

					data = data.data.list;
					_this.datas = data;

					_this.pageSize = pageSize;
					_this.pageNum = pageNum;
					_this.totalNum = totalNum;
				}
			});
		},

		enableData: function enableData(index, row) {
			var _this = this;
			_this.$confirm('确认' + (row.status === "0" ? '禁用' : '启用') + '该组合？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					cid: row.id,
					status: row.status === "0" ? '1' : '0'
				};
				(0, _api.enableCombination)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		resetForm: function resetForm(formName) {
			this.$refs[formName].resetFields();
		},

		editData: function editData(index, row) {
			var formName = 'formData';

			this.editDialogVisible = true;

			if (!row) {
				this.dialogTitle = "添加";
				this.dialogBtnVal = "上传图片";
				if (this.$refs[formName]) this.$refs[formName].resetFields();
				this.formData.cid = "";
				this.formData.name = "";

				this.formData.highimage = "";
				this.formData.thumimage = "";
				this.formData.remark = "";
			} else {
				this.dialogTitle = "编辑";
				this.dialogBtnVal = "重新上传";
				this.formData.cid = row.id;
				this.formData.name = row.name;

				this.formData.highimage = row.highimage;
				this.formData.thumimage = row.thumimage;
				this.formData.remark = row.remark;
			}
		},

		openDialog: function openDialog() {
			this.$refs.UploadFile.changeFileUrl(this.formData.thumimage, this.dialogBtnVal);

			var ele = document.getElementById('focus-ele');
			if (!!ele) {
				ele.focus();
			}
		},

		closeDialog: function closeDialog() {
			this.editDialogVisible = false;
		},

		handleSubmit: function handleSubmit(formName) {
			var _this2 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					var _this = _this2;
					_this.$confirm('确认' + _this.dialogTitle + '组合？', '提示', {
						type: 'warning'
					}).then(function () {
						_this.loading = true;
						var para = {
							name: _this.formData.name,

							highimage: _this.formData.highimage,
							thumimage: _this.formData.thumimage,
							remark: _this.formData.remark
						};
						if (!!_this.formData.cid) para["cid"] = _this.formData.cid;

						(0, _api.addCombination)(para, _this).then(function (res) {
							return res.data;
						}).then(function (data) {
							_this.loading = false;
							var msg = data.msg,
							    code = data.code;

							if (code !== "0") {
								_this.$message({
									message: msg,
									type: 'error'
								});
							} else {
								_this.$message({
									message: msg,
									type: 'success'
								});
								_this.getData();
							}
						});
					}).catch(function (error) {
						if (error !== 'cancel') {
							_this.$message({
								message: error.message ? error.message : error,
								type: 'error'
							});
						}
					});
				} else {
					return false;
				}
			});
		},

		handleRowChange: function handleRowChange(row, event, column) {},

		pagePositionClick: function pagePositionClick() {
			return false;
		},

		nextStep: function nextStep(index, row) {
			this.pagePosition = row.name + '>';
			this.$router.push({ path: '/combinationInventory', query: { cid: row.id, pp: this.pagePosition, ps: this.pageSize, pn: this.pageNum } });
		},

		exportExcel: function exportExcel() {
			var outTable = document.querySelector("#out-table");
			if (!!outTable) {
				var fileName = this.sysCnName + "_" + _util2.default.formatDate.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "_" + this.$root.$route.name;

				_util2.default.exportExcel(fileName, outTable);
			} else {
				this.$message({
					message: "未找到需要导出数据的表格",
					type: 'warning'
				});
			}
		},

		choseImage: function choseImage(file) {
			this.formData.thumimage = file.url;
		},

		getFileUrl: function getFileUrl(high, thum) {
			this.formData.highimage = high;
			this.formData.thumimage = thum;
		},
		handlePageSizeChange: function handlePageSizeChange(val) {
			this.pageSize = val;
			this.getData();
		},
		handlePageCurrentChange: function handlePageCurrentChange(val) {
			this.pageNum = val;
			this.getData();
		}
	},

	created: function created() {
		this.loginId = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.uid, this);

		var query = this.$route.query;
		if (!!query && !!query.ps && !!query.pn) {
			this.pageSize = parseInt(query.ps);
			this.pageNum = parseInt(query.pn);
		}
	},

	mounted: function mounted() {
		var _this3 = this;

		var _this = this;
		_this.containerHeight = _this.$refs.combinationcontainer.offsetHeight;

		_this.getData();

		window.onresize = function () {
			return function () {
				if (!_this3.timer && !!_this.$refs.combinationcontainer) {
					_this3.timer = true;
					_this.containerHeight = _this.$refs.combinationcontainer.offsetHeight;
					var that = _this3;
					setTimeout(function () {
						that.timer = false;
					}, 100);
				}
			}();
		};
	}
};

/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(11);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _sortablejs = __webpack_require__(68);

var _sortablejs2 = _interopRequireDefault(_sortablejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			sysCnName: _emEnum2.default.cnName,
			sysEnName: _emEnum2.default.enName,

			loginId: '',

			cid: '',
			prePagePosition: '',
			cpageSize: 100,
			cPageNum: 1,
			pagePosition: '>',

			loading: false,
			containerHeight: 0,
			datas: [],
			allDatas: [],
			addFormData: {
				ciid: '',
				cid: '',
				spcode: '',
				spsize: '' },
			addRules: {
				spcode: [{ required: true, message: '请选择商品', trigger: 'change' }],
				spsize: [{ required: true, message: '请输入商品数量', trigger: 'blur' }]
			},
			vagueContentSp: '',
			spDatas: [],
			dialogTitle: '',
			editDialogVisible: false,
			formData: {
				ciid: '',
				cid: '',
				spcode: '',
				spsize: '' },
			rules: {
				spcode: [{ required: true, message: '请选择商品', trigger: 'change' }],
				spsize: [{ required: true, message: '请输入商品数量', trigger: 'blur' }]
			},

			vagueContent: '' };
	},

	methods: {
		number: function number() {
			this.addFormData.spsize = this.addFormData.spsize.replace(/[^\.\d]/g, '');
			this.addFormData.spsize = this.addFormData.spsize.replace('.', '');
			if (!!this.addFormData.spsize && parseInt(this.addFormData.spsize) === 0) {
				this.addFormData.spsize = 1;
			}
		},
		editnumber: function editnumber() {
			this.formData.spsize = this.formData.spsize.replace(/[^\.\d]/g, '');
			this.formData.spsize = this.formData.spsize.replace('.', '');
			if (!!this.formData.spsize && parseInt(this.formData.spsize) === 0) {
				this.formData.spsize = 1;
			}
		},

		getData: function getData() {
			var _this = this;
			if (!!_this.cid) {
				_this.loading = true;
				_this.closeDialog();
				var para = {
					cid: _this.cid
				};
				(0, _api.combinationinventoryList)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var _data = data,
					    code = _data.code,
					    msg = _data.msg;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						data = data.data.list;
						_this.allDatas = data;
						_this.datas = _this.allDatas;
					}
				});
			}
		},

		searchSpList: function searchSpList(query) {
			var _this = this;

			_this.vagueContentSp = query;
			_this.loading = true;
			var para = {
				vague: _this.vagueContentSp
			};
			(0, _api.inventoryVague)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data2 = data,
				    code = _data2.code,
				    msg = _data2.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;
					_this.spDatas = data.filter(function (item) {
						return item.status === 0;
					});
				}
			});
		},

		searchList: function searchList() {
			var _this = this;

			if (!!_this.vagueContent) {
				_this.datas = _this.allDatas.filter(function (item) {
					return item.spname.indexOf(_this.vagueContent) >= 0 || item.spcode.indexOf(_this.vagueContent) >= 0;
				});
			} else {
				_this.datas = _this.allDatas;
			}
		},

		enableData: function enableData(index, row) {
			var _this = this;
			_this.$confirm('确认' + (row.status === '0' ? '禁用' : '启用') + '该组合商品？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					ciid: row.id,
					status: row.status === '0' ? '1' : '0'
				};
				(0, _api.enablecombinationinventory)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		resetForm: function resetForm(formName) {
			this.$refs[formName].resetFields();
		},

		editData: function editData(index, row) {
			var formName = 'formData';

			this.editDialogVisible = true;

			if (!row) {
				this.dialogTitle = "添加";
				if (this.$refs[formName]) this.$refs[formName].resetFields();
				this.formData.ciid = "";
				this.formData.cid = "";
				this.formData.spcode = "";
			} else {
				this.dialogTitle = "编辑";
				this.formData.ciid = row.id;
				this.formData.cid = this.cid;
				this.formData.spcode = row.spcode;

				if (!!row.spcode && !this.spDatas.some(function (a) {
					return a.code === row.spcode;
				})) {
					this.spDatas.push({ code: row.spcode, name: row.spname });
				}
			}
		},

		openDialog: function openDialog() {
			var ele = document.getElementById('focus-ele');
			if (!!ele) {
				ele.focus();
			}
		},

		closeDialog: function closeDialog() {
			this.editDialogVisible = false;
		},

		handleAddSubmit: function handleAddSubmit(formName) {
			var _this2 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					var _this = _this2;
					_this.$confirm('确认添加组合商品？', '提示', {
						type: 'warning'
					}).then(function () {
						_this.loading = true;
						var para = {
							cid: _this.cid,
							spcode: _this.addFormData.spcode
						};
						(0, _api.addCombinationinventory)(para, _this).then(function (res) {
							return res.data;
						}).then(function (data) {
							_this.loading = false;
							var msg = data.msg,
							    code = data.code;

							if (code !== "0") {
								_this.$message({
									message: msg,
									type: 'error'
								});
							} else {
								_this.$message({
									message: msg,
									type: 'success'
								});

								_this.addFormData.ciid = '';
								_this.addFormData.spcode = '';
								_this.addFormData.spsize = '';

								_this.getData();
							}
						});
					}).catch(function (error) {
						if (error !== 'cancel') {
							_this.$message({
								message: error.message ? error.message : error,
								type: 'error'
							});
						}
					});
				} else {
					return false;
				}
			});
		},

		handleSubmit: function handleSubmit(formName) {
			var _this3 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					var _this = _this3;
					_this.$confirm('确认' + _this.dialogTitle + '组合商品？', '提示', {
						type: 'warning'
					}).then(function () {
						_this.loading = true;
						var para = {
							cid: _this.cid,
							spcode: _this.formData.spcode
						};
						if (!!_this.formData.ciid) para["ciid"] = _this.formData.ciid;

						(0, _api.addCombinationinventory)(para, _this).then(function (res) {
							return res.data;
						}).then(function (data) {
							_this.loading = false;
							var msg = data.msg,
							    code = data.code;

							if (code !== "0") {
								_this.$message({
									message: msg,
									type: 'error'
								});
							} else {
								_this.$message({
									message: msg,
									type: 'success'
								});
								_this.getData();
							}
						});
					}).catch(function (error) {
						if (error !== 'cancel') {
							_this.$message({
								message: error.message ? error.message : error,
								type: 'error'
							});
						}
					});
				} else {
					return false;
				}
			});
		},

		pagePositionClick: function pagePositionClick() {
			return false;
		},

		preStep: function preStep() {
			this.$router.push({ path: '/combination', query: { ps: this.cPageSize, pn: this.cPageNum } });
		},

		exportExcel: function exportExcel() {
			var outTable = document.querySelector("#out-table");
			if (!!outTable) {
				var fileName = this.sysCnName + "_" + _util2.default.formatDate.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "_" + this.$root.$route.name;

				_util2.default.exportExcel(fileName, outTable);
			} else {
				this.$message({
					message: "未找到需要导出数据的表格",
					type: 'warning'
				});
			}
		},

		clearInventory: function clearInventory(val) {
			if (val == 'sp') {
				this.addFormData.spcode = '';
			} else if (val == 'editsp') {
				this.formData.spcode = '';
			}
		}
	},

	created: function created() {
		this.loginId = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.uid, this);

		var query = this.$route.query;
		this.cid = query.cid;
		this.prePagePosition = query.pp;
		this.pagePosition = this.prePagePosition;
		this.cPageSize = query.ps;
		this.cPageNum = query.pn;
	},

	mounted: function mounted() {
		var _this4 = this;

		var _this = this;
		_this.containerHeight = _this.$refs.combinationInventorycontainer.offsetHeight;

		_this.getData();

		window.onresize = function () {
			return function () {
				if (!_this4.timer && !!_this.$refs.combinationInventorycontainer) {
					_this4.timer = true;
					_this.containerHeight = _this.$refs.combinationInventorycontainer.offsetHeight;
					var that = _this4;
					setTimeout(function () {
						that.timer = false;
					}, 100);
				}
			}();
		};
	}
};

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(11);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _Pagination = __webpack_require__(37);

var _Pagination2 = _interopRequireDefault(_Pagination);

var _UploadFile = __webpack_require__(52);

var _UploadFile2 = _interopRequireDefault(_UploadFile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		Pagination: _Pagination2.default,
		UploadFile: _UploadFile2.default
	},
	data: function data() {
		return {
			sysCnName: _emEnum2.default.cnName,
			sysEnName: _emEnum2.default.enName,

			loginId: '',

			loading: false,
			containerHeight: 0,
			datas: [],

			pageSize: 100,
			pageNum: 1,
			totalNum: 0,

			inventoryStatusOptions: _emEnum2.default.inventoryStatusOptions,
			allClassDatas: [],
			classDatas: [],
			dialogTitle: '',
			dialogBtnVal: '',
			editDialogVisible: false,
			codeDisabled: true,

			sortCode: '',
			inventoryStatus: '',
			oldVagueContent: '',
			vagueContent: '',

			formData: {
				id: '',
				name: '',
				code: '',
				classid: '',
				ccomunitname: '',
				retailprice: '',
				highimage: '',
				thumimage: '',
				remark: '' },
			rules: {
				username: [{ required: true, message: '请输入用户账号', trigger: 'blur' }],
				role: [{ required: true, message: '请选择用户角色', trigger: 'change' }],
				areaid: [{ required: true, message: '请选择所属区域', trigger: 'change' }]
			}
		};
	},

	methods: {
		formatRole: function formatRole(row, column) {
			var roleOp = _emEnum2.default.roleOptions.find(function (item) {
				return item.key === row.role;
			});
			if (!roleOp) return '';else return roleOp.value;
		},

		formatCreatTime: function formatCreatTime(row, column) {
			if (!!row.creattime) {
				return _util2.default.formatDate.format(new Date(row.creattime.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:ss');
			} else return row.creattime;
		},

		searchList: function searchList() {
			var _this = this;
			if (_this.oldVagueContent !== _this.vagueContent) {
				_this.oldVagueContent = _this.vagueContent;

				if (!!_this.vagueContent) {
					_this.loading = true;
					_this.closeDialog();
					var para = {
						vague: _this.vagueContent,
						pageNum: !!_this.pageNum ? _this.pageNum : 1,
						pageSize: !!_this.pageSize ? _this.pageSize : 100
					};

					if (!!_this.sortCode) para['code'] = _this.sortCode;

					if (_this.inventoryStatus !== '') para['status'] = _this.inventoryStatus;

					(0, _api.inventoryVague)(para, _this).then(function (res) {
						return res.data;
					}).then(function (data) {
						_this.loading = false;
						var _data = data,
						    code = _data.code,
						    msg = _data.msg;

						if (code !== "0") {
							_this.$message({
								message: msg,
								type: 'error'
							});
						} else {
							var _data$data = data.data,
							    pageSize = _data$data.pageSize,
							    pageNum = _data$data.pageNum,
							    totalNum = _data$data.totalNum;

							data = data.data.list;
							_this.datas = data;

							_this.pageSize = pageSize;
							_this.pageNum = pageNum;
							_this.totalNum = totalNum;
						}
					});
				} else {
					_this.getData();
				}
			}
		},

		classFilter: function classFilter() {
			var _this = this;
			if (!!_this.vagueContent) {
				_this.searchList();
			} else {
				_this.getData();
			}
		},

		getData: function getData() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {
				pageNum: !!_this.pageNum ? _this.pageNum : 1,
				pageSize: !!_this.pageSize ? _this.pageSize : 100
			};

			if (!!_this.sortCode) para['sortCode'] = _this.sortCode;

			if (_this.inventoryStatus !== '') para['status'] = _this.inventoryStatus;

			(0, _api.getInventoryList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data2 = data,
				    code = _data2.code,
				    msg = _data2.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					var _data$data2 = data.data,
					    pageSize = _data$data2.pageSize,
					    pageNum = _data$data2.pageNum,
					    totalNum = _data$data2.totalNum;

					data = data.data.list;
					_this.datas = data;

					_this.pageSize = pageSize;
					_this.pageNum = pageNum;
					_this.totalNum = totalNum;
				}
			});
		},

		enableData: function enableData(index, row) {
			var _this = this;
			_this.$confirm('确认' + (row.status === 0 ? '禁用' : '启用') + '该库存？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					code: row.code,
					status: row.status === 0 ? '1' : '0'
				};
				(0, _api.enableInventory)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		resetForm: function resetForm(formName) {
			this.$refs[formName].resetFields();
		},

		editData: function editData(index, row) {
			var formName = 'formData';

			this.editDialogVisible = true;

			if (!row) {
				this.dialogTitle = "添加";
				this.dialogBtnVal = "上传图片";
				if (this.$refs[formName]) this.$refs[formName].resetFields();
				this.formData.name = "";
				this.formData.code = "";

				this.formData.highimage = "";
				this.formData.thumimage = "";
				this.formData.remark = "";
			} else {
				this.dialogTitle = "编辑";
				this.dialogBtnVal = "重新上传";
				this.formData.id = row.id;
				this.formData.name = row.name;
				this.formData.code = row.code;

				this.formData.highimage = row.highimage;
				this.formData.thumimage = row.thumimage;
				this.formData.remark = row.remark;
			}
		},

		openDialog: function openDialog() {
			this.$refs.UploadFile.changeFileUrl(this.formData.thumimage, this.dialogBtnVal);

			var ele = document.getElementById('focus-ele');
			if (!!ele) {
				ele.focus();
			}
		},

		closeDialog: function closeDialog() {
			this.editDialogVisible = false;
		},

		handleSubmit: function handleSubmit(formName) {
			var _this2 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					var _this = _this2;
					_this.$confirm('确认' + _this.dialogTitle + '库存图片？', '提示', {
						type: 'warning'
					}).then(function () {
						_this.loading = true;
						if (!_this.formData.code) {
							var para = {
								inventorycode: _this.formData.code,
								highimage: _this.formData.highimage,
								thumimage: _this.formData.thumimage,
								remark: _this.formData.remark
							};
							(0, _api.addInventoryimage)(para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						} else {
							var _para = {
								inventorycode: _this.formData.code,
								highimage: _this.formData.highimage,
								thumimage: _this.formData.thumimage,
								remark: _this.formData.remark
							};
							(0, _api.editInventoryimage)(_para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						}
					}).catch(function (error) {
						if (error !== 'cancel') {
							_this.$message({
								message: error.message ? error.message : error,
								type: 'error'
							});
						}
					});
				} else {
					return false;
				}
			});
		},

		exportExcel: function exportExcel() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {
				pageNum: 1,
				pageSize: _this.totalNum
			};

			if (_this.inventoryStatus !== '') para['status'] = _this.inventoryStatus;

			if (!!_this.vagueContent) {
				para['vague'] = _this.vagueContent;

				if (!!_this.sortCode) para['code'] = _this.sortCode;
				(0, _api.inventoryVague)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var _data3 = data,
					    code = _data3.code,
					    msg = _data3.msg;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						data = data.data.list;
						_this.doExport(data);
					}
				});
			} else {
				if (!!_this.sortCode) para['sortCode'] = _this.sortCode;
				(0, _api.getInventoryList)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var _data4 = data,
					    code = _data4.code,
					    msg = _data4.msg;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						data = data.data.list;
						_this.doExport(data);
					}
				});
			}
		},

		doExport: function doExport(tabData) {
			if (!!tabData && tabData.length > 0) {
				var i = 1;
				tabData.forEach(function (item) {
					item.id = i;
					item.status = item.status === 0 ? '启用' : '禁用';
					item.refsaleprice = parseFloat(item.refsaleprice);
					i++;
				});

				var fileName = this.sysCnName + "_" + _util2.default.formatDate.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "_" + this.$root.$route.name;

				var tHeader = ['序号', '商品名称', '商品编号', '商品分类', '单位', '零售价', '状态', '备注'];
				var filterVal = ['id', 'name', 'code', 'sortCode', 'ccomunitname', 'refsaleprice', 'status', 'remark'];
				_util2.default.exportJsonToExcel(fileName, (0, _stringify2.default)(tabData), tHeader, filterVal);
			} else {
				this.$message({
					message: "没有需要导出的数据",
					type: 'warning'
				});
			}
		},

		syncCommodity: function syncCommodity() {
			var _this = this;
			_this.$confirm('确认同步商品？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {};
				(0, _api.updateInventory)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					var code = data.code,
					    msg = data.msg;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.loading = false;
						_this.$message({
							message: '同步商品成功！',
							type: 'info'
						});
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		getAllClass: function getAllClass() {
			var _this = this;
			_this.loading = true;
			var para = {};
			(0, _api.getInventoryClassList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				var _data5 = data,
				    code = _data5.code,
				    msg = _data5.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;
					_this.classDatas = data;
					_this.classDatas.forEach(function (item) {
						_this.allClassDatas.push({ code: item.code, name: item.name });
					});
					_this.loading = false;
				}
			});
		},

		getFileUrl: function getFileUrl(high, thum) {
			this.formData.highimage = high;
			this.formData.thumimage = thum;
		},
		handlePageSizeChange: function handlePageSizeChange(val) {
			this.pageSize = val;
			this.getData();
		},
		handlePageCurrentChange: function handlePageCurrentChange(val) {
			this.pageNum = val;
			this.getData();
		}
	},

	created: function created() {
		this.loginId = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.uid, this);

		this.getAllClass();
	},

	mounted: function mounted() {
		var _this3 = this;

		var _this = this;
		_this.containerHeight = _this.$refs.inventorycontainer.offsetHeight;

		var query = _this.$route.query;
		_this.sortCode = query.code;

		_this.getData();

		window.onresize = function () {
			return function () {
				if (!_this3.timer && !!_this.$refs.inventorycontainer) {
					_this3.timer = true;
					_this.containerHeight = _this.$refs.inventorycontainer.offsetHeight;
					var that = _this3;
					setTimeout(function () {
						that.timer = false;
					}, 100);
				}
			}();
		};
	}
};

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(11);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _Pagination = __webpack_require__(37);

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		Pagination: _Pagination2.default
	},
	data: function data() {
		return {
			sysCnName: _emEnum2.default.cnName,
			sysEnName: _emEnum2.default.enName,

			loading: false,
			containerHeight: 0,
			datas: [],

			pageSize: 100,
			pageNum: 1,
			totalNum: 0
		};
	},

	methods: {
		getData: function getData() {
			var _this = this;

			_this.loading = true;
			var para = {
				pageNum: _this.pageNum,
				pageSize: _this.pageSize
			};
			(0, _api.getInventoryClassList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data = data,
				    code = _data.code,
				    msg = _data.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					var _data$data = data.data,
					    pageSize = _data$data.pageSize,
					    pageNum = _data$data.pageNum,
					    totalNum = _data$data.totalNum;

					data = data.data.list;
					_this.datas = data;

					_this.pageSize = pageSize;
					_this.pageNum = pageNum;
					_this.totalNum = totalNum;
				}
			});
		},

		searchData: function searchData(index, row) {
			this.$router.push({ path: '/inventory', query: { code: row.code } });
		},

		exportExcel: function exportExcel() {
			var _this = this;

			_this.loading = true;
			var para = {
				pageNum: 1,
				pageSize: _this.totalNum
			};
			(0, _api.getInventoryClassList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data2 = data,
				    code = _data2.code,
				    msg = _data2.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;
					_this.doExport(data);
				}
			});
		},

		doExport: function doExport(tabData) {
			var _this = this;

			if (!!tabData && tabData.length > 0) {
				var i = 1;
				tabData.forEach(function (item) {
					item.id = i;
					i++;
				});

				var fileName = _this.sysCnName + "_" + _util2.default.formatDate.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "_" + _this.$root.$route.name;

				var tHeader = ['序号', '名称', '编号'];
				var filterVal = ['id', 'name', 'code'];
				_util2.default.exportJsonToExcel(fileName, (0, _stringify2.default)(tabData), tHeader, filterVal);
			} else {
				this.$message({
					message: "没有需要导出的数据",
					type: 'warning'
				});
			}
		},
		handlePageSizeChange: function handlePageSizeChange(val) {
			this.pageSize = val;
			this.getData();
		},
		handlePageCurrentChange: function handlePageCurrentChange(val) {
			this.pageNum = val;
			this.getData();
		}
	},

	mounted: function mounted() {
		var _this2 = this;

		var _this = this;
		_this.containerHeight = _this.$refs.inventoryclasscontainer.offsetHeight;

		_this.getData();

		window.onresize = function () {
			return function () {
				if (!_this2.timer && !!_this.$refs.inventoryclasscontainer) {
					_this2.timer = true;
					_this.containerHeight = _this.$refs.inventoryclasscontainer.offsetHeight;
					var that = _this2;
					setTimeout(function () {
						that.timer = false;
					}, 100);
				}
			}();
		};
	}
};

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _api = __webpack_require__(11);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _UploadFile = __webpack_require__(52);

var _UploadFile2 = _interopRequireDefault(_UploadFile);

var _Pagination = __webpack_require__(37);

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		UploadFile: _UploadFile2.default,
		Pagination: _Pagination2.default
	},
	data: function data() {
		return {
			sysCnName: _emEnum2.default.cnName,
			sysEnName: _emEnum2.default.enName,
			pageName: 'logistics',

			uid: '',

			loginId: '',
			loginRole: '',
			areaid: '',
			wxaccount: '',

			loading: false,
			containerHeight: 0,
			datas: [],

			pageSize: 100,
			pageNum: 1,
			totalNum: 0,

			allAreaDatas: [],
			vague: '',
			sortAreaId: '',

			dialogTitle: '',
			editDialogVisible: false,
			formData: {
				lid: '',
				ordercode: '',
				u8id: '',
				logisticsid: '',
				logisticsname: '',
				u8orderid: '' },
			rules: {
				ordercode: [{ required: true, message: '请输入B2B订单号', trigger: 'blur' }],
				u8id: [{ required: true, message: '请输入销售单号(U8系统的ID)', trigger: 'blur' }],
				logisticsid: [{ required: true, message: '请输入快递单号', trigger: 'blur' }],
				logisticsname: [{ required: true, message: '请输入物流公司', trigger: 'blur' }],
				u8orderid: [{ required: true, message: '请输入U8系统发货单号', trigger: 'blur' }]
			},

			logisticsDialogVisible: false,
			logisticsDatas: [],
			logisticsBillNo: '',
			logisticsStatu: '',

			consignment: {},

			multipleSelection: [] };
	},

	methods: {
		formatOrderStatus: function formatOrderStatus(row, column) {
			if (row.orderstatus === '0' || !row.orderstatus) return "待支付";else if (row.orderstatus === '1') return "已付款";else if (row.orderstatus === '2') return "已发货";else if (row.orderstatus === '3') return "已完成";else return "";
		},

		formatCreattime: function formatCreattime(row, column) {
			if (isNaN(row.creattime) && !isNaN(Date.parse(row.creattime))) {
				return _util2.default.formatDate.format(new Date(row.creattime.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:ss');
			} else return row.creattime;
		},

		formatUpdatetime: function formatUpdatetime(row, column) {
			if (isNaN(row.updatetime) && !isNaN(Date.parse(row.updatetime))) {
				return _util2.default.formatDate.format(new Date(row.updatetime.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:ss');
			} else return row.updatetime;
		},

		formatTitle: function formatTitle(date, time) {
			return _util2.default.formatDate.format(new Date(date), "yyyy-MM-dd") + ' ' + time;
		},

		downloadTemplate: function downloadTemplate() {
			window.open(_emEnum2.default.url.logisticsTemplateURL);
		},

		handleSelectionChange: function handleSelectionChange(val) {
			var _this = this;
			_this.multipleSelection = [];
			if (!!val && val.length > 0) {
				val.forEach(function (a) {
					_this.multipleSelection.push(a.id);
				});
			}
		},

		batchDel: function batchDel() {
			var _this = this;
			if (!!_this.multipleSelection && _this.multipleSelection.length > 0) {
				_this.$confirm('确认删除选中的物流？', '提示', {
					type: 'warning'
				}).then(function () {
					_this.loading = true;
					var para = {
						lid: _this.multipleSelection.join(',')
					};
					(0, _api.batchDelLogistics)(para, _this).then(function (res) {
						return res.data;
					}).then(function (data) {
						_this.loading = false;
						var msg = data.msg,
						    code = data.code;

						if (code !== "0") {
							_this.$message({
								message: msg,
								type: 'error'
							});
						} else {
							_this.$message({
								message: '物流删除成功',
								type: 'success'
							});
							_this.getData();
						}
					});
				}).catch(function (error) {
					if (error !== 'cancel') {
						_this.$message({
							message: error.message ? error.message : error,
							type: 'error'
						});
					}
				});
			} else {
				_this.$message({
					message: '请先选择要删除的物流！',
					type: 'warning'
				});
			}
		},

		getData: function getData() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {
				status: 0,
				pageNum: _this.pageNum,
				pageSize: _this.pageSize
			};

			if (!!_this.vague) para['vague'] = _this.vague;

			if (!!_this.sortAreaId) para['areaid'] = _this.sortAreaId;else if (_this.loginRole !== 1) {
				para['areaid'] = _this.areaid;
			}

			if (_this.loginRole === 2) {
				if (!_this.vague && !_this.sortAreaId) {
					if (!!_this.wxaccount) para['wxaccount'] = _this.wxaccount;
				}
			} else {
				if (!!_this.wxaccount) para['wxaccount'] = _this.wxaccount;
			}

			(0, _api.getLogisticsList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data = data,
				    code = _data.code,
				    msg = _data.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					var _data$data = data.data,
					    pageSize = _data$data.pageSize,
					    pageNum = _data$data.pageNum,
					    totalNum = _data$data.totalNum;

					data = data.data.list;
					_this.datas = data;

					_this.pageSize = pageSize;
					_this.pageNum = pageNum;
					_this.totalNum = totalNum;
				}
			});
		},

		delData: function delData(index, row) {
			var _this = this;
			_this.$confirm('确认删除该物流？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					lid: row.id,
					status: '1'
				};
				(0, _api.enableLogistics)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: '物流删除成功',
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		enableData: function enableData(index, row) {
			var _this = this;
			_this.$confirm('确认' + (row.status === '0' ? '禁用' : '启用') + '该物流？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					lid: row.id,
					status: row.status === "0" ? '1' : '0'
				};
				(0, _api.enableLogistics)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		resetForm: function resetForm(formName) {
			this.$refs[formName].resetFields();
		},

		editData: function editData(index, row) {
			var formName = 'formData';

			this.editDialogVisible = true;

			if (!row) {
				this.dialogTitle = "添加";
				this.formData.lid = "";
				this.formData.logisticsid = "";
				this.formData.ordercode = "";
				this.formData.u8id = "";
				this.formData.logisticsname = "";
				this.formData.u8orderid = "";
			} else {
				this.dialogTitle = "编辑";
				this.formData.lid = row.id;
				this.formData.logisticsid = row.logisticsid;
				this.formData.ordercode = row.ordercode;
				this.formData.u8id = row.u8id;
				this.formData.logisticsname = row.logisticsname;
				this.formData.u8orderid = row.u8orderid;

				if (this.$refs[formName]) this.$refs[formName].validate();
			}
		},

		openDialog: function openDialog() {
			var ele = document.getElementById('focus-ele');
			if (!!ele) {
				ele.focus();
			}
		},

		closeDialog: function closeDialog() {
			this.editDialogVisible = false;
		},

		handleSubmit: function handleSubmit(formName) {
			var _this2 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					var _this = _this2;
					_this.$confirm('确认' + _this.dialogTitle + '物流？', '提示', {
						type: 'warning'
					}).then(function () {
						_this.loading = true;
						var para = {
							logisticsid: _this.formData.logisticsid,
							ordercode: _this.formData.ordercode,
							u8id: _this.formData.u8id,
							logisticsname: _this.formData.logisticsname,
							u8orderid: _this.formData.u8orderid
						};
						if (!_this.formData.lid) {
							(0, _api.editLogistics)(para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						} else {
							para["lid"] = _this.formData.lid;
							(0, _api.editLogistics)(para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						}
					}).catch(function (error) {
						if (error !== 'cancel') {
							_this.$message({
								message: error.message ? error.message : error,
								type: 'error'
							});
						}
					});
				} else {
					return false;
				}
			});
		},

		importExcel: function importExcel(e) {
			var file = e.target.files[0];

			if (!file) {
				this.$message({
					message: '请选择导入的文件！',
					type: 'warning'
				});
				return;
			}

			var types = file.name.split('.')[1];
			var fileType = ['xlsx', 'xls', 'csv'].some(function (item) {
				return item === types;
			});
			if (!fileType) {
				this.$message({
					message: '格式错误，请重新选择！',
					type: 'warning'
				});
				return;
			} else {
				var _this = this;

				var xlsxJson = void 0;

				var dataArray = [];
				var nullArray = [];
				_util2.default.file2Xce(file).then(function (tabJson) {
					var f = document.getElementById('file');
					f.value = '';

					if (tabJson && tabJson.length > 0) {
						xlsxJson = tabJson;

						if (!!xlsxJson && xlsxJson.length > 0) {
							xlsxJson.forEach(function (sheetItem) {
								if (!!sheetItem && !!sheetItem.sheet && sheetItem.sheet.length > 0) {
									sheetItem.sheet.forEach(function (item) {
										var logisticsData = {};
										var i = 0;
										(0, _keys2.default)(item).forEach(function (col) {
											if (i === 1) logisticsData['ordercode'] = item[col];else if (i === 2) logisticsData['u8id'] = item[col];else if (i === 3) logisticsData['logisticsid'] = item[col];else if (i === 4) logisticsData['logisticsname'] = item[col];else if (i === 5) logisticsData['u8orderid'] = item[col];

											i++;
										});

										if (!!logisticsData.ordercode) {
											if (!!logisticsData.logisticsid) {
												dataArray.push(logisticsData);
											} else {
												nullArray.push(logisticsData.ordercode);
											}
										}
									});
								}
							});
							if (!!dataArray && dataArray.length > 0) {
								_this.loading = true;
								var para = {
									data: dataArray
								};
								(0, _api.editOrderWaybillcode)(para, _this).then(function (res) {
									return res.data;
								}).then(function (data) {
									_this.loading = false;
									var code = data.code,
									    msg = data.msg;

									if (code !== "0") {
										_this.$message({
											message: msg,
											type: 'error'
										});
									} else {
										if (!!nullArray && nullArray.length > 0) {
											_this.$message({
												message: nullArray.join(',') + ' 等订单对应运单号为空，请确认后重新导入！',
												type: 'warning'
											});
										}
										_this.getData();
									}
								});
							} else {
								if (!!nullArray && nullArray.length > 0) {
									_this.$message({
										message: nullArray.join(',') + ' 等订单对应运单号为空，请确认后重新导入！',
										type: 'warning'
									});
								} else {
									_this.$message({
										message: '未读取到有效数据，请确认数据格式后重新导入！',
										type: 'warning'
									});
								}
							}
						}
					} else {
						_this.$message({
							message: '导入文件的数据为空！',
							type: 'warning'
						});
					}
				});
			}
		},

		exportExcel: function exportExcel() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {
				status: 0,
				pageNum: 1,
				pageSize: _this.totalNum
			};

			if (!!_this.vague) para['vague'] = _this.vague;

			if (!!_this.sortAreaId) para['areaid'] = _this.sortAreaId;else if (_this.loginRole !== 1) {
				para['areaid'] = _this.areaid;
			}

			if (_this.loginRole === 2) {
				if (!_this.vague && !_this.sortAreaId) {
					if (!!_this.wxaccount) para['wxaccount'] = _this.wxaccount;
				}
			} else {
				if (!!_this.wxaccount) para['wxaccount'] = _this.wxaccount;
			}

			(0, _api.getLogisticsList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data2 = data,
				    code = _data2.code,
				    msg = _data2.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;
					_this.doExport(data);
				}
			});
		},

		doExport: function doExport(tabData) {
			var _this = this;

			if (!!tabData && tabData.length > 0) {
				var i = 1;
				tabData.forEach(function (item) {
					item.id = i;
					i++;
				});

				var fileName = _this.sysCnName + "_" + _util2.default.formatDate.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "_" + _this.$root.$route.name;

				var tHeader = ['序号', '销售单号(U8系统的ID)', '快递单号', '物流公司', 'U8系统发货单号'];
				var filterVal = ['id', 'u8id', 'logisticsid', 'logisticsname', 'u8orderid'];
				_util2.default.exportJsonToExcel(fileName, (0, _stringify2.default)(tabData), tHeader, filterVal);
			} else {
				this.$message({
					message: "没有需要导出的数据",
					type: 'warning'
				});
			}
		},

		clickWayBill: function clickWayBill(index, row) {
			var logisticsid = row.logisticsid;
			if (logisticsid.indexOf('DPK') == 0) {
				this.checkLogistics(logisticsid);
			} else {
				this.checkSFWaybill(logisticsid);
			}
			this.checkU8idFun(row.u8orderid);
		},

		checkLogistics: function checkLogistics(wayid) {
			var _this = this;
			_this.logisticsDatas = [];
			_this.logisticsBillNo = '';
			_this.logisticsStatu = '';
			if (!!wayid) {
				_this.loading = true;
				var para = {
					wid: wayid
				};
				(0, _api.findwaybill)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var code = data.code,
					    msg = data.msg;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						if (!!data.data && !!data.data.list && !!data.data.list.result) {
							var result = data.data.list.result;
							_this.logisticsBillNo = result.billno;
							_this.logisticsStatu = result.billnostate;
							if (!!result.tracks) {
								_this.logisticsDatas = data.data.list.result.tracks;
							}
						} else {
							_this.logisticsBillNo = wayid;
							_this.logisticsStatu = "暂无物流信息";
						}

						_this.logisticsDialogVisible = true;
					}
				});
			}
		},

		checkSFWaybill: function checkSFWaybill(wayid) {
			var _this = this;
			_this.logisticsDatas = [];
			_this.logisticsBillNo = '';
			_this.logisticsStatu = '';
			if (!!wayid) {
				_this.loading = true;
				var para = {
					uid: _this.uid,
					wid: wayid
				};
				(0, _api.queryWaybill)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var code = data.code,
					    msg = data.msg;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						if (!!data.data) {
							var result = data.data;
							_this.logisticsBillNo = result.billno;
							_this.logisticsStatu = result.billnostate;
							if (!!result.tracks) {
								_this.logisticsDatas = result.tracks;
							}
						} else {
							_this.logisticsBillNo = wayid;
							_this.logisticsStatu = "暂无物流信息";
						}

						_this.logisticsDialogVisible = true;
					}
				});
			}
		},

		checkU8idFun: function checkU8idFun(u8orderid) {
			var _this = this;
			if (!!u8orderid) {
				_this.loading = true;
				var para = {
					u8orderid: u8orderid
				};
				(0, _api.u8orderidInter)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var code = data.code,
					    msg = data.msg;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.consignment = JSON.parse(data.data).consignment;
					}
				});
			}
		},

		closeLogisticsDialog: function closeLogisticsDialog() {
			this.logisticsDialogVisible = false;
		},

		getAllAgencys: function getAllAgencys() {
			var _this = this;
			_this.loading = true;
			var para = {};
			(0, _api.areabyroleList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				var code = data.code,
				    msg = data.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					var agencyData = data.data.list;
					var areaData = data.data.list2;

					_this.agencyDatas = agencyData;

					var areaDatas = areaData.filter(function (item) {
						return item.status === 0;
					});

					_this.allAreaDatas.push({ id: '', areaname: '全部' });
					if (!!_this.areaid) {
						var areas = _this.areaid.split(',');
						areaDatas.forEach(function (item) {
							areas.forEach(function (a) {
								if (a + '' === item.areaId + '') {
									_this.allAreaDatas.push({ id: item.areaId, areaname: item.areaName });
								}
							});
						});
					} else {
						areaDatas.forEach(function (item) {
							_this.allAreaDatas.push({ id: item.areaId, areaname: item.areaName });
						});
					}
					_this.loading = false;

					_this.getData();
				}
			});
		},
		handlePageSizeChange: function handlePageSizeChange(val) {
			this.pageSize = val;
			this.getData();
		},
		handlePageCurrentChange: function handlePageCurrentChange(val) {
			this.pageNum = val;
			this.getData();
		}
	},

	created: function created() {
		this.loginId = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.uid, this);

		var role = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.role, this);
		this.loginRole = role;

		if (role === 1 || role === 3 || role === 4) this.areaid = '';else this.areaid = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.areaid, this);

		this.wxaccount = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.wxaccount, this);
	},

	mounted: function mounted() {
		var _this3 = this;

		var _this = this;
		_this.containerHeight = _this.$refs.logisticscontainer.offsetHeight;

		_this.uid = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.uid, this);

		_this.getAllAgencys();

		window.onresize = function () {
			return function () {
				if (!_this3.timer && !!_this.$refs.logisticscontainer) {
					_this3.timer = true;
					_this.containerHeight = _this.$refs.logisticscontainer.offsetHeight;
					var that = _this3;
					setTimeout(function () {
						that.timer = false;
					}, 100);
				}
			}();
		};
	}
};

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _defineProperty2 = __webpack_require__(346);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _typeof2 = __webpack_require__(76);

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(11);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _UploadFile = __webpack_require__(52);

var _UploadFile2 = _interopRequireDefault(_UploadFile);

var _Pagination = __webpack_require__(37);

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		UploadFile: _UploadFile2.default,
		Pagination: _Pagination2.default
	},
	data: function data() {
		var _this2 = this;

		var validatorPcd = function validatorPcd(rule, value, callback) {
			if (!_this2.formData.region.province) {
				return callback(new Error('请选择省'));
			} else if (!_this2.formData.region.city) {
				return callback(new Error('请选择市'));
			} else if (!_this2.formData.region.district) {
				return callback(new Error('请选择县（区）'));
			}
			callback();
		};
		return {
			sysCnName: _emEnum2.default.cnName,
			sysEnName: _emEnum2.default.enName,
			pageName: 'order',

			loginId: '',
			loginRole: '',
			areaid: '',
			wxaccount: '',

			loading: false,
			containerHeight: 0,
			datas: [],

			orderTypeOptions: _emEnum2.default.orderTypeOptions,

			orderStatusOptions: _emEnum2.default.orderStatusOptions,

			isreportedOptions: _emEnum2.default.isreportedOptions,

			fuzzyFieldOptions: _emEnum2.default.fuzzyFieldOptions,

			pageSize: 100,
			pageNum: 1,
			totalNum: 0,

			allAreaDatas: [],
			fuzzyField: '',
			fuzzyFieldValue: '',
			vague: '',
			sortAreaId: '',
			aagencyid: '',
			paystatus: '',
			orderStartime: '',
			orderEndtime: '',
			orderStartStamp: '',
			orderEndStamp: '',

			startPickerOptions: {
				disabledDate: function disabledDate(time) {
					if (!!_this2.orderEndtime) {
						return time.getTime() > new Date(_this2.orderEndtime);
					}
					return false;
				}
			},
			endPickerOptions: {
				disabledDate: function disabledDate(time) {
					if (!!_this2.orderStartime) {
						return time.getTime() < new Date(_this2.orderStartime);
					}
					return false;
				}
			},

			promotiontitleDisabled: true,
			waybillcodeDisabled: false,

			logisticsDialogVisible: false,
			logisticsDatas: [],
			agencyDatas: [],

			progressDialogVisible: false,
			progressPercentage: 0,

			u8idDialogVisible: false,
			u8idPayfailreason: '',

			editDisabled: true,
			dialogTitle: '',
			editDialogVisible: false,
			formData: {
				oid: '',
				code: '',
				creattime: '',
				ordercaretername: '',

				aagencyid: '',
				pagencyname: '',
				cagencyname: '',
				tagencyname: '',

				consignee: '',
				linkphone: '',
				region: {
					province: '',
					city: '',
					district: '' },
				address: '',
				remark: '',

				franchisee: '',
				isreported: '',
				storename: '',
				notreportreason: '',
				totalamount: '',
				ordertype: '',
				promotiontitle: '',
				paystatus: '',
				waybillcode: '',
				u8id: '' },
			rules: {
				consignee: [{ required: true, message: '请输入收货人', trigger: 'blur' }],
				linkphone: [{ required: true, message: '请输入收货电话', trigger: 'blur' }],
				address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
				province: [{ required: true, validator: validatorPcd, trigger: 'blur' }]
			},
			fixedPos: 'right',
			colDialogVisible: false,
			colDatas: [{ key: 'code', label: '订单单号' }, { key: 'creatdate', label: '订单日期' }, { key: 'creattime', label: '订单时间' }, { key: 'ordercaretername', label: '下单人' }, { key: 'aagencyname', label: '培训公司' }, { key: 'pagencyname', label: '销售公司' }, { key: 'cagencyname', label: '代理1' }, { key: 'tagencyname', label: '代理2' }, { key: 'consignee', label: '收货人' }, { key: 'linkphone', label: '收货电话' }, { key: 'province', label: '省' }, { key: 'city', label: '市' }, { key: 'district', label: '县（区）' }, { key: 'franchisee', label: '加盟商姓名' }, { key: 'finaladdress', label: '收货地址' }, { key: 'isreported', label: '是否报备' }, { key: 'storename', label: '店铺名称' }, { key: 'notreportreason', label: '未报备原因' }, { key: 'totalamount', label: '实际总金额' }, { key: 'voucherid', label: '返单券ID' }, { key: 'voucheramount', label: '返单券金额' }, { key: 'ordertype', label: '订单类型' }, { key: 'promotiontitle', label: '促销标题' }, { key: 'paystatus', label: '订单状态' }, { key: 'u8id', label: 'U8ID' }, { key: 'remark', label: '备注' }],
			colUnShowKeys: ['creattime', 'province', 'city', 'district'],

			detailDataList: [],

			currentOpDataList: [] };
	},

	methods: {
		formatCreatdate: function formatCreatdate(row, column) {
			var r = row.creattime.match(_util2.default.Regex.longDateRegex);
			if (r != null) {
				return _util2.default.formatDate.format(new Date(row.creattime.replace(/-/g, '/')), 'yyyy-MM-dd');
			} else return row.creattime;
		},
		formatCreattime: function formatCreattime(row, column) {
			var r = row.creattime.match(_util2.default.Regex.longDateRegex);
			if (r != null) {
				return _util2.default.formatDate.format(new Date(row.creattime.replace(/-/g, '/')), 'HH:mm:ss');
			} else return row.creattime;
		},

		formatOrderType: function formatOrderType(row, column) {
			if (row.ordertype === '1') return "活动订单";else if (row.ordertype === '2') return "促销订单";else return "";
		},

		formatVoucherAmount: function formatVoucherAmount(row, column) {
			if (row.voucheramount === 0 || row.voucheramount === '0') return "";else return row.voucheramount;
		},

		formatPaystatus: function formatPaystatus(row, column) {
			if (row.paystatus === '0' || row.paystatus === '-3' || !row.paystatus) return "待支付";else if (row.paystatus === '1') return "已付款";else if (row.paystatus === '2') return "已发货";else if (row.paystatus === '3') return "已完成";else return "";
		},

		formatIsreported: function formatIsreported(row, column) {
			var rOp = _emEnum2.default.isreportedOptions.find(function (item) {
				return item.key === row.isreported;
			});
			if (!rOp) return '';else return rOp.value;
		},

		cash: function cash() {
			this.formData.totalamount = this.formData.totalamount.replace(/[^\.\d]/g, '');
			this.formData.totalamount = this.formData.totalamount.replace(/^\./g, '');
			var temp = this.formData.totalamount.replace(/\./g, '');
			if (this.formData.totalamount.length >= temp.length + 2) {
				this.formData.totalamount = this.formData.totalamount.substr(0, this.formData.totalamount.length - 1);
			}
		},

		orderTimeChange: function orderTimeChange(control) {
			var _this = this;
			_this.orderStartStamp = '';
			_this.orderEndStamp = '';
			if (!!_this.orderStartime && !!_this.orderEndtime) {
				var s = _util2.default.formatDate.format(new Date(_this.orderStartime), 'yyyy-MM-dd') + ' 00:00:00';
				var e = _util2.default.formatDate.format(new Date(_this.orderEndtime), 'yyyy-MM-dd') + ' 23:59:59';
				_this.orderStartStamp = new Date(s).getTime();
				_this.orderEndStamp = new Date(e).getTime();
			}

			_this.searchList();
		},

		searchColumn: function searchColumn() {
			if (!!this.vague) {
				this.getData();
			}
		},

		searchList: function searchList() {
			this.pageNum = 1;
			this.getData();
		},

		getData: function getData() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {
				status: 0,
				pageNum: _this.pageNum,
				pageSize: _this.pageSize
			};

			if (!!_this.aagencyid) para['aagencyid'] = _this.aagencyid;

			if (!!_this.paystatus) para['paystatus'] = _this.paystatus;

			if (!!_this.orderStartStamp && !!_this.orderEndStamp) {
				para['startime'] = _this.orderStartStamp;
				para['endtime'] = _this.orderEndStamp;
			}

			if (!!_this.sortAreaId) para['areaid'] = _this.sortAreaId;else if (_this.loginRole !== 1) {
				para['areaid'] = _this.areaid;
			}

			if (!!_this.wxaccount && (_this.loginRole === 1 || !_this.sortAreaId)) {
				para['wxaccount'] = _this.wxaccount;
			}

			if (!!_this.fuzzyField && !!_this.vague) {
				para['column'] = _this.fuzzyField;
				para['columnvalue'] = _this.vague;
			} else {
				if (!!_this.vague) para['vague'] = _this.vague;
			}

			(0, _api.getOrderList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data = data,
				    code = _data.code,
				    msg = _data.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					var _data$data = data.data,
					    pageSize = _data$data.pageSize,
					    pageNum = _data$data.pageNum,
					    totalNum = _data$data.totalNum;

					data = data.data.list;
					_this.datas = data;

					_this.pageSize = pageSize;
					_this.pageNum = pageNum;
					_this.totalNum = totalNum;
				}
			});
		},

		resetForm: function resetForm(formName) {
			this.$refs[formName].resetFields();
		},

		delData: function delData(index, row) {
			var _this = this;
			_this.$confirm('确认删除该订单？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					oid: row.id,
					status: '1'
				};
				(0, _api.enableOrder)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: '订单删除成功',
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		editPaystatusData: function editPaystatusData(index, row) {
			var sta = '';
			var staCode = '';
			if (row.paystatus === '0' || row.paystatus === '-3' || !row.paystatus) {
				sta = '付款';
				staCode = '1';
			} else if (row.paystatus === '1') {
				sta = '发货';
				staCode = '2';
			} else if (row.paystatus === '2') {
				sta = '完成';
				staCode = '3';
			}
			this.paystatusDataUpdate(row.code, staCode, sta);
		},
		clickPaystatus: function clickPaystatus() {
			var sta = '';
			var staCode = '';
			if (this.formData.paystatus === '0') {
				sta = '付款';
				staCode = '1';
			} else {
				sta = '完成';
				staCode = '3';
			}
			this.paystatusDataUpdate(this.formData.code, staCode, sta);
		},

		paystatusDataUpdate: function paystatusDataUpdate(code, staCode, staDesc) {
			if (!!staCode) {
				var _this = this;
				_this.$confirm('确认订单【' + staDesc + '】？', '提示', {
					type: 'warning'
				}).then(function () {
					var orderCode = code;

					_this.loading = true;
					var para = {
						code: orderCode,
						paystatus: staCode
					};
					(0, _api.editPaystatus)(para, _this).then(function (res) {
						return res.data;
					}).then(function (data) {
						_this.loading = false;
						var code = data.code,
						    msg = data.msg;

						if (code !== "0") {
							_this.$message({
								message: msg,
								type: 'error'
							});
						} else {
							_this.$message({
								message: msg,
								type: 'success'
							});
							_this.getData();
						}
					});
				}).catch(function (error) {
					if (error !== 'cancel') {
						_this.$message({
							message: error.message ? error.message : error,
							type: 'error'
						});
					}
				});
			} else {
				this.$message({
					message: '订单支付状态有误，请确认后修改！',
					type: 'warning'
				});
			}
		},

		editData: function editData(index, row) {
			if (!row) {
				this.$message({
					message: '请选择要编辑的数据！',
					type: 'warning'
				});
			} else {
				this.editDialogVisible = true;
				this.dialogTitle = "编辑";

				this.formData.oid = row.id;
				this.formData.code = row.code;
				this.formData.creattime = row.creattime;
				this.formData.ordercaretername = row.ordercaretername;
				this.formData.aagencyid = row.aagencyid == null ? '' : row.aagencyid + '';
				this.formData.pagencyname = row.pagencyname;
				this.formData.cagencyname = row.cagencyname;
				this.formData.tagencyname = row.tagencyname;

				this.formData.consignee = row.consignee;
				this.formData.linkphone = row.linkphone;
				this.formData.region.province = row.province;
				this.formData.region.city = row.city;
				this.formData.region.district = row.district;
				this.formData.address = row.address;
				this.formData.remark = row.remark;

				this.formData.franchisee = row.franchisee;
				this.formData.storename = row.storename;
				this.formData.isreported = row.isreported;
				this.formData.notreportreason = row.notreportreason;
				this.formData.totalamount = row.totalamount;
				this.formData.ordertype = row.ordertype;
				this.formData.promotiontitle = row.promotiontitle;
				this.formData.paystatus = row.paystatus;
				this.formData.waybillcode = row.waybillcode;
				this.formData.u8id = row.u8id;
			}
		},

		checkLogistics: function checkLogistics(index, row) {
			var _this = this;
			if (!!row.waybillcode) {
				_this.loading = true;
				_this.closeLogisticsDialog();
				var para = {
					waybillcode: row.waybillcode
				};
				(0, _api.findwaybill)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var code = data.code,
					    msg = data.msg;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.logisticsDialogVisible = true;
					}
				});
			}
		},

		closeLogisticsDialog: function closeLogisticsDialog() {
			this.logisticsDialogVisible = false;
		},

		openDialog: function openDialog() {
			var ele = document.getElementById('focus-ele');
			if (!!ele) {
				ele.focus();
			}
		},

		openProgressDialog: function openProgressDialog() {
			this.progressPercentage = 0;
			this.detailDataList = [];
		},

		beforeCloseProgressDialog: function beforeCloseProgressDialog(done) {
			var _this = this;
			_this.$confirm('正在导出订单明细，关闭将结束导出，确认关闭？').then(function (r) {
				done();
			}).catch(function (r) {});
		},
		closeProgressDialog: function closeProgressDialog() {
			this.progressDialogVisible = false;
			this.progressPercentage = 0;
			this.detailDataList = [];
		},

		checkU8idPayfailreason: function checkU8idPayfailreason(index, row) {
			this.u8idPayfailreason = row.payfailreason;
			this.u8idDialogVisible = true;
		},

		beforeCloseU8idDialog: function beforeCloseU8idDialog() {
			this.u8idPayfailreason = '';
		},

		ordertypeChange: function ordertypeChange() {},

		orderstatusChange: function orderstatusChange() {
			if (this.formData.paystatus === 0 || this.formData.paystatus === 1) {
				this.waybillcodeDisabled = true;
			} else {
				this.waybillcodeDisabled = false;
			}
		},

		closeDialog: function closeDialog() {
			this.editDialogVisible = false;
		},

		handleSubmit: function handleSubmit(formName) {
			var _this3 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					var _this = _this3;
					_this.$confirm('确认' + _this.dialogTitle + '订单？', '提示', {
						type: 'warning'
					}).then(function () {
						_this.loading = true;
						if (!_this.formData.oid) {
							_this.$message({
								message: '请选择要编辑的数据！',
								type: 'warning'
							});
						} else {
							var para = {
								oid: _this.formData.oid,

								aagencyid: _this.formData.aagencyid,
								pagencyname: _this.formData.pagencyname,
								cagencyname: _this.formData.cagencyname,
								tagencyname: _this.formData.tagencyname,

								consignee: _this.formData.consignee,
								linkphone: _this.formData.linkphone,
								province: _this.formData.region.province,
								city: _this.formData.region.city,
								district: _this.formData.region.district,
								address: _this.formData.address,
								remark: _this.formData.remark,

								franchisee: _this.formData.franchisee,
								storename: _this.formData.storename,
								isreported: _this.formData.isreported,
								notreportreason: _this.formData.notreportreason,
								totalamount: _this.formData.totalamount,
								ordertype: _this.formData.ordertype
							};

							var agency = _this.agencyDatas.find(function (item) {
								return item.aagencyid === para.aagencyid;
							});
							if (!!agency) {
								para["aagencyname"] = agency.aagencyname;
							} else {
								para["aagencyname"] = "";
							}

							(0, _api.editOrder)(para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						}
					}).catch(function (error) {
						if (error !== 'cancel') {
							_this.$message({
								message: error.message ? error.message : error,
								type: 'error'
							});
						}
					});
				} else {
					return false;
				}
			});
		},

		nextStep: function nextStep(index, row) {
			this.$router.push({ path: '/orderView', query: { oid: row.id, ps: this.pageSize, pn: this.pageNum } });
		},

		importExcel: function importExcel(e) {
			var file = e.target.files[0];

			if (!file) {
				this.$message({
					message: '请选择导入的文件！',
					type: 'warning'
				});
				return;
			}

			var types = file.name.split('.')[1];
			var fileType = ['xlsx', 'xls', 'csv'].some(function (item) {
				return item === types;
			});
			if (!fileType) {
				this.$message({
					message: '格式错误，请重新选择！',
					type: 'warning'
				});
				return;
			} else {
				var _this = this;

				var xlsxJson = void 0;

				var dataArray = [];
				var nullArray = [];
				_util2.default.file2Xce(file).then(function (tabJson) {
					var f = document.getElementById('file');
					f.value = '';

					if (tabJson && tabJson.length > 0) {
						xlsxJson = tabJson;

						if (!!xlsxJson && xlsxJson.length > 0) {
							xlsxJson.forEach(function (sheetItem) {
								if (!!sheetItem && !!sheetItem.sheet && sheetItem.sheet.length > 0) {
									sheetItem.sheet.forEach(function (item) {
										if (!!item.code) {
											if (!!item.waybillcode) {
												dataArray.push({ code: item.code, waybillcode: !!item.waybillcode ? item.waybillcode : '' });
											} else {
												nullArray.push(item.code);
											}
										}
									});
								}
							});
							if (!!dataArray && dataArray.length > 0) {
								_this.loading = true;
								var para = {
									data: dataArray
								};
								(0, _api.editOrderWaybillcode)(para, _this).then(function (res) {
									return res.data;
								}).then(function (data) {
									_this.loading = false;
									var code = data.code,
									    msg = data.msg;

									if (code !== "0") {
										_this.$message({
											message: msg,
											type: 'error'
										});
									} else {
										if (!!nullArray && nullArray.length > 0) {
											_this.$message({
												message: nullArray.join(',') + ' 等订单对应运单号为空，请确认后重新导入！',
												type: 'warning'
											});
										}
										_this.getData();
									}
								});
							} else {
								if (!!nullArray && nullArray.length > 0) {
									_this.$message({
										message: nullArray.join(',') + ' 等订单对应运单号为空，请确认后重新导入！',
										type: 'warning'
									});
								} else {
									_this.$message({
										message: '未读取到有效数据，请确认数据格式后重新导入！',
										type: 'warning'
									});
								}
							}
						}
					} else {
						_this.$message({
							message: '导入文件的数据为空！',
							type: 'warning'
						});
					}
				});
			}
		},

		exportExcel: function exportExcel() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {
				status: 0,
				pageNum: 1,
				pageSize: _this.totalNum
			};

			if (!!_this.aagencyid) para['aagencyid'] = _this.aagencyid;

			if (!!_this.paystatus) para['paystatus'] = _this.paystatus;

			if (!!_this.orderStartStamp && !!_this.orderEndStamp) {
				para['startime'] = _this.orderStartStamp;
				para['endtime'] = _this.orderEndStamp;
			}

			if (!!_this.sortAreaId) para['areaid'] = _this.sortAreaId;else if (_this.loginRole !== 1) {
				para['areaid'] = _this.areaid;
			}

			if (!!_this.wxaccount && (_this.loginRole === 1 || !_this.sortAreaId)) {
				para['wxaccount'] = _this.wxaccount;
			}

			if (!!_this.fuzzyField && !!_this.vague) {
				para['column'] = _this.fuzzyField;
				para['columnvalue'] = _this.vague;
			} else {
				if (!!_this.vague) para['vague'] = _this.vague;
			}

			(0, _api.getOrderList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data2 = data,
				    code = _data2.code,
				    msg = _data2.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;
					_this.doExport(data);
				}
			});
		},

		doExport: function doExport(tabData) {
			var _this = this;

			if (!!tabData && tabData.length > 0) {
				var i = 1;
				tabData.forEach(function (item) {
					item.id = i;
					item["creattime1"] = _this.formatCreatdate(item);
					item["creattime2"] = _this.formatCreattime(item);
					item.isreported = _this.formatIsreported(item);
					item.ordertype = _this.formatOrderType(item);
					item.voucheramount = _this.formatVoucherAmount(item);
					item.paystatus = _this.formatPaystatus(item);
					item.totalamount = parseFloat(item.totalamount);
					i++;
				});

				var tHeader = ['序号', '订单单号', '订单日期', '订单时间', '下单人', '培训公司', '销售公司', '代理1', '代理2', '收货人', '收货电话', '省', '市', '县（区）', '收货地址', '加盟商姓名', '是否报备', '店铺名称', '未报备原因', '实际总金额', '返单券ID', '返单券金额', '订单类型', '促销标题', '订单状态', 'U8ID', '备注'];
				var filterVal = ['id', 'code', 'creattime1', 'creattime2', 'ordercaretername', 'aagencyname', 'pagencyname', 'cagencyname', 'tagencyname', 'consignee', 'linkphone', 'province', 'city', 'district', 'finaladdress', 'franchisee', 'isreported', 'storename', 'notreportreason', 'totalamount', 'voucherid', 'voucheramount', 'ordertype', 'promotiontitle', 'paystatus', 'u8id', 'remark'];

				var fileName = _this.sysCnName + "_" + _util2.default.formatDate.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "_" + _this.$root.$route.name;
				_util2.default.exportJsonToExcel(fileName, (0, _stringify2.default)(tabData), tHeader, filterVal);
			} else {
				this.$message({
					message: "没有需要导出的数据",
					type: 'warning'
				});
			}
		},

		exportDetailExcel: function exportDetailExcel() {
			var _this4 = this;

			var _this = this;
			var detailData = [];

			_this.loading = true;
			var para = {
				status: 0 };

			if (!!_this.aagencyid) para['aagencyid'] = _this.aagencyid;

			if (!!_this.paystatus) para['paystatus'] = _this.paystatus;

			if (!!_this.orderStartStamp && !!_this.orderEndStamp) {
				para['startime'] = _this.orderStartStamp;
				para['endtime'] = _this.orderEndStamp;
			}

			if (!!_this.sortAreaId) para['areaid'] = _this.sortAreaId;else if (_this.loginRole !== 1) {
				para['areaid'] = _this.areaid;
			}

			if (!!_this.wxaccount && (_this.loginRole === 1 || !_this.sortAreaId)) {
				para['wxaccount'] = _this.wxaccount;
			}

			if (!!_this.fuzzyField && !!_this.vague) {
				para['column'] = _this.fuzzyField;
				para['columnvalue'] = _this.vague;
			} else {
				if (!!_this.vague) para['vague'] = _this.vague;
			}

			(0, _api.orderDetail)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data3 = data,
				    code = _data3.code,
				    msg = _data3.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;

					if (!!data && data.length > 0) {
						data.forEach(function (d) {
							d.orderstep.forEach(function (ele) {
								var bZxg = ele.promotionsteptype === "4";

								ele.orderstep.forEach(function (innerEle) {
									var obj = {
										id: d.id,
										code: d.code,
										ordercaretername: d.ordercaretername,
										aagencyname: d.aagencyname,
										pagencyname: d.pagencyname,
										cagencyname: d.cagencyname,
										tagencyname: d.tagencyname,

										franchisee: d.franchisee,
										consignee: d.consignee,
										linkphone: d.linkphone,
										province: d.province,
										city: d.city,
										district: d.district,

										finaladdress: d.finaladdress,
										remark: d.remark,
										creattime: isNaN(d.creattime) && !isNaN(Date.parse(d.creattime)) ? _util2.default.formatDate.format(new Date(d.creattime.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:ss') : d.creattime,
										ordertype: _this.formatOrderType(d),
										status: d.status === 0 ? '启用' : d.status === 1 ? '禁用' : '结单',
										paystatus: _this.formatPaystatus(d),

										spcode: innerEle.spcode,
										spname: innerEle.spname,
										stepname: innerEle.orderstepname,
										spsize: innerEle.spsize,
										spmoney: innerEle.spmoney,
										spamount: 0,
										spccomunitname: innerEle.spccomunitname,
										zpcode: bZxg ? '' : innerEle.spcode
									};
									detailData.push(obj);
									if (!!innerEle.zpinventorylist && innerEle.zpinventorylist.length > 0) {
										innerEle.zpinventorylist.forEach(function (zpItem) {
											var zpObj = {
												id: d.id,
												code: d.code,
												ordercaretername: d.ordercaretername,
												aagencyname: d.aagencyname,
												pagencyname: d.pagencyname,
												cagencyname: d.cagencyname,
												tagencyname: d.tagencyname,

												franchisee: d.franchisee,
												consignee: d.consignee,
												linkphone: d.linkphone,
												province: d.province,
												city: d.city,
												district: d.district,

												finaladdress: d.finaladdress,
												remark: d.remark,
												creattime: isNaN(d.creattime) && !isNaN(Date.parse(d.creattime)) ? _util2.default.formatDate.format(new Date(d.creattime.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:ss') : d.creattime,
												ordertype: _this.formatOrderType(d),
												status: d.status === 0 ? '启用' : d.status === 1 ? '禁用' : '结单',
												paystatus: _this.formatPaystatus(d),

												spcode: zpItem.zpcode,
												spname: zpItem.zpname,
												stepname: innerEle.orderstepname,
												spsize: zpItem.zpsize,
												spmoney: zpItem.zpmoney,
												spamount: 0,
												spccomunitname: zpItem.zpccomunitname,
												zpcode: zpItem.zpcode
											};
											detailData.push(zpObj);
										});
									}
								});
							});
						});


						_this.doDetailExport(detailData);
					} else {
						_this4.$message({
							message: "没有需要导出的数据",
							type: 'warning'
						});
					}
				}
			});
		},

		exportDetailExcelByPage: function exportDetailExcelByPage() {
			var _this = this;

			_this.progressDialogVisible = true;

			var para = {
				status: 0,
				pageNum: 1,
				pageSize: _this.totalNum
			};

			if (!!_this.aagencyid) para['aagencyid'] = _this.aagencyid;

			if (!!_this.paystatus) para['paystatus'] = _this.paystatus;

			if (!!_this.orderStartStamp && !!_this.orderEndStamp) {
				para['startime'] = _this.orderStartStamp;
				para['endtime'] = _this.orderEndStamp;
			}

			if (!!_this.sortAreaId) para['areaid'] = _this.sortAreaId;else if (_this.loginRole !== 1) {
				para['areaid'] = _this.areaid;
			}

			if (!!_this.wxaccount && (_this.loginRole === 1 || !_this.sortAreaId)) {
				para['wxaccount'] = _this.wxaccount;
			}

			if (!!_this.fuzzyField && !!_this.vague) {
				para['column'] = _this.fuzzyField;
				para['columnvalue'] = _this.vague;
			} else {
				if (!!_this.vague) para['vague'] = _this.vague;
			}

			(0, _api.getOrderList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				var _data4 = data,
				    code = _data4.code,
				    msg = _data4.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					var _ret = function () {
						data = data.data.list;

						var detailData = [];
						if (!!data && data.length > 0) {
							var orderCodeArr = data.map(function (a) {
								return a.code;
							});
							var oldLen = orderCodeArr.length;

							var num = 20;

							while (!!orderCodeArr && orderCodeArr.length > 0) {
								if (!_this.progressDialogVisible) {
									return {
										v: void 0
									};
								}

								_this.progressPercentage = parseInt(100 - orderCodeArr.length / oldLen * 100);

								var codeArr = orderCodeArr.splice(0, num);
								if (!!codeArr && codeArr.length > 0) {
									var codeStr = codeArr.join(',');

									var _para = {
										code: codeStr
									};

									(0, _api.orderDetailByPage)(_para, _this).then(function (res) {
										return res.data;
									}).then(function (data) {
										var _data5 = data,
										    code = _data5.code,
										    msg = _data5.msg;

										if (code === "0") {
											data = data.data.list;
											if (!!data && data.length > 0) {
												data.forEach(function (d) {
													d.orderstep.forEach(function (ele) {
														var bZxg = ele.promotionsteptype === "4";

														ele.orderstep.forEach(function (innerEle) {
															var obj = {
																id: d.id,
																code: d.code,
																ordercaretername: d.ordercaretername,
																aagencyname: d.aagencyname,
																pagencyname: d.pagencyname,
																cagencyname: d.cagencyname,
																tagencyname: d.tagencyname,

																franchisee: d.franchisee,
																consignee: d.consignee,
																linkphone: d.linkphone,
																province: d.province,
																city: d.city,
																district: d.district,

																finaladdress: d.finaladdress,
																remark: d.remark,
																creattime: isNaN(d.creattime) && !isNaN(Date.parse(d.creattime)) ? _util2.default.formatDate.format(new Date(d.creattime.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:ss') : d.creattime,
																ordertype: _this.formatOrderType(d),
																status: d.status === 0 ? '启用' : d.status === 1 ? '禁用' : '结单',
																paystatus: _this.formatPaystatus(d),

																spcode: innerEle.spcode,
																spname: innerEle.spname,
																stepname: innerEle.orderstepname,
																spsize: innerEle.spsize,
																spmoney: innerEle.spmoney,
																spamount: 0,
																spccomunitname: innerEle.spccomunitname,
																zpcode: bZxg ? '' : innerEle.spcode
															};
															detailData.push(obj);
															if (!!innerEle.zpinventorylist && innerEle.zpinventorylist.length > 0) {
																innerEle.zpinventorylist.forEach(function (zpItem) {
																	var zpObj = {
																		id: d.id,
																		code: d.code,
																		ordercaretername: d.ordercaretername,
																		aagencyname: d.aagencyname,
																		pagencyname: d.pagencyname,
																		cagencyname: d.cagencyname,
																		tagencyname: d.tagencyname,

																		franchisee: d.franchisee,
																		consignee: d.consignee,
																		linkphone: d.linkphone,
																		province: d.province,
																		city: d.city,
																		district: d.district,

																		finaladdress: d.finaladdress,
																		remark: d.remark,
																		creattime: isNaN(d.creattime) && !isNaN(Date.parse(d.creattime)) ? _util2.default.formatDate.format(new Date(d.creattime.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:ss') : d.creattime,
																		ordertype: _this.formatOrderType(d),
																		status: d.status === 0 ? '启用' : d.status === 1 ? '禁用' : '结单',
																		paystatus: _this.formatPaystatus(d),

																		spcode: zpItem.zpcode,
																		spname: zpItem.zpname,
																		stepname: innerEle.orderstepname,
																		spsize: zpItem.zpsize,
																		spmoney: zpItem.zpmoney,
																		spamount: 0,
																		spccomunitname: zpItem.zpccomunitname,
																		zpcode: zpItem.zpcode
																	};
																	detailData.push(zpObj);
																});
															}
														});
													});
												});
											}
										}
									});
								}
							}
						}

						if (_this.progressDialogVisible) {
							if (detailData && detailData.length > 0) {
								_this.doDetailExport(detailData);
								_this.progressPercentage = 100;

								_this.closeProgressDialog();
							} else {
								_this.progressPercentage = 100;

								_this.closeProgressDialog();
								_this.$message({
									message: "没有需要导出的数据",
									type: 'warning'
								});
							}
						}
					}();

					if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
				}
			});
		},

		exportDetailExcelByPageNum: function exportDetailExcelByPageNum() {
			var _this = this;
			_this.$confirm('该操作是一个耗时操作，请耐心等待', '提示', {
				type: 'warning'
			}).then(function () {
				_this.progressDialogVisible = true;

				var _pageSize = 10;
				var _pageNum = 1;
				var para = {
					status: 0,
					pageNum: _pageNum,
					pageSize: _pageSize
				};

				if (!!_this.aagencyid) para['aagencyid'] = _this.aagencyid;

				if (!!_this.paystatus) para['paystatus'] = _this.paystatus;

				if (!!_this.orderStartStamp && !!_this.orderEndStamp) {
					para['startime'] = _this.orderStartStamp;
					para['endtime'] = _this.orderEndStamp;
				}

				if (!!_this.sortAreaId) para['areaid'] = _this.sortAreaId;else if (_this.loginRole !== 1) {
					para['areaid'] = _this.areaid;
				}

				if (!!_this.wxaccount && (_this.loginRole === 1 || !_this.sortAreaId)) {
					para['wxaccount'] = _this.wxaccount;
				}

				if (!!_this.fuzzyField && !!_this.vague) {
					para['column'] = _this.fuzzyField;
					para['columnvalue'] = _this.vague;
				} else {
					if (!!_this.vague) para['vague'] = _this.vague;
				}
				_this.callOrderDetailByPage(para);
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		doExportDetailExcelByPageNum: function doExportDetailExcelByPageNum() {
			var _this = this;

			if (_this.progressDialogVisible) {
				_this.progressPercentage = 100;
				if (_this.detailDataList && _this.detailDataList.length > 0) {
					_this.doDetailExport(_this.detailDataList);
				} else {
					_this.$message({
						message: "没有需要导出的数据",
						type: 'warning'
					});
				}

				_this.closeProgressDialog();
			} else {
				_this.detailDataList = [];
			}
		},

		callOrderDetailByPage: function callOrderDetailByPage(para) {
			var _this = this;

			(0, _api.orderDetailByPage)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				var _data6 = data,
				    code = _data6.code,
				    msg = _data6.msg;

				if (code === "0") {
					var _data$data2 = data.data,
					    pageSize = _data$data2.pageSize,
					    pageNum = _data$data2.pageNum,
					    totalNum = _data$data2.totalNum;

					data = data.data.list;
					if (!!data && data.length > 0) {
						data.forEach(function (d) {
							d.orderstep.forEach(function (ele) {
								var bZxg = ele.promotionsteptype === "4";

								ele.orderstep.forEach(function (innerEle) {
									var _obj;

									var obj = (_obj = {
										id: d.id,
										code: d.code,
										creattime: d.creattime,
										ordercaretername: d.ordercaretername,
										aagencyname: d.aagencyname,
										pagencyname: d.pagencyname,
										cagencyname: d.cagencyname,
										tagencyname: d.tagencyname,

										franchisee: d.franchisee,
										consignee: d.consignee,
										linkphone: d.linkphone,
										province: d.province,
										city: d.city,
										district: d.district,

										finaladdress: d.finaladdress,
										remark: d.remark }, (0, _defineProperty3.default)(_obj, 'creattime', isNaN(d.creattime) && !isNaN(Date.parse(d.creattime)) ? _util2.default.formatDate.format(new Date(d.creattime.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:ss') : d.creattime), (0, _defineProperty3.default)(_obj, 'ordertype', _this.formatOrderType(d)), (0, _defineProperty3.default)(_obj, 'status', d.status === 0 ? '启用' : d.status === 1 ? '禁用' : '结单'), (0, _defineProperty3.default)(_obj, 'paystatus', _this.formatPaystatus(d)), (0, _defineProperty3.default)(_obj, 'spcode', innerEle.spcode), (0, _defineProperty3.default)(_obj, 'spname', innerEle.spname), (0, _defineProperty3.default)(_obj, 'stepname', innerEle.orderstepname), (0, _defineProperty3.default)(_obj, 'spsize', innerEle.spsize), (0, _defineProperty3.default)(_obj, 'spmoney', innerEle.spmoney), (0, _defineProperty3.default)(_obj, 'spamount', 0), (0, _defineProperty3.default)(_obj, 'spccomunitname', innerEle.spccomunitname), (0, _defineProperty3.default)(_obj, 'zpcode', bZxg ? '' : innerEle.spcode), (0, _defineProperty3.default)(_obj, 'storename', d.storename), (0, _defineProperty3.default)(_obj, 'isreported', d.isreported), (0, _defineProperty3.default)(_obj, 'notreportreason', d.notreportreason), _obj);
									if (_this.progressDialogVisible) _this.detailDataList.push(obj);
									if (!!innerEle.zpinventorylist && innerEle.zpinventorylist.length > 0) {
										innerEle.zpinventorylist.forEach(function (zpItem) {
											var _zpObj;

											var zpObj = (_zpObj = {
												id: d.id,
												code: d.code,
												creattime: d.creattime,
												ordercaretername: d.ordercaretername,
												aagencyname: d.aagencyname,
												pagencyname: d.pagencyname,
												cagencyname: d.cagencyname,
												tagencyname: d.tagencyname,

												franchisee: d.franchisee,
												consignee: d.consignee,
												linkphone: d.linkphone,
												province: d.province,
												city: d.city,
												district: d.district,

												finaladdress: d.finaladdress,
												remark: d.remark }, (0, _defineProperty3.default)(_zpObj, 'creattime', isNaN(d.creattime) && !isNaN(Date.parse(d.creattime)) ? _util2.default.formatDate.format(new Date(d.creattime.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:ss') : d.creattime), (0, _defineProperty3.default)(_zpObj, 'ordertype', _this.formatOrderType(d)), (0, _defineProperty3.default)(_zpObj, 'status', d.status === 0 ? '启用' : d.status === 1 ? '禁用' : '结单'), (0, _defineProperty3.default)(_zpObj, 'paystatus', _this.formatPaystatus(d)), (0, _defineProperty3.default)(_zpObj, 'spcode', zpItem.zpcode), (0, _defineProperty3.default)(_zpObj, 'spname', zpItem.zpname), (0, _defineProperty3.default)(_zpObj, 'stepname', innerEle.orderstepname), (0, _defineProperty3.default)(_zpObj, 'spsize', zpItem.zpsize), (0, _defineProperty3.default)(_zpObj, 'spmoney', zpItem.zpmoney), (0, _defineProperty3.default)(_zpObj, 'spamount', 0), (0, _defineProperty3.default)(_zpObj, 'spccomunitname', zpItem.zpccomunitname), (0, _defineProperty3.default)(_zpObj, 'zpcode', zpItem.zpcode), (0, _defineProperty3.default)(_zpObj, 'storename', d.storename), (0, _defineProperty3.default)(_zpObj, 'isreported', d.isreported), (0, _defineProperty3.default)(_zpObj, 'notreportreason', d.notreportreason), _zpObj);
											if (_this.progressDialogVisible) _this.detailDataList.push(zpObj);
										});
									}
								});
							});
						});
					}

					var currentNum = pageSize * pageNum;
					if (totalNum <= currentNum || !_this.progressDialogVisible) {
						_this.progressPercentage = 100;
						_this.doExportDetailExcelByPageNum();
						return;
					} else {
						_this.progressPercentage = parseInt(currentNum / totalNum * 100);
						var _para2 = {
							status: 0,
							pageNum: pageNum + 1,
							pageSize: pageSize
						};

						if (!!_this.aagencyid) _para2['aagencyid'] = _this.aagencyid;

						if (!!_this.paystatus) _para2['paystatus'] = _this.paystatus;

						if (!!_this.orderStartStamp && !!_this.orderEndStamp) {
							_para2['startime'] = _this.orderStartStamp;
							_para2['endtime'] = _this.orderEndStamp;
						}

						if (!!_this.sortAreaId) _para2['areaid'] = _this.sortAreaId;else if (_this.loginRole !== 1) {
							_para2['areaid'] = _this.areaid;
						}

						if (!!_this.wxaccount && (_this.loginRole === 1 || !_this.sortAreaId)) {
							_para2['wxaccount'] = _this.wxaccount;
						}

						if (!!_this.fuzzyField && !!_this.vague) {
							_para2['column'] = _this.fuzzyField;
							_para2['columnvalue'] = _this.vague;
						} else {
							if (!!_this.vague) _para2['vague'] = _this.vague;
						}
						_this.callOrderDetailByPage(_para2);
					}
				} else {
					_this.doExportDetailExcelByPageNum();
				}
			});
		},

		formatAmount: function formatAmount(row, column) {
			var size = parseFloat(row.spsize);
			if (size.toString() == 'NaN') return 0;

			var money = parseFloat(row.spmoney);
			if (money.toString() == 'NaN') return 0;

			return size * money;
		},

		formatType: function formatType(row, column) {
			return !!row.zpcode ? '赠品' : '';
		},

		doDetailExport: function doDetailExport(tabData) {
			var _this = this;

			if (!!tabData && tabData.length > 0) {
				var i = 1;
				tabData.forEach(function (item) {
					item.id = i;
					item.creattime1 = _util2.default.formatDate.format(new Date(item.creattime.replace(/-/g, '/')), 'yyyy-MM-dd');
					item.zpcode = _this.formatType(item);
					item.spmoney = parseFloat(item.spmoney);
					item.spsize = parseFloat(item.spsize);
					item.spamount = parseFloat(_this.formatAmount(item));
					item.isreported = _this.formatIsreported(item);
					i++;
				});

				var tHeader = ['序号', '订单编号', '订单日期', '下单人', '广域', '销售公司', '代理1', '代理2', '加盟商', '收货人', '电话', '省份', '市', '县（区）', '收货地址', '是否报备', '店铺名称', '未报备原因', '备注', '具体下单时间', '订单类型', '订单状态', '支付状态', '商品类别', '商品名称', '商品编码', '单价', '数量', '总价', '是否赠品'];
				var filterVal = ['id', 'code', 'creattime1', 'ordercaretername', 'aagencyname', 'pagencyname', 'cagencyname', 'tagencyname', 'franchisee', 'consignee', 'linkphone', 'province', 'city', 'district', 'finaladdress', 'isreported', 'storename', 'notreportreason', 'remark', 'creattime', 'ordertype', 'status', 'paystatus', 'stepname', 'spname', 'spcode', 'spmoney', 'spsize', 'spamount', 'zpcode'];

				var fileName = _this.sysCnName + "_" + _util2.default.formatDate.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "_" + '明细表';
				_util2.default.exportJsonToExcel(fileName, (0, _stringify2.default)(tabData), tHeader, filterVal);
			} else {
				this.$message({
					message: "没有需要导出的数据",
					type: 'warning'
				});
			}
		},

		editCol: function editCol() {
			this.colDialogVisible = true;
		},

		closeColSet: function closeColSet() {
			this.fixedPos = "none";

			_util2.default.editStore.SetUnShowCols(this.pageName, this.colUnShowKeys);
			this.fixedPos = "right";
		},

		regionChange: function regionChange(val) {
			if (this.formData.region.province !== val.province) {
				this.formData.region.province = val.province;
				this.formData.region.city = '';
				this.formData.region.district = '';
			} else if (this.formData.region.city !== val.city) {
				this.formData.region.city = val.city;
				this.formData.region.district = '';
			} else if (this.formData.region.district !== val.district) {
				this.formData.region.district = val.district;
			}
		},

		getAllAgencys: function getAllAgencys() {
			var _this = this;
			_this.loading = true;
			var para = {};
			(0, _api.areabyroleList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				var code = data.code,
				    msg = data.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					var agencyData = data.data.list;
					var areaData = data.data.list2;

					_this.agencyDatas = agencyData;

					var areaDatas = areaData.filter(function (item) {
						return item.status === 0;
					});

					_this.allAreaDatas.push({ id: '', areaname: '全部' });
					if (!!_this.areaid) {
						var areas = _this.areaid.split(',');
						areaDatas.forEach(function (item) {
							areas.forEach(function (a) {
								if (a + '' === item.areaId + '') {
									_this.allAreaDatas.push({ id: item.areaId, areaname: item.areaName });
								}
							});
						});
					} else {
						areaDatas.forEach(function (item) {
							_this.allAreaDatas.push({ id: item.areaId, areaname: item.areaName });
						});
					}
					_this.loading = false;

					_this.getData();
				}
			});
		},
		handlePageSizeChange: function handlePageSizeChange(val) {
			this.pageSize = val;
			this.getData();
		},
		handlePageCurrentChange: function handlePageCurrentChange(val) {
			this.pageNum = val;
			this.getData();
		}
	},

	created: function created() {
		this.loginId = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.uid, this);

		var role = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.role, this);
		this.loginRole = role;

		if (role === 1 || role === 3 || role === 4) this.areaid = '';else this.areaid = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.areaid, this);

		this.wxaccount = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.wxaccount, this);

		var unShowCols = _util2.default.editStore.GetUnShowCols(this.pageName);
		if (!!unShowCols && unShowCols !== 'none') {
			this.colUnShowKeys = unShowCols;
		}

		var query = this.$route.query;
		if (!!query && !!query.ps && !!query.pn) {
			this.pageSize = parseInt(query.ps);
			this.pageNum = parseInt(query.pn);
		}
	},

	mounted: function mounted() {
		var _this5 = this;

		var _this = this;
		_this.containerHeight = _this.$refs.ordercontainer.offsetHeight;

		_this.getAllAgencys();

		window.onresize = function () {
			return function () {
				if (!_this5.timer && !!_this.$refs.ordercontainer) {
					_this5.timer = true;
					_this.containerHeight = _this.$refs.ordercontainer.offsetHeight;
					var that = _this5;
					setTimeout(function () {
						that.timer = false;
					}, 100);
				}
			}();
		};
	}
};

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(75);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(11);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _sortablejs = __webpack_require__(68);

var _sortablejs2 = _interopRequireDefault(_sortablejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			sysCnName: _emEnum2.default.cnName,
			sysEnName: _emEnum2.default.enName,

			loginId: '',
			oid: '',
			opageSize: 100,
			oPageNum: 1,

			submitSortDisabled: true,
			idArr: [],
			sequenceArr: [],

			loading: false,
			containerHeight: 0,
			orderHeight: 343,
			orderColl: '隐藏',
			activeName: ['coll'],
			datas: [],
			orderstep: [],

			orderDisabled: true,
			formData: {},

			editDisabled: true,

			wayBillDialogVisible: false,
			wayBillDatas: [],

			logisticsDialogVisible: false,
			logisticsDatas: [],
			logisticsBillNo: '',
			logisticsStatu: '' };
	},

	methods: {
		formatAmount: function formatAmount(row, column) {
			var size = parseFloat(row.spsize);
			if (size.toString() == 'NaN') return 0;

			var money = parseFloat(row.spmoney);
			if (money.toString() == 'NaN') return 0;

			return size * money;
		},

		formatType: function formatType(row, column) {
			return !!row.zpcode ? '赠品' : '';
		},

		formatTitle: function formatTitle(date, time) {
			return _util2.default.formatDate.format(new Date(date), "yyyy-MM-dd") + ' ' + time;
		},

		formatContent: function formatContent(content) {
			return content.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
		},

		collapseChange: function collapseChange(val) {
			if (val === "coll") {
				this.orderHeight = 343;
				this.orderColl = "隐藏";
			} else {
				this.orderHeight = 100;
				this.orderColl = "展开";
			}
		},

		getData: function getData() {
			var _this = this;
			_this.datas = [];
			if (!!_this.formData.code) {
				_this.loading = true;
				var para = {
					code: _this.formData.code
				};
				(0, _api.orderDetail)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var _data = data,
					    code = _data.code,
					    msg = _data.msg;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						data = data.data.list;
						if (!!data && data.length > 0) {
							var orderstep = data[0].orderstep;
							var index = 1;
							orderstep.forEach(function (ele) {
								var bZxg = ele.promotionsteptype === "4";

								ele.orderstep.forEach(function (innerEle) {
									var obj = {
										id: index,
										spcode: innerEle.spcode,
										spname: innerEle.spname,
										stepname: innerEle.orderstepname,
										spsize: innerEle.spsize,
										spmoney: innerEle.spmoney,
										spamount: parseFloat(innerEle.spsize) * parseFloat(innerEle.spmoney),
										spccomunitname: innerEle.spccomunitname,
										zpcode: bZxg ? '' : innerEle.spcode
									};
									_this.datas.push(obj);
									if (!!innerEle.zpinventorylist && innerEle.zpinventorylist.length > 0) {
										innerEle.zpinventorylist.forEach(function (zpItem) {
											var zpObj = {
												id: index,
												spcode: zpItem.zpcode,
												spname: zpItem.zpname,
												stepname: innerEle.orderstepname,
												spsize: zpItem.zpsize,
												spmoney: zpItem.zpmoney,
												spamount: parseFloat(zpItem.zpsize) * parseFloat(zpItem.zpmoney),
												spccomunitname: zpItem.zpccomunitname,
												zpcode: zpItem.zpcode
											};
											_this.datas.push(zpObj);
										});
									}
									index++;
								});
							});
						}
					}
				});
			}
		},

		checkWaybill: function checkWaybill() {
			var _this = this;
			_this.wayBillDatas = [];
			var noData = true;
			if (!!_this.formData.waybillcode) {
				var codes = _this.formData.waybillcode.split(',');
				if (!!codes && codes.length > 0) {
					noData = false;
					_this.wayBillDatas = codes;

					_this.wayBillDialogVisible = true;
				}
			}

			if (noData) {
				_this.$message({
					message: '没有可用运单号！',
					type: 'error'
				});
			}
		},

		clickWayBill: function clickWayBill(wb) {
			this.checkLogistics(wb);
		},

		checkLogistics: function checkLogistics(wayid) {
			var _this = this;
			_this.logisticsDatas = [];
			_this.logisticsBillNo = '';
			_this.logisticsStatu = '';
			if (!!wayid) {
				_this.loading = true;
				var para = {
					wid: wayid
				};
				(0, _api.findwaybill)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var code = data.code,
					    msg = data.msg;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						if (!!data.data && !!data.data.list && !!data.data.list.result) {
							var result = data.data.list.result;
							_this.logisticsBillNo = result.billno;
							_this.logisticsStatu = result.billnostate;
							if (!!result.tracks) {
								_this.logisticsDatas = data.data.list.result.tracks;
							}
						}

						_this.logisticsDialogVisible = true;
					}
				});
			}
		},

		openDialog: function openDialog() {},

		closeDialog: function closeDialog() {
			this.logisticsDialogVisible = false;
		},

		rowDrop: function rowDrop() {
			var tbody = document.querySelector('.el-table__body-wrapper tbody');
			var _this = this;
			_sortablejs2.default.create(tbody, {
				onEnd: function onEnd(_ref) {
					var newIndex = _ref.newIndex,
					    oldIndex = _ref.oldIndex;

					if (_this.sequenceArr.length > 1) {
						var currRow = _this.datas.splice(oldIndex, 1)[0];
						_this.datas.splice(newIndex, 0, currRow);
						_this.submitSortDisabled = false;

						for (var i = 0; i < _this.datas.length; i++) {
							_this.datas[i].sequence = _this.sequenceArr[i];
						}
					}
				}
			});
		},

		submitSort: function submitSort() {
			var _this = this;

			_this.idArr = _this.datas.map(function (item) {
				return item.id;
			});

			if (!!_this.idArr && !!_this.sequenceArr && _this.idArr.length === _this.sequenceArr.length) {
				_this.$confirm('确认提交排序结果？', '提示', {
					type: 'warning'
				}).then(function () {}).catch(function (error) {
					if (error !== 'cancel') {
						_this.$message({
							message: error.message ? error.message : error,
							type: 'error'
						});
					}
				});
			} else {
				_this.$message({
					message: '排序数据出现问题，请刷新后重试！',
					type: 'error'
				});
			}
		},

		preStep: function preStep() {
			this.$router.push({ path: '/order', query: { ps: this.oPageSize, pn: this.oPageNum } });
		},

		exportExcel: function exportExcel() {
			this.doExport();
		},

		doExport: function doExport() {
			var _this = this;

			if (!!_this.formData || !!_this.datas && _this.datas.length > 0) {
				var tabData2 = [];
				var i = 1;
				_this.datas.forEach(function (item) {
					var spData = {
						id: i,
						spcode: item.spcode,
						spname: item.spname,
						stepname: item.stepname,
						spsize: parseFloat(item.spsize),
						spmoney: parseFloat(item.spmoney),
						spamount: parseFloat(_this.formatAmount(item)),
						spccomunitname: item.spccomunitname,
						zpcode: _this.formatType(item)
					};
					tabData2.push(spData);
					i++;
				});

				var ths = [];
				var h2 = ['序号', '促销类别', '商品编号', '商品名称', '单位', '数量', '单价(元)', '合计(元)', '是否赠品'];
				var f2 = ['id', 'stepname', 'spcode', 'spname', 'spccomunitname', 'spsize', 'spmoney', 'spamount', 'zpcode'];
				ths.push(h2);

				var h3 = ['', '', '', '', '', '', '', '', ''];
				var h4 = ['备注', !_this.formData.remark ? '' : _this.formData.remark, '', '', '', '', '', '', ''];
				var h5 = ['收货地址', !_this.formData.finaladdress ? '' : _this.formData.finaladdress, '', '', '', '', '', '', ''];
				var h6 = ['收货人', !_this.formData.consignee ? '' : _this.formData.consignee, '电话', !_this.formData.linkphone ? '' : _this.formData.linkphone, '', '', '', '', ''];
				var h7 = ['培训公司', !_this.formData.aagencyname ? '' : _this.formData.aagencyname, '销售公司', !_this.formData.pagencyname ? '' : _this.formData.pagencyname, '代理1', !_this.formData.cagencyname ? '' : _this.formData.cagencyname, '', '代理2', !_this.formData.tagencyname ? '' : _this.formData.tagencyname];
				var h8 = ['订单编号', !_this.formData.code ? '' : _this.formData.code, '', '下单人', !_this.formData.ordercaretername ? '' : _this.formData.ordercaretername, '', '', '', ''];
				var h9 = ['订单日期', !_this.formData.creattime ? '' : _this.formData.creattime, '', '加盟商', !_this.formData.franchisee ? '' : _this.formData.franchisee, '', '', 'U8ID', !_this.formData.u8id ? '' : _this.formData.u8id];

				var h10 = ['', '', '', '订单商品详情表', '', '', '', '', ''];

				ths.push(h3);
				ths.push(h4);
				ths.push(h5);
				ths.push(h6);
				ths.push(h7);
				ths.push(h8);
				ths.push(h9);
				ths.push(h10);

				var fileName = _this.sysCnName + "_" + _util2.default.formatDate.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "_" + _this.$root.$route.name;

				_util2.default.exportJsonToExcelMultTh(fileName, (0, _stringify2.default)(tabData2), ths, f2);
			} else {
				this.$message({
					message: "没有需要导出的数据",
					type: 'warning'
				});
			}
		},

		getOrderData: function getOrderData() {
			var _this = this;

			_this.loading = true;
			var para = {
				oid: _this.oid
			};
			(0, _api.getOrderList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data2 = data,
				    code = _data2.code,
				    msg = _data2.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;
					data = data.find(function (item) {
						return item.id === _this.oid;
					});
					_this.formData = (0, _extends3.default)({}, data);

					if (_this.formData.ordertype === '1') _this.formData.ordertype = "活动订单";else if (_this.formData.ordertype === '2') _this.formData.ordertype = "促销订单";else _this.formData.ordertype = "";

					if (_this.formData.paystatus === '0') _this.formData.paystatus = "待支付";else if (_this.formData.paystatus === '1') _this.formData.paystatus = "已支付";else if (_this.formData.paystatus === '2') _this.formData.paystatus = "已发货";else if (_this.formData.paystatus === '3') _this.formData.paystatus = "已完成";else _this.formData.paystatus = "";

					_this.getData();
				}
			});
		},

		tableRowClassName: function tableRowClassName(_ref2) {
			var row = _ref2.row,
			    rowIndex = _ref2.rowIndex;

			if (!!row.zpcode) {
				return 'zp-row';
			}
			return '';
		}
	},

	created: function created() {
		this.loginId = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.uid, this);

		var query = this.$route.query;
		this.oid = query.oid;
		this.oPageSize = query.ps;
		this.oPageNum = query.pn;
	},

	mounted: function mounted() {
		var _this2 = this;

		var _this = this;
		_this.containerHeight = _this.$refs.orderViewcontainer.offsetHeight;

		_this.getOrderData();

		document.body.ondrop = function (event) {
			event.preventDefault();
			event.stopPropagation();
		};

		window.onresize = function () {
			return function () {
				if (!_this2.timer && !!_this.$refs.orderViewcontainer) {
					_this2.timer = true;
					_this.containerHeight = _this.$refs.orderViewcontainer.offsetHeight;
					var that = _this2;
					setTimeout(function () {
						that.timer = false;
					}, 100);
				}
			}();
		};
	}
};

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(11);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _sortablejs = __webpack_require__(68);

var _sortablejs2 = _interopRequireDefault(_sortablejs);

var _LayerPath = __webpack_require__(115);

var _LayerPath2 = _interopRequireDefault(_LayerPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		LayerPath: _LayerPath2.default
	},
	data: function data() {
		return {
			sysCnName: _emEnum2.default.cnName,
			sysEnName: _emEnum2.default.enName,

			layer: 3,

			loginId: '',

			pid: '',
			sid: '',
			steptitle: '',
			steptype: '',

			submitSortDisabled: true,
			idArr: [],
			sequenceArr: [],

			loading: false,
			containerHeight: 0,
			datas: []
		};
	},

	methods: {
		formatStartime: function formatStartime(row, column) {
			if (!!row.startime) {
				return _util2.default.formatDate.format(new Date(row.startime.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:ss');
			} else return row.startime;
		},

		formatEndtime: function formatEndtime(row, column) {
			if (!!row.endtime) {
				return _util2.default.formatDate.format(new Date(row.endtime.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:ss');
			} else return row.endtime;
		},

		promotionStepChange: function promotionStepChange(pid, sid, st, sp) {
			this.$refs.LayerPath.callBack();
			this.pid = pid;
			this.sid = sid;
			this.steptitle = st;
			this.steptype = sp;
			this.getData();
		},

		getData: function getData() {
			var _this2 = this;

			var _this = this;

			_this.loading = true;
			var para = {
				sid: _this.sid
			};
			(0, _api.getProcesslabelList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data = data,
				    code = _data.code,
				    msg = _data.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;

					_this2.$refs.LayerPath.changeData(_this2.layer, data);

					_this.datas = data;

					_this.idArr = [];
					_this.sequenceArr = [];
					_this.datas.forEach(function (item) {
						_this.sequenceArr.push(item.sequence);
					});
				}
			});
		},

		delData: function delData(index, row) {
			var _this = this;
			_this.$confirm('确认删除该促销标签？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					plid: row.id
				};
				(0, _api.deleteProcesslabel)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		enableData: function enableData(index, row) {
			var _this = this;
			_this.$confirm('确认' + (row.status === 0 ? '禁用' : '启用') + '该促销标签？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					plid: row.id,
					status: row.status === 0 ? '1' : '0'
				};
				(0, _api.enableProcesslabel)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		editData: function editData(index, row) {
			if (!row) {
				var q = {
					pid: this.pid,
					sid: this.sid,
					st: this.steptitle,
					sp: this.steptype,
					plid: ''
				};
				this.$router.push({ path: '/processLabelInventory', query: q });
			} else {
				var _q = {
					pid: this.pid,
					sid: this.sid,
					st: row.steptitle,
					sp: this.steptype,
					plid: row.id,
					ln: row.labelname,

					s: row.startime,
					e: row.endtime,
					r: row.remark
				};
				this.$router.push({ path: '/processLabelInventory', query: _q });
			}
		},

		rowDrop: function rowDrop() {
			var tbody = document.querySelector('.el-table__body-wrapper tbody');
			var _this = this;
			_sortablejs2.default.create(tbody, {
				onEnd: function onEnd(_ref) {
					var newIndex = _ref.newIndex,
					    oldIndex = _ref.oldIndex;

					if (_this.sequenceArr.length > 1) {
						var currRow = _this.datas.splice(oldIndex, 1)[0];
						_this.datas.splice(newIndex, 0, currRow);
						_this.submitSortDisabled = false;

						for (var i = 0; i < _this.datas.length; i++) {
							_this.datas[i].sequence = _this.sequenceArr[i];
						}
					}
				}
			});
		},

		submitSort: function submitSort() {
			var _this = this;

			_this.idArr = _this.datas.map(function (item) {
				return item.id;
			});

			if (!!_this.idArr && !!_this.sequenceArr && _this.idArr.length === _this.sequenceArr.length) {
				_this.$confirm('确认提交排序结果？', '提示', {
					type: 'warning'
				}).then(function () {
					_this.loading = true;
					var para = {
						plid: _this.idArr,
						sequence: _this.sequenceArr
					};
					(0, _api.sortProcesslabel)(para, _this).then(function (res) {
						return res.data;
					}).then(function (data) {
						_this.loading = false;
						var msg = data.msg,
						    code = data.code;

						if (code !== "0") {
							_this.$message({
								message: msg,
								type: 'error'
							});
						} else {
							_this.$message({
								message: msg,
								type: 'success'
							});
							_this.getData();
						}
					});
				}).catch(function (error) {
					if (error !== 'cancel') {
						_this.$message({
							message: error.message ? error.message : error,
							type: 'error'
						});
					}
				});
			} else {
				_this.$message({
					message: '排序数据出现问题，请刷新后重试！',
					type: 'error'
				});
			}
		},

		handleRowChange: function handleRowChange(row, event, column) {},

		preStep: function preStep() {
			this.$router.push({ path: '/promotionStep', query: { pid: this.pid } });
		},

		exportExcel: function exportExcel() {
			var _this = this;

			_this.loading = true;
			var para = {
				sid: _this.sid
			};
			(0, _api.getProcesslabelList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data2 = data,
				    code = _data2.code,
				    msg = _data2.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;
					_this.doExport(data);
				}
			});
		},

		doExport: function doExport(tabData) {
			var _this = this;

			if (!!tabData && tabData.length > 0) {
				var i = 1;
				tabData.forEach(function (item) {
					item.id = i;
					i++;
				});

				var fileName = _this.sysCnName + "_" + _util2.default.formatDate.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "_" + _this.$root.$route.name;

				var tHeader = ['序号', '名称', '父级促销步骤', '备注'];
				var filterVal = ['id', 'labelname', 'steptitle', 'remark'];
				_util2.default.exportJsonToExcel(fileName, (0, _stringify2.default)(tabData), tHeader, filterVal);
			} else {
				this.$message({
					message: "没有需要导出的数据",
					type: 'warning'
				});
			}
		}
	},

	created: function created() {
		this.loginId = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.uid, this);

		var query = this.$route.query;
		this.pid = query.pid;
		this.sid = query.sid;
		this.steptitle = query.st;
		this.steptype = query.sp;
	},

	mounted: function mounted() {
		var _this3 = this;

		var _this = this;
		_this.containerHeight = _this.$refs.processlabelcontainer.offsetHeight;

		_this.$refs.LayerPath.changeVal(_this.layer - 1, _this.sid);
		_this.$refs.LayerPath.changeVal(_this.layer - 2, _this.pid);

		_this.getData();

		document.body.ondrop = function (event) {
			event.preventDefault();
			event.stopPropagation();
		};

		_this.rowDrop();

		window.onresize = function () {
			return function () {
				if (!_this3.timer && !!_this.$refs.processlabelcontainer) {
					_this3.timer = true;
					_this.containerHeight = _this.$refs.processlabelcontainer.offsetHeight;
					var that = _this3;
					setTimeout(function () {
						that.timer = false;
					}, 100);
				}
			}();
		};
	}
};

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(11);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _sortablejs = __webpack_require__(68);

var _sortablejs2 = _interopRequireDefault(_sortablejs);

var _LayerPath = __webpack_require__(115);

var _LayerPath2 = _interopRequireDefault(_LayerPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		LayerPath: _LayerPath2.default
	},
	data: function data() {
		return {
			sysCnName: _emEnum2.default.cnName,
			sysEnName: _emEnum2.default.enName,

			loginId: '',

			pid: '',
			sid: '',
			steptitle: '',
			steptype: '',
			plid: '',

			submitSortDisabled: true,
			idArr: [],
			sequenceArr: [],

			loading: false,
			containerHeight: 0,
			datas: [],
			allDatas: [],
			labelCodeDisabled: false,
			steptitleDisabled: true,
			submitDisabled: false,
			labelFormData: {
				plid: '',
				labelname: '',
				remark: '' },
			labelRules: {
				labelname: [{ required: true, message: '请输入标签名称', trigger: 'blur' }]
			},

			addFormData: {
				icode: '',
				zpcode: '',
				icodesize: '',
				zpcodesize: '',
				remark: '' },
			addRules: {
				icode: [{ required: true, message: '请选择商品', trigger: 'change' }],
				zpcode: [{ required: true, message: '请选择赠品商品', trigger: 'change' }],
				icodesize: [{ required: true, message: '请输入商品数量', trigger: 'blur' }],
				zpcodesize: [{ required: true, message: '请输入赠品数量', trigger: 'blur' }]
			},
			vagueContentSp: '',
			spDatas: [],
			vagueContentZp: '',
			zpDatas: [],

			addZpDisabled: true,
			editZpDisabled: true,
			dialogTitle: '',
			editDialogVisible: false,
			formData: {
				Pliid: '',
				icode: '',
				zpcode: '',
				icodesize: '',
				zpcodesize: '',
				remark: '' },
			rules: {
				icode: [{ required: true, message: '请选择商品', trigger: 'change' }],
				zpcode: [{ required: true, message: '请选择赠品商品', trigger: 'change' }],
				icodesize: [{ required: true, message: '请输入商品数量', trigger: 'blur' }],
				zpcodesize: [{ required: true, message: '请输入赠品数量', trigger: 'blur' }]
			},

			vagueContent: '' };
	},

	methods: {
		number: function number() {
			this.addFormData.icodesize = this.addFormData.icodesize.replace(/[^\.\d]/g, '');
			this.addFormData.icodesize = this.addFormData.icodesize.replace('.', '');
			if (!!this.addFormData.icodesize && parseInt(this.addFormData.icodesize) === 0) {
				this.addFormData.icodesize = 1;
			}
		},
		zpnumber: function zpnumber() {
			this.addFormData.zpcodesize = this.addFormData.zpcodesize.replace(/[^\.\d]/g, '');
			this.addFormData.zpcodesize = this.addFormData.zpcodesize.replace('.', '');
			if (!!this.addFormData.zpcodesize && parseInt(this.addFormData.zpcodesize) === 0) {
				this.addFormData.zpcodesize = 1;
			}
		},
		editnumber: function editnumber() {
			this.formData.icodesize = this.formData.icodesize.replace(/[^\.\d]/g, '');
			this.formData.icodesize = this.formData.icodesize.replace('.', '');
			if (!!this.formData.icodesize && parseInt(this.formData.icodesize) === 0) {
				this.formData.icodesize = 1;
			}
		},
		editzpnumber: function editzpnumber() {
			this.formData.zpcodesize = this.formData.zpcodesize.replace(/[^\.\d]/g, '');
			this.formData.zpcodesize = this.formData.zpcodesize.replace('.', '');
			if (!!this.formData.zpcodesize && parseInt(this.formData.zpcodesize) === 0) {
				this.formData.zpcodesize = 1;
			}
		},

		formatIcodesize: function formatIcodesize(row, column) {
			if (!!row.icodesize && row.icodesize !== "0") return row.icodesize;else return '';
		},

		formatZpname: function formatZpname(row, column) {
			if (!!row.zpcode) return row.zpname;else return '';
		},
		formatZpcodesize: function formatZpcodesize(row, column) {
			if (!!row.zpcode) return row.zpcodesize;else return '';
		},

		handleLabelSubmit: function handleLabelSubmit(formName) {
			var _this2 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					var _this = _this2;
					_this.$confirm('确认' + (!_this.labelFormData.plid ? '添加' : '编辑') + '促销标签？', '提示', {
						type: 'warning'
					}).then(function () {
						_this.loading = true;
						if (!_this.labelFormData.plid) {
							var para = {
								pid: _this.pid,
								sid: _this.sid,
								labelname: _this.labelFormData.labelname,

								remark: _this.labelFormData.remark
							};
							(0, _api.addProcesslabel)(para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});

									var result = data.data.list;
									_this.labelFormData.plid = result.id;
								}
							});
						} else {
							var _para = {
								plid: _this.labelFormData.plid,

								labelname: _this.labelFormData.labelname,

								remark: _this.labelFormData.remark
							};
							(0, _api.editProcesslabel)(_para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
								}
							});
						}
					}).catch(function (error) {
						if (error !== 'cancel') {
							_this.$message({
								message: error.message ? error.message : error,
								type: 'error'
							});
						}
					});
				} else {
					return false;
				}
			});
		},

		promotionLabelChange: function promotionLabelChange(pid, sid, st, sp, plid, ln, s, e, r) {
			this.$refs.LayerPath.callBack();
			this.pid = pid;
			this.sid = sid;
			this.steptitle = st;
			this.steptype = sp;
			this.plid = plid;
			this.labelFormData.plid = plid;
			if (!!this.labelFormData.plid) {
				this.labelCodeDisabled = true;
				this.labelFormData.labelname = ln;

				this.labelFormData.startime = s;
				this.labelFormData.endtime = e;
				this.labelFormData.remark = r;
			} else {
				this.labelCodeDisabled = false;
			}
			this.getData();
		},

		getData: function getData() {
			var _this = this;

			if (!!_this.labelFormData.plid) {
				_this.loading = true;
				_this.closeDialog();
				var para = {
					plid: _this.labelFormData.plid
				};
				(0, _api.getProcesslabelInventoryList)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var _data = data,
					    code = _data.code,
					    msg = _data.msg;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						data = data.data.list;
						_this.allDatas = data;
						_this.datas = _this.allDatas;
					}
				});
			}
		},

		searchSpList: function searchSpList(query) {
			var _this = this;

			_this.vagueContentSp = query;
			_this.loading = true;
			var para = {
				vague: _this.vagueContentSp,
				pageNum: 1,
				pageSize: 10000
			};
			(0, _api.inventoryVague)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data2 = data,
				    code = _data2.code,
				    msg = _data2.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;
					_this.spDatas = data.filter(function (item) {
						return item.status === 0;
					});
				}
			});
		},
		searchZpList: function searchZpList(query) {
			var _this = this;

			_this.vagueContentZp = query;
			_this.loading = true;
			var para = {
				vague: _this.vagueContentZp
			};
			(0, _api.inventoryVague)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data3 = data,
				    code = _data3.code,
				    msg = _data3.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;
					_this.zpDatas = data.filter(function (item) {
						return item.status === 0;
					});
				}
			});
		},

		searchList: function searchList() {
			var _this = this;

			if (!!_this.vagueContent) {
				_this.datas = _this.allDatas.filter(function (item) {
					return !!item.name && item.name.indexOf(_this.vagueContent) >= 0 || !!item.zpname && item.zpname.indexOf(_this.vagueContent) >= 0;
				});
			} else {
				_this.datas = _this.allDatas;
			}
		},

		delData: function delData(index, row) {
			var _this = this;
			_this.$confirm('确认删除该促销标签商品？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					pliid: row.id
				};
				(0, _api.deleteProcesslabelinventory)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		enableData: function enableData(index, row) {
			var _this = this;
			_this.$confirm('确认' + (row.status === 0 ? '禁用' : '启用') + '该促销标签商品？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					pliid: row.id,
					status: row.status === 0 ? '1' : '0'
				};
				(0, _api.enableProcesslabelInventory)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		resetForm: function resetForm(formName) {
			this.$refs[formName].resetFields();
		},

		editData: function editData(index, row) {
			var formName = 'formData';

			this.editDialogVisible = true;

			if (!row) {
				this.dialogTitle = "添加";
				if (this.$refs[formName]) this.$refs[formName].resetFields();
				this.formData.pliid = "";
				this.formData.icode = "";
				this.formData.zpcode = "";
				this.formData.icodesize = "";
				this.formData.zpcodesize = "";
				this.formData.remark = "";
			} else {
				this.dialogTitle = "编辑";
				this.formData.pliid = row.id;
				this.formData.icode = row.icode;
				this.formData.zpcode = row.zpcode;
				this.formData.icodesize = this.formatIcodesize(row);
				this.formData.zpcodesize = !!row.zpcode ? row.zpcodesize : '';
				this.formData.remark = row.remark;

				if (!!row.icode && !this.spDatas.some(function (a) {
					return a.code === row.icode;
				})) {
					this.spDatas.push({ code: row.icode, name: row.name });
				}
				if (!!row.zpcode && !this.zpDatas.some(function (a) {
					return a.code === row.zpcode;
				})) {
					this.zpDatas.push({ code: row.zpcode, name: row.zpname });
				}

				this.codeSizeChange('edit');
			}
		},

		openDialog: function openDialog() {
			var ele = document.getElementById('focus-ele');
			if (!!ele) {
				ele.focus();
			}
		},

		closeDialog: function closeDialog() {
			this.editDialogVisible = false;
		},

		handleAddSubmit: function handleAddSubmit(formName) {
			var _this3 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					var _this = _this3;

					if (!!_this.addFormData.icode) {
						var sp = _this.allDatas.filter(function (item) {
							return item.icode === _this.addFormData.icode;
						});
						if (!!sp && sp.length > 0) {
							_this.$message({
								message: '商品【' + sp[0].iname + '】已存在，不能重复添加！',
								type: 'error'
							});
							return;
						}
					}

					_this.loading = true;
					var para = {
						plid: _this.labelFormData.plid,
						remark: _this.addFormData.remark
					};

					if (!!_this.addFormData.icode) para['icode'] = _this.addFormData.icode;
					if (!!_this.addFormData.zpcode) para['zpcode'] = _this.addFormData.zpcode;

					if (!!_this.addFormData.icodesize || _this.addFormData.icodesize === 0 || _this.addFormData.icodesize === '0') para['icodesize'] = _this.addFormData.icodesize;
					if (!!_this.addFormData.zpcodesize || _this.addFormData.zpcodesize === 0 || _this.addFormData.zpcodesize === '0') para['zpcodesize'] = _this.addFormData.zpcodesize;

					(0, _api.addProcesslabelInventory)(para, _this).then(function (res) {
						return res.data;
					}).then(function (data) {
						_this.loading = false;
						var msg = data.msg,
						    code = data.code;

						if (code !== "0") {
							_this.$message({
								message: msg,
								type: 'error'
							});
						} else {
							_this.$message({
								message: msg,
								type: 'success'
							});

							_this.addFormData.icode = '';
							_this.addFormData.zpcode = '';
							_this.addFormData.icodesize = '';
							_this.addFormData.zpcodesize = '';
							_this.addFormData.remark = '';
							_this.codeSizeChange('add');

							_this.getData();
						}
					});
				} else {
					return false;
				}
			});
		},

		handleSubmit: function handleSubmit(formName) {
			var _this4 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					var _this = _this4;
					_this.$confirm('确认' + _this.dialogTitle + '促销标签商品？', '提示', {
						type: 'warning'
					}).then(function () {
						_this.loading = true;
						if (!_this.formData.pliid) {
							var para = {
								plid: _this.labelFormData.plid,
								remark: _this.formData.remark
							};

							if (!!_this.formData.icode) para['icode'] = _this.formData.icode;
							if (!!_this.formData.zpcode) para['zpcode'] = _this.formData.zpcode;

							if (!!_this.formData.icodesize || _this.formData.icodesize === 0 || _this.formData.icodesize === '0') para['icodesize'] = _this.formData.icodesize;
							if (!!_this.formData.zpcodesize || _this.formData.zpcodesize === 0 || _this.formData.zpcodesize === '0') para['zpcodesize'] = _this.formData.zpcodesize;

							(0, _api.addProcesslabelInventory)(para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						} else {
							var _para2 = {
								pliid: _this.formData.pliid,
								plid: _this.labelFormData.plid,

								icode: _this.formData.icode,
								zpcode: _this.formData.zpcode,
								icodesize: _this.formData.icodesize,
								zpcodesize: _this.formData.zpcodesize,
								remark: _this.formData.remark
							};


							(0, _api.editProcesslabelInventory)(_para2, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						}
					}).catch(function (error) {
						if (error !== 'cancel') {
							_this.$message({
								message: error.message ? error.message : error,
								type: 'error'
							});
						}
					});
				} else {
					return false;
				}
			});
		},

		rowDrop: function rowDrop() {
			var tbody = document.querySelector('.el-table__body-wrapper tbody');
			var _this = this;
			_sortablejs2.default.create(tbody, {
				onEnd: function onEnd(_ref) {
					var newIndex = _ref.newIndex,
					    oldIndex = _ref.oldIndex;

					if (_this.sequenceArr.length > 1) {
						var currRow = _this.datas.splice(oldIndex, 1)[0];
						_this.datas.splice(newIndex, 0, currRow);
						_this.submitSortDisabled = false;

						for (var i = 0; i < _this.datas.length; i++) {
							_this.datas[i].sequence = _this.sequenceArr[i];
						}
					}
				}
			});
		},

		submitSort: function submitSort() {
			var _this = this;

			_this.idArr = _this.datas.map(function (item) {
				return item.id;
			});

			if (!!_this.idArr && !!_this.sequenceArr && _this.idArr.length === _this.sequenceArr.length) {
				_this.$confirm('确认提交排序结果？', '提示', {
					type: 'warning'
				}).then(function () {}).catch(function (error) {
					if (error !== 'cancel') {
						_this.$message({
							message: error.message ? error.message : error,
							type: 'error'
						});
					}
				});
			} else {
				_this.$message({
					message: '排序数据出现问题，请刷新后重试！',
					type: 'error'
				});
			}
		},

		handleRowChange: function handleRowChange(row, event, column) {},

		preStep: function preStep() {
			this.$router.push({ path: '/processLabel', query: { pid: this.pid, sid: this.sid, st: this.steptitle, sp: this.steptype } });
		},

		exportExcel: function exportExcel() {
			var _this = this;
			if (!!_this.labelFormData.plid) {
				_this.loading = true;
				_this.closeDialog();
				var para = {
					plid: _this.labelFormData.plid
				};
				(0, _api.getProcesslabelInventoryList)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var _data4 = data,
					    code = _data4.code,
					    msg = _data4.msg;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						data = data.data.list;
						_this.doExport(data);
					}
				});
			}
		},

		doExport: function doExport(tabData) {
			var _this = this;

			if (!!tabData && tabData.length > 0) {
				var i = 1;
				tabData.forEach(function (item) {
					item.id = i;
					item.refsaleprice = parseFloat(item.refsaleprice);
					item.icodesize = parseFloat(item.icodesize);
					item.zpname = _this.formatZpname(item);
					item.zpcodesize = _this.formatZpcodesize(item);
					i++;
				});

				var fileName = _this.sysCnName + "_" + _util2.default.formatDate.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "_" + _this.$root.$route.name;

				var tHeader = ['序号', '商品名称', '单价', '数量', '赠品商品', '赠品数量', '备注'];
				var filterVal = ['id', 'name', 'refsaleprice', 'icodesize', 'zpname', 'zpcodesize', 'remark'];
				_util2.default.exportJsonToExcel(fileName, (0, _stringify2.default)(tabData), tHeader, filterVal);
			} else {
				this.$message({
					message: "没有需要导出的数据",
					type: 'warning'
				});
			}
		},

		clearInventory: function clearInventory(val) {
			if (val == 'sp') {
				this.addFormData.icode = '';
			} else if (val == 'zp') {
				this.addFormData.zpcode = '';
			} else if (val == 'editsp') {
				this.formData.icode = '';
			} else if (val == 'editzp') {
				this.formData.zpcode = '';
			}
		},

		followInventory: function followInventory(val) {
			var _this = this;
			if (val == 'zp') {
				if (!!_this.addFormData.icode && !_this.zpDatas.some(function (a) {
					return a.code === _this.addFormData.icode;
				})) {
					var sp = _this.spDatas.find(function (item) {
						return item.code === _this.addFormData.icode;
					});
					if (!!sp) {
						_this.zpDatas.push({ code: sp.code, name: sp.name });
					}
				}
				_this.addFormData.zpcode = _this.addFormData.icode;
			} else if (val == 'editzp') {
				if (!!_this.formData.icode && !_this.zpDatas.some(function (a) {
					return a.code === _this.formData.icode;
				})) {
					var _sp = _this.spDatas.find(function (item) {
						return item.code === _this.formData.icode;
					});
					if (!!_sp) {
						_this.zpDatas.push({ code: _sp.code, name: _sp.name });
					}
				}
				_this.formData.zpcode = _this.formData.icode;
			}
		},

		codeSizeChange: function codeSizeChange(val) {
			if (val === 'add') {
				if (this.steptype == 1 || this.steptype == 4) {
					if (!this.addFormData.icodesize) {
						this.addZpDisabled = true;
						this.addRules.zpcode[0].required = false;
						this.addRules.zpcodesize[0].required = false;

						this.addFormData.zpcode = '';
						this.addFormData.zpcodesize = '';
					} else {
						this.addZpDisabled = false;
						this.addRules.zpcode[0].required = true;
						this.addRules.zpcodesize[0].required = true;
					}
				} else {
					this.addZpDisabled = false;
					this.addRules.zpcode[0].required = true;
					this.addRules.zpcodesize[0].required = true;
				}
			} else if (val === 'edit') {
				if (this.steptype == 1 || this.steptype == 4) {
					if (!this.formData.icodesize) {
						this.editZpDisabled = true;
						this.rules.zpcode[0].required = false;
						this.rules.zpcodesize[0].required = false;

						this.formData.zpcode = '';
						this.formData.zpcodesize = '';
					} else {
						this.editZpDisabled = false;
						this.rules.zpcode[0].required = true;
						this.rules.zpcodesize[0].required = true;
					}
				} else {
					this.editZpDisabled = false;
					this.rules.zpcode[0].required = true;
					this.rules.zpcodesize[0].required = true;
				}
			}
		}
	},

	created: function created() {
		this.loginId = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.uid, this);

		var query = this.$route.query;
		this.pid = query.pid;
		this.sid = query.sid;
		this.steptitle = query.st;
		this.steptype = query.sp;
		this.plid = query.plid;
		this.labelFormData.plid = query.plid;
		if (!!this.labelFormData.plid) {
			this.labelCodeDisabled = true;
			this.labelFormData.labelname = query.ln;

			this.labelFormData.startime = query.s;
			this.labelFormData.endtime = query.e;
			this.labelFormData.remark = query.r;
		} else {
			this.labelCodeDisabled = false;
		}
	},

	mounted: function mounted() {
		var _this5 = this;

		var _this = this;
		_this.containerHeight = _this.$refs.processLabelInventorycontainer.offsetHeight;

		_this.$refs.LayerPath.changeVal(1, _this.pid);
		_this.$refs.LayerPath.changeVal(2, _this.sid);
		_this.$refs.LayerPath.changeVal(3, _this.plid);

		_this.getData();

		if (_this.steptype == 1 || _this.steptype == 4) {
			_this.addRules.icode[0].required = true;
			_this.addRules.zpcode[0].required = false;
			_this.addRules.zpcodesize[0].required = false;
			_this.rules.icode[0].required = true;
			_this.rules.zpcode[0].required = false;
			_this.rules.zpcodesize[0].required = false;
		} else {
			_this.addRules.icode[0].required = false;
			_this.addRules.zpcode[0].required = true;
			_this.addRules.zpcodesize[0].required = true;
			_this.rules.icode[0].required = false;
			_this.rules.zpcode[0].required = true;
			_this.rules.zpcodesize[0].required = true;

			_this.addZpDisabled = false;
			_this.editZpDisabled = false;
		}

		document.body.ondrop = function (event) {
			event.preventDefault();
			event.stopPropagation();
		};

		_this.rowDrop();

		window.onresize = function () {
			return function () {
				if (!_this5.timer && !!_this.$refs.processLabelInventorycontainer) {
					_this5.timer = true;
					_this.containerHeight = _this.$refs.processLabelInventorycontainer.offsetHeight;
					var that = _this5;
					setTimeout(function () {
						that.timer = false;
					}, 100);
				}
			}();
		};
	}
};

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(11);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _sortablejs = __webpack_require__(68);

var _sortablejs2 = _interopRequireDefault(_sortablejs);

var _UploadFile = __webpack_require__(52);

var _UploadFile2 = _interopRequireDefault(_UploadFile);

var _LayerPath = __webpack_require__(115);

var _LayerPath2 = _interopRequireDefault(_LayerPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		UploadFile: _UploadFile2.default,
		LayerPath: _LayerPath2.default
	},
	data: function data() {
		return {
			sysCnName: _emEnum2.default.cnName,
			sysEnName: _emEnum2.default.enName,

			layer: 1,

			loginId: '',

			submitSortDisabled: true,
			idArr: [],
			sequenceArr: [],

			loading: false,
			containerHeight: 0,
			datas: [],

			copyDisabled: true,
			copyId: '',
			copyTitle: '',

			codeDisabled: true,
			roleOptions: _emEnum2.default.roleOptions,
			promotionTypeOptions: _emEnum2.default.promotionTypeOptions,
			useVoucherOptions: _emEnum2.default.useVoucherOptions,
			dialogTitle: '',
			dialogBtnVal: '',
			editDialogVisible: false,
			voucherUnEditable: false,

			formData: {
				pid: '',
				startime: '',
				endtime: '',
				title: '',
				cashpromote: '',
				promotiontype: '',
				highimage: '',
				thumimage: '',
				usevoucher: '',
				voucherrate: '',
				voucheramount: '' },
			rules: {
				title: [{ required: true, message: '请输入促销标题', trigger: 'blur' }],
				promotiontype: [{ required: true, message: '请选择促销类型', trigger: 'change' }],
				cashpromote: [{ required: true, message: '请输入现金促销', trigger: 'blur' }],
				usevoucher: [{ required: true, message: '请选择是否可用返单券', trigger: 'change' }],
				voucherrate: [{ required: true, message: '请选择返单券比例', trigger: 'change' }],
				voucheramount: [{ required: true, message: '请输入返单券金额', trigger: 'blur' }],
				startime: [{ required: true, message: '请选择促销开始日期', trigger: 'change' }],
				endtime: [{ required: true, message: '请选择促销结束日期', trigger: 'change' }]
			}
		};
	},

	methods: {
		formatStatus: function formatStatus(row, column) {
			return row.status === 0 ? "是" : row.status === 1 ? "否" : "待审核";
		},

		formatStartime: function formatStartime(row, column) {
			if (isNaN(row.startime) && !isNaN(Date.parse(row.startime))) {
				return _util2.default.formatDate.format(new Date(row.startime.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:ss');
			} else return row.startime;
		},

		formatEndtime: function formatEndtime(row, column) {
			if (isNaN(row.endtime) && !isNaN(Date.parse(row.endtime))) {
				return _util2.default.formatDate.format(new Date(row.endtime.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:ss');
			} else return row.endtime;
		},

		formatPromotionType: function formatPromotionType(row, column) {
			var typeOp = _emEnum2.default.promotionTypeOptions.find(function (item) {
				return item.key === row.promotiontype;
			});
			if (!typeOp) return '';else return typeOp.value;
		},

		formatUseVoucher: function formatUseVoucher(row, column) {
			var useOp = _emEnum2.default.useVoucherOptions.find(function (item) {
				return item.key === row.usevoucher;
			});
			if (!useOp) return '';else return useOp.value;
		},

		cash: function cash() {
			this.formData.cashpromote = this.formData.cashpromote.replace(/[^\.\d]/g, '');
			this.formData.cashpromote = this.formData.cashpromote.replace(/^\./g, '');
			var temp = this.formData.cashpromote.replace(/\./g, '');
			if (this.formData.cashpromote.length >= temp.length + 2) {
				this.formData.cashpromote = this.formData.cashpromote.substr(0, this.formData.cashpromote.length - 1);
			}
		},

		usevoucherChange: function usevoucherChange() {
			if (this.formData.usevoucher === 0) {
				this.voucherUnEditable = true;
			} else {
				this.voucherUnEditable = false;
			}
		},

		getData: function getData() {
			var _this2 = this;

			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {};
			(0, _api.getPromotionList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data = data,
				    code = _data.code,
				    msg = _data.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;

					_this2.$refs.LayerPath.changeData(_this2.layer, data);
					_this2.$refs.LayerPath.changeData(_this2.layer + 1, '');
					_this2.$refs.LayerPath.changeData(_this2.layer + 2, '');

					_this.datas = data;

					_this.idArr = [];
					_this.sequenceArr = [];
					_this.datas.forEach(function (item) {
						_this.sequenceArr.push(item.sequence);
					});
				}
			});
		},

		delData: function delData(index, row) {
			var _this = this;
			_this.$confirm('确认删除该促销活动？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					pid: row.id
				};
				(0, _api.deletePromotion)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		enableData: function enableData(index, row) {
			var _this = this;
			_this.$confirm('确认' + (row.status === 0 ? '下架' : '发布') + '该促销活动？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					pid: row.id,
					status: row.status === 0 ? '1' : '0'
				};
				(0, _api.enablePromotion)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		resetForm: function resetForm(formName) {
			this.$refs[formName].resetFields();
		},

		editData: function editData(index, row) {
			var formName = 'formData';

			this.editDialogVisible = true;

			if (!row) {
				this.dialogTitle = "添加";
				this.dialogBtnVal = "上传图片";
				this.codeDisabled = false;
				if (this.$refs[formName]) this.$refs[formName].resetFields();
				this.formData.pid = "";

				this.formData.startime = "";
				this.formData.endtime = "";
				this.formData.title = "";
				this.formData.cashpromote = "";

				this.formData.promotiontype = this.promotionTypeOptions[0].key;
				this.formData.highimage = "";
				this.formData.thumimage = "";

				this.formData.usevoucher = 1;
				this.formData.voucherrate = 0;
				this.formData.voucheramount = "";
			} else {
				this.dialogTitle = "编辑";
				this.dialogBtnVal = "重新上传";
				this.codeDisabled = true;
				this.formData.pid = row.id;

				this.formData.startime = row.startime;
				this.formData.endtime = row.endtime;
				this.formData.title = row.title;
				this.formData.cashpromote = row.cashpromote;

				this.formData.promotiontype = row.promotiontype;
				this.formData.highimage = row.highimage;
				this.formData.thumimage = row.thumimage;

				this.formData.usevoucher = row.usevoucher;

				var rate = parseInt(row.voucherrate);
				if (isNaN(rate)) {
					this.formData.voucherrate = 0;
				} else {
					this.formData.voucherrate = rate;
				}
				this.formData.voucheramount = row.voucheramount;
			}
		},

		copyData: function copyData(index, row) {
			var _this = this;
			if (!!_this.copyId) {
				_this.$confirm('确认复制促销活动：' + _this.copyTitle + '？', '提示', {
					type: 'warning'
				}).then(function () {
					_this.loading = true;
					var para = {
						pid: _this.copyId
					};
					_this.loading = false;
					(0, _api.promotionCopy)(para, _this).then(function (res) {
						return res.data;
					}).then(function (data) {
						_this.loading = false;
						var msg = data.msg,
						    code = data.code;

						if (code !== "0") {
							_this.$message({
								message: msg,
								type: 'error'
							});
						} else {
							_this.$message({
								message: msg,
								type: 'success'
							});
							_this.getData();
						}
					});
				}).catch(function (error) {
					if (error !== 'cancel') {
						_this.$message({
							message: error.message ? error.message : error,
							type: 'error'
						});
					}
				});
			} else {
				_this.$message({
					message: '请先选择要复制的促销活动！',
					type: 'warning'
				});
			}
		},

		openDialog: function openDialog() {
			this.$refs.UploadFile.changeFileUrl(this.formData.thumimage, this.dialogBtnVal);

			var ele = document.getElementById('focus-ele');
			if (!!ele) {
				ele.focus();
			}
		},

		closeDialog: function closeDialog() {
			this.editDialogVisible = false;
		},

		handleSubmit: function handleSubmit(formName) {
			var _this3 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					var _this = _this3;
					_this.$confirm('确认' + _this.dialogTitle + '促销活动？', '提示', {
						type: 'warning'
					}).then(function () {
						_this.loading = true;
						if (!_this.formData.pid) {
							var para = {
								startime: _this.formData.startime,
								endtime: _this.formData.endtime,
								title: _this.formData.title,
								cashpromote: _this.formData.cashpromote,
								promotiontype: _this.formData.promotiontype,
								highimage: _this.formData.highimage,
								thumimage: _this.formData.highimage,

								usevoucher: _this.formData.usevoucher,
								voucherrate: _this.formData.voucherrate,
								voucheramount: _this.formData.voucheramount
							};
							(0, _api.addPromotion)(para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						} else {
							var _para = {
								pid: _this.formData.pid,

								startime: _this.formData.startime,
								endtime: _this.formData.endtime,
								title: _this.formData.title,
								cashpromote: _this.formData.cashpromote,
								promotiontype: _this.formData.promotiontype,
								highimage: _this.formData.highimage,
								thumimage: _this.formData.highimage,

								usevoucher: _this.formData.usevoucher,
								voucherrate: _this.formData.voucherrate,
								voucheramount: _this.formData.voucheramount
							};
							(0, _api.editPromotion)(_para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						}
					}).catch(function (error) {
						if (error !== 'cancel') {
							_this.$message({
								message: error.message ? error.message : error,
								type: 'error'
							});
						}
					});
				} else {
					return false;
				}
			});
		},

		rowDrop: function rowDrop() {
			var tbody = document.querySelector('.el-table__body-wrapper tbody');
			var _this = this;
			_sortablejs2.default.create(tbody, {
				onEnd: function onEnd(_ref) {
					var newIndex = _ref.newIndex,
					    oldIndex = _ref.oldIndex;

					if (_this.sequenceArr.length > 1) {
						var currRow = _this.datas.splice(oldIndex, 1)[0];
						_this.datas.splice(newIndex, 0, currRow);
						_this.submitSortDisabled = false;

						for (var i = 0; i < _this.datas.length; i++) {
							_this.datas[i].sequence = _this.sequenceArr[i];
						}
					}
				}
			});
		},

		submitSort: function submitSort() {
			var _this = this;

			_this.idArr = _this.datas.map(function (item) {
				return item.id;
			});

			if (!!_this.idArr && !!_this.sequenceArr && _this.idArr.length === _this.sequenceArr.length) {
				_this.$confirm('确认提交排序结果？', '提示', {
					type: 'warning'
				}).then(function () {
					_this.loading = true;
					var para = {
						pid: _this.idArr,
						sequence: _this.sequenceArr
					};
					(0, _api.sortPromotion)(para, _this).then(function (res) {
						return res.data;
					}).then(function (data) {
						_this.loading = false;
						var msg = data.msg,
						    code = data.code;

						if (code !== "0") {
							_this.$message({
								message: msg,
								type: 'error'
							});
						} else {
							_this.$message({
								message: msg,
								type: 'success'
							});
							_this.getData();
						}
					});
				}).catch(function (error) {
					if (error !== 'cancel') {
						_this.$message({
							message: error.message ? error.message : error,
							type: 'error'
						});
					}
				});
			} else {
				_this.$message({
					message: '排序数据出现问题，请刷新后重试！',
					type: 'error'
				});
			}
		},

		handleRowChange: function handleRowChange(row, event, column) {
			if (!row.id) {
				this.copyDisabled = true;
				this.copyId = '';
				this.copyTitle = '';
			} else {
				this.copyDisabled = false;
				this.copyId = row.id;
				this.copyTitle = row.title;
			}
		},

		nextStep: function nextStep(index, row) {
			this.$router.push({ path: '/promotionStep', query: { pid: row.id } });
		},

		exportExcel: function exportExcel() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {};
			(0, _api.getPromotionList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data2 = data,
				    code = _data2.code,
				    msg = _data2.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;
					_this.doExport(data);
				}
			});
		},

		doExport: function doExport(tabData) {
			var _this = this;

			if (!!tabData && tabData.length > 0) {
				var i = 1;
				tabData.forEach(function (item) {
					item.id = i;
					item.promotiontype = _this.formatPromotionType(item);
					item.startime = _this.formatStartime(item);
					item.endtime = _this.formatEndtime(item);
					item.status = _this.formatStatus(item);
					item.cashpromote = parseFloat(item.cashpromote);
					item.usevoucher = _this.formatUseVoucher(item);
					item.voucheramount = parseFloat(item.voucheramount);
					i++;
				});

				var fileName = _this.sysCnName + "_" + _util2.default.formatDate.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "_" + _this.$root.$route.name;

				var tHeader = ['序号', '标题', '促销类型', '开始时间', '结束时间', '现金促销金额', '可用返单券', '返单券比例', '返单券金额', '是否发布'];
				var filterVal = ['id', 'title', 'promotiontype', 'startime', 'endtime', 'cashpromote', 'usevoucher', 'voucherrate', 'voucheramount', 'status'];
				_util2.default.exportJsonToExcel(fileName, (0, _stringify2.default)(tabData), tHeader, filterVal);
			} else {
				this.$message({
					message: "没有需要导出的数据",
					type: 'warning'
				});
			}
		},

		choseImage: function choseImage(file) {
			this.formData.thumimage = file.url;
		},

		getFileUrl: function getFileUrl(high, thum) {
			this.formData.highimage = high;
			this.formData.thumimage = thum;
		}
	},

	created: function created() {
		this.loginId = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.uid, this);
	},

	mounted: function mounted() {
		var _this4 = this;

		var _this = this;
		_this.containerHeight = _this.$refs.promotioncontainer.offsetHeight;

		_this.getData();

		document.body.ondrop = function (event) {
			event.preventDefault();
			event.stopPropagation();
		};

		_this.rowDrop();

		window.onresize = function () {
			return function () {
				if (!_this4.timer && !!_this.$refs.promotioncontainer) {
					_this4.timer = true;
					_this.containerHeight = _this.$refs.promotioncontainer.offsetHeight;
					var that = _this4;
					setTimeout(function () {
						that.timer = false;
					}, 100);
				}
			}();
		};
	}
};

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(11);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _sortablejs = __webpack_require__(68);

var _sortablejs2 = _interopRequireDefault(_sortablejs);

var _LayerPath = __webpack_require__(115);

var _LayerPath2 = _interopRequireDefault(_LayerPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		LayerPath: _LayerPath2.default
	},
	data: function data() {
		return {
			sysCnName: _emEnum2.default.cnName,
			sysEnName: _emEnum2.default.enName,

			layer: 2,

			loginId: '',

			pid: '',

			submitSortDisabled: true,
			idArr: [],
			sequenceArr: [],

			loading: false,
			containerHeight: 0,
			datas: [],

			areaDatas: [],
			codeDisabled: true,
			roleOptions: _emEnum2.default.roleOptions,
			stepTypeOptions: _emEnum2.default.stepTypeOptions,
			dialogTitle: '',
			editDialogVisible: false,
			stepamountShow: true,
			monthoverdateShow: false,
			formData: {
				psId: '',

				steptitle: '',
				steptype: '',
				minstepamount: '',
				maxstepamount: '',
				remark: '',
				monthoverdate: ''
			},
			rules: {
				steptitle: [{ required: true, message: '请输入步骤标题', trigger: 'blur' }],
				steptype: [{ required: true, message: '请选择类型', trigger: 'change' }],
				minstepamount: [{ required: true, message: '请输入促销区间', trigger: 'blur' }],
				monthoverdate: [{ required: true, message: '请选择过期日', trigger: 'change' }]
			}
		};
	},

	methods: {
		formatStatus: function formatStatus(row, column) {
			return row.status === 0 ? "已启用" : "已禁用";
		},

		formatStartime: function formatStartime(row, column) {
			if (!!row.startime) {
				return _util2.default.formatDate.format(new Date(row.startime.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:ss');
			} else return row.startime;
		},

		formatEndtime: function formatEndtime(row, column) {
			if (!!row.endtime) {
				return _util2.default.formatDate.format(new Date(row.endtime.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:ss');
			} else return row.endtime;
		},

		formatStepType: function formatStepType(row, column) {
			var typeOp = _emEnum2.default.stepTypeOptions.find(function (item) {
				return item.key === row.steptype;
			});
			if (!typeOp) return '';else return typeOp.value;
		},

		formatStepAmount: function formatStepAmount(row, column) {
			var stepAmount = row.stepamount;
			var amountArr = stepAmount.split(',');
			if (!!amountArr && amountArr.length >= 2) {
				var min = parseInt(amountArr[0]);
				var max = parseInt(amountArr[1]);
				if (min === max) {
					return min + '';
				} else if (max === -1) {
					return min + '以上';
				} else {
					return min + ' - ' + max;
				}
			} else {
				return stepAmount;
			}
		},

		cashMin: function cashMin() {
			this.formData.minstepamount = this.formData.minstepamount.replace(/[^\.\d]/g, '');
			this.formData.minstepamount = this.formData.minstepamount.replace(/^\./g, '');
			var temp = this.formData.minstepamount.replace(/\./g, '');
			if (this.formData.minstepamount.length >= temp.length + 2) {
				this.formData.minstepamount = this.formData.minstepamount.substr(0, this.formData.minstepamount.length - 1);
			}
		},
		cashMax: function cashMax() {
			this.formData.maxstepamount = this.formData.maxstepamount.replace(/[^\.\d]/g, '');
			this.formData.maxstepamount = this.formData.maxstepamount.replace(/^\./g, '');
			var temp = this.formData.maxstepamount.replace(/\./g, '');
			if (this.formData.maxstepamount.length >= temp.length + 2) {
				this.formData.maxstepamount = this.formData.maxstepamount.substr(0, this.formData.maxstepamount.length - 1);
			}
		},
		cashChange: function cashChange(val) {
			if (val == 'Min') {
				if (!!this.formData.minstepamount && !!this.formData.maxstepamount) {
					if (parseFloat(this.formData.minstepamount) > parseFloat(this.formData.maxstepamount)) {
						this.$message({
							message: '促销区间最小金额不能大于最大金额！',
							type: 'warning'
						});
						this.formData.minstepamount = this.formData.maxstepamount;
					}
				}
			} else {
				if (!!this.formData.minstepamount && !!this.formData.maxstepamount) {
					if (parseFloat(this.formData.minstepamount) > parseFloat(this.formData.maxstepamount)) {
						this.$message({
							message: '促销区间最大金额不能小于最小金额！',
							type: 'warning'
						});
						this.formData.maxstepamount = this.formData.minstepamount;
					}
				}
			}
		},

		promotionChange: function promotionChange(pid) {
			this.$refs.LayerPath.callBack();
			this.pid = pid;
			this.getData();
		},

		getData: function getData() {
			var _this2 = this;

			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {
				pid: _this.pid
			};
			(0, _api.getPromotionstepList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data = data,
				    code = _data.code,
				    msg = _data.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;

					_this2.$refs.LayerPath.changeData(_this2.layer, data);
					_this2.$refs.LayerPath.changeData(_this2.layer + 1, '');

					_this.datas = data;

					_this.idArr = [];
					_this.sequenceArr = [];
					_this.datas.forEach(function (item) {
						_this.sequenceArr.push(item.sequence);
					});
				}
			});
		},

		delData: function delData(index, row) {
			var _this = this;
			_this.$confirm('确认删除该促销步骤？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					psid: row.id
				};
				(0, _api.deletePromotionstep)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		enableData: function enableData(index, row) {
			var _this = this;
			_this.$confirm('确认' + (row.status === 0 ? '禁用' : '启用') + '该促销步骤？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					psid: row.id,
					status: row.status === 0 ? '1' : '0'
				};
				(0, _api.enablePromotionstep)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		resetForm: function resetForm(formName) {
			this.$refs[formName].resetFields();
		},

		editData: function editData(index, row) {
			var formName = 'formData';

			this.editDialogVisible = true;

			if (!row) {
				this.dialogTitle = "添加";
				this.codeDisabled = false;
				if (this.$refs[formName]) this.$refs[formName].resetFields();
				this.formData.psid = "";

				this.formData.steptitle = "";

				this.formData.steptype = this.stepTypeOptions[0].key;
				this.formData.minstepamount = "";
				this.formData.maxstepamount = "";
				this.formData.remark = "";
				this.formData.monthoverdate = "";
			} else {
				this.dialogTitle = "编辑";
				this.codeDisabled = true;
				this.formData.psid = row.id;

				this.formData.steptitle = row.steptitle;

				this.formData.steptype = row.steptype;

				this.formData.minstepamount = '';
				this.formData.maxstepamount = '';
				if (!!row.stepamount) {
					var splitIndex = row.stepamount.indexOf(',');
					if (splitIndex > -1 && row.stepamount != ',') {
						this.formData.minstepamount = row.stepamount.substr(0, splitIndex);
						var max = row.stepamount.substr(splitIndex + 1, row.stepamount.length - splitIndex - 1);
						this.formData.maxstepamount = max == '-1' ? '' : max;
					}
				}
				this.formData.remark = row.remark;
				this.formData.monthoverdate = row.monthoverdate;
			}
			this.steptypeChange();
		},

		openDialog: function openDialog() {
			var ele = document.getElementById('focus-ele');
			if (!!ele) {
				ele.focus();
			}
		},

		closeDialog: function closeDialog() {
			this.editDialogVisible = false;
		},

		steptypeChange: function steptypeChange() {
			if (this.formData.steptype === 1 || this.formData.steptype === 4) {
				this.stepamountShow = true;
				this.rules.minstepamount[0].required = true;
				this.monthoverdateShow = false;
				this.rules.monthoverdate[0].required = false;
			} else {
				this.stepamountShow = false;
				this.rules.minstepamount[0].required = false;
				if (this.formData.steptype === 3) {
					this.monthoverdateShow = true;
					this.rules.monthoverdate[0].required = true;
				} else {
					this.monthoverdateShow = false;
					this.rules.monthoverdate[0].required = false;
				}
			}
		},

		handleSubmit: function handleSubmit(formName) {
			var _this3 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					var _this = _this3;
					_this.$confirm('确认' + _this.dialogTitle + '促销步骤？', '提示', {
						type: 'warning'
					}).then(function () {
						_this.loading = true;
						if (!_this.formData.psid) {
							var para = {
								pid: _this.pid,
								remark: _this.formData.remark,
								steptitle: _this.formData.steptitle,
								steptype: _this.formData.steptype
							};

							if (_this.formData.steptype === 1 || _this.formData.steptype === 4) {
								para['stepamount'] = _this.formData.minstepamount + ',' + (!!_this.formData.maxstepamount && _this.formData.maxstepamount != '' ? _this.formData.maxstepamount : '-1');
								para['monthoverdate'] = '';
							} else if (_this.formData.steptype === 3) {
								para['stepamount'] = '';
								para['monthoverdate'] = _this.formData.monthoverdate;
							} else {
								para['stepamount'] = '';
								para['monthoverdate'] = '';
							}

							(0, _api.addPromotionstep)(para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						} else {
							var _para = {
								psid: _this.formData.psid,

								remark: _this.formData.remark,

								steptitle: _this.formData.steptitle,
								steptype: _this.formData.steptype
							};

							if (_this.formData.steptype === 1 || _this.formData.steptype === 4) {
								_para['stepamount'] = _this.formData.minstepamount + ',' + (!!_this.formData.maxstepamount && _this.formData.maxstepamount != '' ? _this.formData.maxstepamount : '-1');
								_para['monthoverdate'] = '';
							} else if (_this.formData.steptype === 3) {
								_para['stepamount'] = '';
								_para['monthoverdate'] = _this.formData.monthoverdate;
							} else {
								_para['stepamount'] = '';
								_para['monthoverdate'] = '';
							}

							(0, _api.editPromotionstep)(_para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						}
					}).catch(function (error) {
						if (error !== 'cancel') {
							_this.$message({
								message: error.message ? error.message : error,
								type: 'error'
							});
						}
					});
				} else {
					return false;
				}
			});
		},

		rowDrop: function rowDrop() {
			var tbody = document.querySelector('.el-table__body-wrapper tbody');
			var _this = this;
			_sortablejs2.default.create(tbody, {
				onEnd: function onEnd(_ref) {
					var newIndex = _ref.newIndex,
					    oldIndex = _ref.oldIndex;

					if (_this.sequenceArr.length > 1) {
						var currRow = _this.datas.splice(oldIndex, 1)[0];
						_this.datas.splice(newIndex, 0, currRow);
						_this.submitSortDisabled = false;

						for (var i = 0; i < _this.datas.length; i++) {
							_this.datas[i].sequence = _this.sequenceArr[i];
						}
					}
				}
			});
		},

		submitSort: function submitSort() {
			var _this = this;

			_this.idArr = _this.datas.map(function (item) {
				return item.id;
			});

			if (!!_this.idArr && !!_this.sequenceArr && _this.idArr.length === _this.sequenceArr.length) {
				_this.$confirm('确认提交排序结果？', '提示', {
					type: 'warning'
				}).then(function () {
					_this.loading = true;
					var para = {
						psid: _this.idArr,
						sequence: _this.sequenceArr
					};
					(0, _api.sortPromotionstep)(para, _this).then(function (res) {
						return res.data;
					}).then(function (data) {
						_this.loading = false;
						var msg = data.msg,
						    code = data.code;

						if (code !== "0") {
							_this.$message({
								message: msg,
								type: 'error'
							});
						} else {
							_this.$message({
								message: msg,
								type: 'success'
							});
							_this.getData();
						}
					});
				}).catch(function (error) {
					if (error !== 'cancel') {
						_this.$message({
							message: error.message ? error.message : error,
							type: 'error'
						});
					}
				});
			} else {
				_this.$message({
					message: '排序数据出现问题，请刷新后重试！',
					type: 'error'
				});
			}
		},

		handleRowChange: function handleRowChange(row, event, column) {},

		preStep: function preStep() {
			this.$router.push({ path: '/promotion' });
		},

		nextStep: function nextStep(index, row) {
			this.$router.push({ path: '/processLabel', query: { pid: this.pid, sid: row.id, st: row.steptitle, sp: row.steptype } });
		},

		exportExcel: function exportExcel() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {
				pid: _this.pid
			};
			(0, _api.getPromotionstepList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data2 = data,
				    code = _data2.code,
				    msg = _data2.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;
					_this.doExport(data);
				}
			});
		},

		doExport: function doExport(tabData) {
			var _this = this;

			if (!!tabData && tabData.length > 0) {
				var i = 1;
				tabData.forEach(function (item) {
					item.id = i;
					item.steptype = _this.formatStepType(item);
					item.stepamount = _this.formatStepAmount(item);
					i++;
				});

				var fileName = _this.sysCnName + "_" + _util2.default.formatDate.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "_" + _this.$root.$route.name;

				var tHeader = ['序号', '名称', '类型', '促销区间', '过期日', '备注'];
				var filterVal = ['id', 'steptitle', 'steptype', 'stepamount', 'monthoverdate', 'remark'];
				_util2.default.exportJsonToExcel(fileName, (0, _stringify2.default)(tabData), tHeader, filterVal);
			} else {
				this.$message({
					message: "没有需要导出的数据",
					type: 'warning'
				});
			}
		}
	},

	created: function created() {
		this.loginId = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.uid, this);

		var query = this.$route.query;
		this.pid = query.pid;
	},

	mounted: function mounted() {
		var _this4 = this;

		var _this = this;
		_this.containerHeight = _this.$refs.promotionstepcontainer.offsetHeight;

		_this.$refs.LayerPath.changeVal(_this.layer - 1, _this.pid);

		_this.getData();

		document.body.ondrop = function (event) {
			event.preventDefault();
			event.stopPropagation();
		};

		_this.rowDrop();

		window.onresize = function () {
			return function () {
				if (!_this4.timer && !!_this.$refs.promotionstepcontainer) {
					_this4.timer = true;
					_this.containerHeight = _this.$refs.promotionstepcontainer.offsetHeight;
					var that = _this4;
					setTimeout(function () {
						that.timer = false;
					}, 100);
				}
			}();
		};
	}
};

/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(11);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _Pagination = __webpack_require__(37);

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {},
	data: function data() {
		return {
			sysCnName: _emEnum2.default.cnName,
			sysEnName: _emEnum2.default.enName,

			loading: false,
			containerHeight: 0,
			datas: [],


			dialogTitle: '',
			editDialogVisible: false,
			formData: {
				areaId: '',
				areaName: '',
				isinternal: 'no' },
			rules: {
				areaName: [{ required: true, message: '请输入区域名称', trigger: 'blur' }],
				isinternal: [{ required: true, message: '请选择是否内部员工', trigger: 'blur,change' }]
			}
		};
	},

	methods: {
		formatCreatTime: function formatCreatTime(row, column) {
			if (!!row.creattime) {
				return _util2.default.formatDate.format(new Date(row.creattime.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:ss');
			} else return row.creattime;
		},

		formatIsinternal: function formatIsinternal(row, column) {
			if (row.isinternal === 'yes') return "是";else if (row.isinternal === 'no') return "否";else return '';
		},

		getData: function getData() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {};
			(0, _api.getAreaConfig)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data = data,
				    code = _data.code,
				    msg = _data.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;
					_this.datas = data;
				}
			});
		},

		delData: function delData(index, row) {
			var _this = this;
			_this.$confirm('确认删除该区域？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					aid: row.id
				};
				(0, _api.deleteArea)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		enableData: function enableData(index, row) {
			var _this = this;
			_this.$confirm('确认' + (row.status === 0 ? '禁用' : '启用') + '该区域？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					aid: row.id,
					status: row.status === 0 ? '1' : '0'
				};
				(0, _api.enableArea)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		resetForm: function resetForm(formName) {
			this.$refs[formName].resetFields();
		},

		editData: function editData(index, row) {
			var formName = 'formData';

			this.editDialogVisible = true;

			if (!row) {
				this.dialogTitle = "添加";
				this.formData.areaId = "";
				this.formData.areaName = "";
				this.formData.isinternal = "no";
			} else {
				this.dialogTitle = "编辑";
				this.formData.areaId = row.id;
				this.formData.areaName = row.areaname;
				this.formData.isinternal = row.isinternal === "yes" ? "yes" : "no";

				if (this.$refs[formName]) this.$refs[formName].validate();
			}
		},

		openDialog: function openDialog() {
			var ele = document.getElementById('focus-ele');
			if (!!ele) {
				ele.focus();
			}
		},

		closeDialog: function closeDialog() {
			this.editDialogVisible = false;
		},

		handleSubmit: function handleSubmit(formName) {
			var _this2 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					var _this = _this2;
					_this.$confirm('确认' + _this.dialogTitle + '区域？', '提示', {
						type: 'warning'
					}).then(function () {
						_this.loading = true;
						if (!_this.formData.areaId) {
							var para = {
								areaname: _this.formData.areaName,
								isinternal: _this.formData.isinternal
							};
							(0, _api.addArea)(para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						} else {
							var _para = {
								aid: _this.formData.areaId,
								areaname: _this.formData.areaName,
								isinternal: _this.formData.isinternal
							};
							(0, _api.editArea)(_para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						}
					}).catch(function (error) {
						if (error !== 'cancel') {
							_this.$message({
								message: error.message ? error.message : error,
								type: 'error'
							});
						}
					});
				} else {
					return false;
				}
			});
		},

		searchData: function searchData(index, row) {
			this.$router.push({ path: '/client', query: { id: row.id } });
		},

		exportExcel: function exportExcel() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {};
			(0, _api.getAreaConfig)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data2 = data,
				    code = _data2.code,
				    msg = _data2.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;
					_this.doExport(data);
				}
			});
		},

		doExport: function doExport(tabData) {
			var _this = this;

			if (!!tabData && tabData.length > 0) {
				var i = 1;
				tabData.forEach(function (item) {
					item.id = i;
					item.creattime = _this.formatCreatTime(item);
					i++;
				});

				var fileName = _this.sysCnName + "_" + _util2.default.formatDate.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "_" + _this.$root.$route.name;

				var tHeader = ['序号', '团队名', '创建时间'];
				var filterVal = ['id', 'areaname', 'creattime'];
				_util2.default.exportJsonToExcel(fileName, (0, _stringify2.default)(tabData), tHeader, filterVal);
			} else {
				this.$message({
					message: "没有需要导出的数据",
					type: 'warning'
				});
			}
		}
	},

	mounted: function mounted() {
		var _this3 = this;

		var _this = this;
		_this.containerHeight = _this.$refs.areacontainer.offsetHeight;

		_this.getData();

		window.onresize = function () {
			return function () {
				if (!_this3.timer && !!_this.$refs.areacontainer) {
					_this3.timer = true;
					_this.containerHeight = _this.$refs.areacontainer.offsetHeight;
					var that = _this3;
					setTimeout(function () {
						that.timer = false;
					}, 100);
				}
			}();
		};
	}
};

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(11);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var _this2 = this;

    var checkConfirmPwd = function checkConfirmPwd(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入确认密码'));
      } else if (value !== _this2.formData.newPwd) {
        return callback(new Error('两次密码输入不一致'));
      } else {
        callback();
      }
    };
    return {
      uid: '',
      loading: false,
      tipContent: '',
      plaintextShow: false,
      formData: {
        oldPwd: '',
        newPwd: '',
        confirmPwd: ''
      },
      rules: {
        oldPwd: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPwd: [{ required: true, message: '请输入新密码', trigger: 'blur' }, { min: 6, message: '长度必须大于等于 6 个字符', trigger: 'blur' }],
        confirmPwd: [{ required: true, validator: checkConfirmPwd, trigger: 'blur' }]
      }
    };
  },

  methods: {
    submitForm: function submitForm(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var _this = _this3;
          _this.loading = true;
          var para = {
            uid: _this.uid,
            oldPassword: _this.formData.oldPwd,
            newPassword: _this.formData.newPwd
          };
          (0, _api.changePassword)(para, _this).then(function (res) {
            return res.data;
          }).then(function (data) {
            _this.loading = false;
            var code = data.code,
                msg = data.msg;

            if (code !== "0") {
              _this.$message({
                message: msg,
                type: 'error'
              });

              var ele = document.getElementById('focus-ele');
              if (!!ele) {
                ele.focus();
              }
            } else {
              _util2.default.userData.reLogin(_this, true, msg + '，请重新登录！');
            }
          });
        } else {
          return false;
        }
      });
    },

    returnManagePage: function returnManagePage(e, val) {
      this.$root.$router.back(-1);
    }
  },

  created: function created() {},
  mounted: function mounted() {
    var ele = document.getElementById('focus-ele');
    if (!!ele) {
      ele.focus();
    }

    this.uid = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.uid, this);

    var pwdOriginal = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.pwdOriginal, this);

    if (!!pwdOriginal && pwdOriginal == 1) {
      this.tipContent = "警告：您的登录密码为初始密码，为了账号安全，请尽快修改密码！";
    }
  }
};

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(11);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _Pagination = __webpack_require__(37);

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		Pagination: _Pagination2.default
	},
	data: function data() {
		return {
			sysCnName: _emEnum2.default.cnName,
			sysEnName: _emEnum2.default.enName,

			loginId: '',

			loading: false,
			containerHeight: 0,
			datas: [],

			pageSize: 100,
			pageNum: 1,
			totalNum: 0,

			areaDatas: [],
			roleOptions: _emEnum2.default.roleOptions,
			dialogTitle: '',
			editDialogVisible: false,
			roleDisabled: false,
			areaDisabled: false,
			formData: {
				id: '',
				username: '',
				role: '',
				areaid: '',
				wxaccount: '',
				remark: '' },
			rules: {
				username: [{ required: true, message: '请输入用户账号', trigger: 'blur' }],
				role: [{ required: true, message: '请选择用户角色', trigger: 'change' }],
				areaid: [{ required: true, message: '请选择所属区域', trigger: 'change' }]
			}
		};
	},

	methods: {
		formatRole: function formatRole(row, column) {
			var roleOp = _emEnum2.default.roleOptions.find(function (item) {
				return item.key === row.role;
			});
			if (!roleOp) return '';else return roleOp.value;
		},

		formatCreatTime: function formatCreatTime(row, column) {
			if (!!row.creattime) {
				return _util2.default.formatDate.format(new Date(row.creattime.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:ss');
			} else return row.creattime;
		},

		getData: function getData() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {
				pageNum: _this.pageNum,
				pageSize: _this.pageSize
			};
			(0, _api.getUserList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data = data,
				    code = _data.code,
				    msg = _data.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					var _data$data = data.data,
					    pageSize = _data$data.pageSize,
					    pageNum = _data$data.pageNum,
					    totalNum = _data$data.totalNum;

					data = data.data.list;
					_this.datas = data;

					_this.pageSize = pageSize;
					_this.pageNum = pageNum;
					_this.totalNum = totalNum;
				}
			});
		},

		delData: function delData(index, row) {
			var _this = this;
			_this.$confirm('确认删除该用户？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					uid: row.id
				};
				(0, _api.deleteUser)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		enableData: function enableData(index, row) {
			var _this = this;
			_this.$confirm('确认' + (row.status === 0 ? '禁用' : '启用') + '该用户？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					uid: row.id,
					status: row.status === 0 ? '1' : '0'
				};
				(0, _api.enableUser)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		resetPassword: function resetPassword(index, row) {
			var _this = this;
			_this.$confirm('确认将【' + row.username + '】的密码重置为初始密码？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					uid: row.id
				};
				(0, _api.resetUserPass)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		resetForm: function resetForm(formName) {
			this.$refs[formName].resetFields();
		},

		editData: function editData(index, row) {
			var formName = 'formData';

			this.editDialogVisible = true;
			this.formData.areaid = [];

			if (!row) {
				this.dialogTitle = "添加";
				if (this.$refs[formName]) this.$refs[formName].resetFields();
				this.formData.id = "";
				this.formData.username = "";

				this.formData.role = this.roleOptions[0].key;
				this.roleDisabled = false;
				this.formData.areaid = [];

				this.formData.wxaccount = "";
				this.formData.remark = "";
			} else {
				this.dialogTitle = "编辑";
				this.formData.id = row.id;
				this.formData.username = row.username;

				var roleOp = _emEnum2.default.roleOptions.find(function (item) {
					return item.key === row.role;
				});
				if (!roleOp) {
					this.formData.role = this.roleOptions[0].key;
					this.roleDisabled = false;
				} else {
					this.formData.role = row.role;
					this.roleDisabled = row.role === 1;
				}

				this.formData.areaid = !!row.areaid ? row.areaid.split(',') : [];
				this.formData.wxaccount = row.wxaccount;
				this.formData.remark = row.remark;

				if (this.$refs[formName]) this.$refs[formName].validate();
			}

			this.roleChange(this.formData.areaid);
		},

		openDialog: function openDialog() {
			var ele = document.getElementById('focus-ele');
			if (!!ele) {
				ele.focus();
			}
		},

		closeDialog: function closeDialog() {
			this.editDialogVisible = false;
		},

		handleSubmit: function handleSubmit(formName) {
			var _this2 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					var _this = _this2;
					_this.$confirm('确认' + _this.dialogTitle + '用户？', '提示', {
						type: 'warning'
					}).then(function () {
						_this.loading = true;
						var selAreaid = '';
						if (!!_this.formData.areaid) {
							selAreaid = _this.formData.areaid.join(',');
						}
						if (!_this.formData.id) {
							var para = {
								username: _this.formData.username,
								role: _this.formData.role,
								wxaccount: _this.formData.wxaccount,
								remark: _this.formData.remark
							};

							if (!!selAreaid) para['areaid'] = selAreaid;

							(0, _api.addUser)(para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						} else {
							var _para = {
								uid: _this.formData.id,
								username: _this.formData.username,
								role: _this.formData.role,
								areaid: selAreaid,
								wxaccount: _this.formData.wxaccount,
								remark: _this.formData.remark
							};
							(0, _api.editUser)(_para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						}
					}).catch(function (error) {
						if (error !== 'cancel') {
							_this.$message({
								message: error.message ? error.message : error,
								type: 'error'
							});
						}
					});
				} else {
					return false;
				}
			});
		},

		exportExcel: function exportExcel() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {
				pageNum: 1,
				pageSize: _this.totalNum
			};

			(0, _api.getUserList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data2 = data,
				    code = _data2.code,
				    msg = _data2.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;
					_this.doExport(data);
				}
			});
		},

		doExport: function doExport(tabData) {
			var _this = this;

			if (!!tabData && tabData.length > 0) {
				var i = 1;
				tabData.forEach(function (item) {
					item.id = i;
					item.role = _this.formatRole(item);
					item.creattime = _this.formatCreatTime(item);
					i++;
				});

				var fileName = _this.sysCnName + "_" + _util2.default.formatDate.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "_" + _this.$root.$route.name;

				var tHeader = ['序号', '用户账号', '用户角色', '所属区域', '创建时间', '备注'];
				var filterVal = ['id', 'username', 'role', 'areaname', 'creattime', 'remark'];
				_util2.default.exportJsonToExcel(fileName, (0, _stringify2.default)(tabData), tHeader, filterVal);
			} else {
				this.$message({
					message: "没有需要导出的数据",
					type: 'warning'
				});
			}
		},

		roleChange: function roleChange(areas) {
			if (this.formData.role === 1 || this.formData.role === 3 || this.formData.role === 4) {
				this.formData.areaid = [];
				this.areaDisabled = true;
				this.rules.areaid[0].required = false;
				this.formData.wxaccount = "";
			} else {
				this.areaDisabled = false;
				this.rules.areaid[0].required = true;
			}
		},

		getAllAreas: function getAllAreas() {
			var _this = this;
			_this.loading = true;
			var para = {};
			(0, _api.getAreaConfig)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				var _data3 = data,
				    code = _data3.code,
				    msg = _data3.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;
					_this.areaDatas = data.filter(function (item) {
						return item.status === 0;
					});
					_this.loading = false;
				}
			});
		},
		handlePageSizeChange: function handlePageSizeChange(val) {
			this.pageSize = val;
			this.getData();
		},
		handlePageCurrentChange: function handlePageCurrentChange(val) {
			this.pageNum = val;
			this.getData();
		}
	},

	created: function created() {
		this.loginId = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.uid, this);

		this.getAllAreas();
	},

	mounted: function mounted() {
		var _this3 = this;

		var _this = this;
		_this.containerHeight = _this.$refs.usercontainer.offsetHeight;

		_this.getData();

		window.onresize = function () {
			return function () {
				if (!_this3.timer && !!_this.$refs.usercontainer) {
					_this3.timer = true;
					_this.containerHeight = _this.$refs.usercontainer.offsetHeight;
					var that = _this3;
					setTimeout(function () {
						that.timer = false;
					}, 100);
				}
			}();
		};
	}
};

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(16);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(11);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _UploadFile = __webpack_require__(52);

var _UploadFile2 = _interopRequireDefault(_UploadFile);

var _Pagination = __webpack_require__(37);

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		UploadFile: _UploadFile2.default,
		Pagination: _Pagination2.default
	},
	data: function data() {
		var _this2 = this;

		var validatorPcd = function validatorPcd(rule, value, callback) {
			if (!_this2.formData.region.province) {
				return callback(new Error('请选择省'));
			} else if (!_this2.formData.region.city) {
				return callback(new Error('请选择市'));
			} else if (!_this2.formData.region.district) {
				return callback(new Error('请选择县（区）'));
			}
			callback();
		};
		return {
			sysCnName: _emEnum2.default.cnName,
			sysEnName: _emEnum2.default.enName,
			pageName: 'voucher',

			loading: false,
			containerHeight: 0,
			datas: [],

			fuzzyFieldOptions: _emEnum2.default.voucherFuzzyFieldOptions,

			usedOptions: _emEnum2.default.usedOptions,

			pageSize: 100,
			pageNum: 1,
			totalNum: 0,

			fuzzyField: '',
			fuzzyFieldValue: '',
			vague: '',
			used: '',
			aagencyid: '',
			voucherStartime: '',
			voucherEndtime: '',
			voucherStartStamp: '',
			voucherEndStamp: '',

			startPickerOptions: {
				disabledDate: function disabledDate(time) {
					if (!!_this2.voucherEndtime) {
						return time.getTime() > new Date(_this2.voucherEndtime);
					}
					return false;
				}
			},
			endPickerOptions: {
				disabledDate: function disabledDate(time) {
					if (!!_this2.voucherStartime) {
						return time.getTime() < new Date(_this2.voucherStartime);
					}
					return false;
				}
			},

			agencyDatas: [],

			dialogTitle: '',
			editDialogVisible: false,
			unEditEnable: true,
			formData: {
				id: '',

				orderCode: '',
				ordercaretername: '',
				ordercareter: '',
				aagencyid: '',
				aagencyname: '',
				pagencyname: '',
				cagencyname: '',
				tagencyname: '',
				consignee: '',

				amount: '',
				franchisee: '',
				consigneePhone: '',
				region: {
					province: '',
					city: '',
					district: '' },
				address: '',
				remark: '' },
			rules: {
				ordercaretername: [{ required: true, message: '请输入下单人姓名', trigger: 'blur' }],
				ordercareter: [{ required: true, message: '请输入下单人编号', trigger: 'blur' }],
				consignee: [{ required: true, message: '请输入收货人姓名', trigger: 'blur' }],
				amount: [{ required: true, message: '请输入返单券金额', trigger: 'blur' }],
				franchisee: [{ required: true, message: '请输入加盟商姓名', trigger: 'blur' }],
				consigneePhone: [{ required: true, message: '请输入收货人电话', trigger: 'blur' }],
				province: [{ required: true, validator: validatorPcd, trigger: 'blur' }],
				address: [{ required: true, message: '请输入收货人地址', trigger: 'blur' }]
			},
			fixedPos: 'right',
			colDialogVisible: false,
			colDatas: [{ key: 'id', label: '返单券ID' }, { key: 'amount', label: '返单券金额' }, { key: 'gmtCreate', label: '赠送日期' }, { key: 'gmtCreatetime', label: '赠送时间' }, { key: 'ordercareter', label: '客户编码' }, { key: 'ordercaretername', label: '客户姓名' }, { key: 'aagencyname', label: '培训公司' }, { key: 'pagencyname', label: '销售公司' }, { key: 'cagencyname', label: '代理1' }, { key: 'tagencyname', label: '代理2' }, { key: 'consignee', label: '收货人姓名' }, { key: 'consigneePhone', label: '收货人电话' }, { key: 'province', label: '省' }, { key: 'city', label: '市' }, { key: 'district', label: '县（区）' }, { key: 'address', label: '收货人地址' }, { key: 'franchisee', label: '加盟商姓名' }, { key: 'used', label: '是否已消费' }, { key: 'usedOrderCode', label: '消费订单号' }, { key: 'remark', label: '备注' }],
			colUnShowKeys: [] };
	},

	methods: {
		formatGmtCreate: function formatGmtCreate(row, column) {
			return _util2.default.formatDate.format(new Date(row.gmtCreate), 'yyyy-MM-dd');
		},
		formatGmtCreatetime: function formatGmtCreatetime(row, column) {
			return _util2.default.formatDate.format(new Date(row.gmtCreate), 'HH:mm:ss');
		},

		formatUsed: function formatUsed(row, column) {
			var uOp = _emEnum2.default.usedOptions.find(function (item) {
				return item.key === row.used;
			});
			if (!uOp) return '';else return uOp.value;
		},

		voucherTimeChange: function voucherTimeChange(control) {
			var _this = this;
			_this.voucherStartStamp = '';
			_this.voucherEndStamp = '';
			if (!!_this.voucherStartime && !!_this.voucherEndtime) {
				var s = _util2.default.formatDate.format(new Date(_this.voucherStartime), 'yyyy-MM-dd') + ' 00:00:00';
				var e = _util2.default.formatDate.format(new Date(_this.voucherEndtime), 'yyyy-MM-dd') + ' 23:59:59';
				_this.voucherStartStamp = new Date(s).getTime();
				_this.voucherEndStamp = new Date(e).getTime();
			}

			_this.searchList();
		},

		searchColumn: function searchColumn() {
			if (!!this.vague) {
				this.getData();
			}
		},

		searchList: function searchList() {
			this.pageNum = 1;
			this.getData();
		},

		searchAgencyname: function searchAgencyname($event) {
			var aagency = this.agencyDatas.find(function (item) {
				return item.aagencyid === $event;
			});
			if (!!aagency && !!aagency.aagencyname) this.formData.aagencyname = aagency.aagencyname;
		},

		searchData: function searchData() {
			var _this = this;

			_this.formData.ordercaretername = '';
			_this.formData.ordercareter = '';
			_this.formData.aagencyid = '';
			_this.formData.aagencyname = '';
			_this.formData.pagencyname = '';
			_this.formData.cagencyname = '';
			_this.formData.tagencyname = '';
			_this.formData.consignee = '';

			_this.formData.franchisee = '';
			_this.formData.consigneePhone = '';
			_this.formData.region.province = '';
			_this.formData.region.city = '';
			_this.formData.region.district = '';
			_this.formData.address = '';
			_this.formData.amount = '';

			if (!!_this.formData.orderCode) {
				var para = {
					code: _this.formData.orderCode
				};

				(0, _api.getOrderList)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var code = data.code,
					    msg = data.msg;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						var orderDatas = data.data.list;
						if (!!orderDatas && orderDatas.length > 0) {
							var orderData = orderDatas[0];

							_this.formData.ordercaretername = orderData.ordercaretername;
							_this.formData.ordercareter = orderData.ordercareter;
							_this.formData.aagencyid = !!orderData.aagencyid ? orderData.aagencyid + '' : '';
							_this.formData.aagencyname = orderData.aagencyname;
							_this.formData.pagencyname = orderData.pagencyname;
							_this.formData.cagencyname = orderData.cagencyname;
							_this.formData.tagencyname = orderData.tagencyname;
							_this.formData.consignee = orderData.consignee;

							_this.formData.franchisee = orderData.franchisee;
							_this.formData.consigneePhone = orderData.linkphone;
							_this.formData.region.province = orderData.province;
							_this.formData.region.city = orderData.city;
							_this.formData.region.district = orderData.district;
							_this.formData.address = orderData.address;

							if (!!orderData.promotionid) {
								var paraAmount = {
									id: orderData.promotionid
								};

								(0, _api.getPromotionAmount)(paraAmount, _this).then(function (res) {
									return res.data;
								}).then(function (data) {
									_this.loading = false;
									var code = data.code,
									    msg = data.msg;

									if (code !== "0") {
										_this.$message({
											message: msg,
											type: 'error'
										});
									} else {
										if (!!data.data) {
											_this.formData.amount = data.data.voucheramount;
										}
									}
								});
							}
						}
					}
				});
			} else {
				_this.$message({
					message: '请先输入订单编号再搜索！',
					type: 'warning'
				});
			}
		},

		getData: function getData() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {
				pageNum: _this.pageNum,
				pageSize: _this.pageSize
			};

			if (!!_this.aagencyid) para['aagencyid'] = _this.aagencyid;

			if (!!_this.voucherStartStamp && !!_this.voucherEndStamp) {
				para['startime'] = _this.voucherStartStamp;
				para['endtime'] = _this.voucherEndStamp;
			}

			if (!!_this.used || _this.used === 0) para['used'] = _this.used;

			if (!!_this.fuzzyField && !!_this.vague) {
				if (_this.fuzzyField === 'id') {
					para['id'] = _this.vague;
				} else if (_this.fuzzyField === 'ordercaretername') {
					para['ordercaretername'] = _this.vague;
				} else if (_this.fuzzyField === 'franchisee') {
					para['franchisee'] = _this.vague;
				}
			}

			(0, _api.getVoucherList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data = data,
				    code = _data.code,
				    msg = _data.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					var _data$data = data.data,
					    pageSize = _data$data.pageSize,
					    pageNum = _data$data.pageNum,
					    totalNum = _data$data.totalNum;

					data = data.data.list;
					_this.datas = data;

					_this.pageSize = pageSize;
					_this.pageNum = pageNum;
					_this.totalNum = totalNum;
				}
			});
		},

		delData: function delData(index, row) {
			var _this = this;
			_this.$confirm('确认删除该返单券？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					id: row.id
				};
				(0, _api.deleteVoucher)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		editData: function editData(index, row) {
			var formName = 'formData';

			this.editDialogVisible = true;
			if (!row) {
				this.dialogTitle = "添加";
				this.unEditEnable = false;
				if (this.$refs[formName]) this.$refs[formName].resetFields();

				this.formData.id = "";
				this.formData.orderCode = "";
				this.formData.ordercaretername = "";
				this.formData.ordercareter = "";
				this.formData.aagencyid = "";
				this.formData.aagencyname = "";
				this.formData.pagencyname = "";
				this.formData.cagencyname = "";
				this.formData.tagencyname = "";
				this.formData.consignee = "";

				this.formData.amount = "";
				this.formData.franchisee = "";
				this.formData.consigneePhone = "";

				this.formData.region.province = "";
				this.formData.region.city = "";
				this.formData.region.district = "";
				this.formData.address = "";
				this.formData.remark = "";
			} else {
				this.dialogTitle = "编辑";
				this.unEditEnable = true;

				this.formData.id = row.id;

				this.formData.orderCode = row.orderCode;
				this.formData.ordercaretername = row.ordercaretername;
				this.formData.ordercareter = row.ordercareter;
				this.formData.aagencyid = !!row.aagencyid ? row.aagencyid + '' : '';
				this.formData.aagencyname = row.aagencyname;
				this.formData.pagencyname = row.pagencyname;
				this.formData.cagencyname = row.cagencyname;
				this.formData.tagencyname = row.tagencyname;
				this.formData.consignee = row.consignee;

				this.formData.amount = row.amount;
				this.formData.franchisee = row.franchisee;
				this.formData.consigneePhone = row.consigneePhone;

				this.formData.region.province = row.province;
				this.formData.region.city = row.city;
				this.formData.region.district = row.district;
				this.formData.address = row.address;
				this.formData.remark = row.remark;

				if (this.$refs[formName]) this.$refs[formName].validate();
			}
		},

		openDialog: function openDialog() {
			var ele = document.getElementById('focus-ele');
			if (!!ele) {
				ele.focus();
			}
		},

		closeDialog: function closeDialog() {
			this.editDialogVisible = false;
		},

		handleSubmit: function handleSubmit(formName) {
			var _this3 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					var _this = _this3;
					_this.$confirm('确认' + _this.dialogTitle + '返单券？', '提示', {
						type: 'warning'
					}).then(function () {
						_this.loading = true;
						if (!_this.formData.id) {
							var para = {
								orderCode: _this.formData.orderCode,
								ordercaretername: _this.formData.ordercaretername,
								ordercareter: _this.formData.ordercareter,
								aagencyid: _this.formData.aagencyid,
								aagencyname: _this.formData.aagencyname,
								pagencyname: _this.formData.pagencyname,
								cagencyname: _this.formData.cagencyname,
								tagencyname: _this.formData.tagencyname,
								consignee: _this.formData.consignee,

								amount: _this.formData.amount,
								franchisee: _this.formData.franchisee,
								consigneePhone: _this.formData.consigneePhone,

								province: _this.formData.region.province,
								city: _this.formData.region.city,
								district: _this.formData.region.district,
								address: _this.formData.address,
								remark: _this.formData.remark
							};

							(0, _api.addVoucher)(para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						} else {
							var _para = {
								id: _this.formData.id,

								aagencyid: _this.formData.aagencyid,
								aagencyname: _this.formData.aagencyname,
								pagencyname: _this.formData.pagencyname,
								cagencyname: _this.formData.cagencyname,
								tagencyname: _this.formData.tagencyname,
								consignee: _this.formData.consignee,

								amount: _this.formData.amount,
								franchisee: _this.formData.franchisee,
								consigneePhone: _this.formData.consigneePhone,

								province: _this.formData.region.province,
								city: _this.formData.region.city,
								district: _this.formData.region.district,
								address: _this.formData.address,
								remark: _this.formData.remark
							};

							(0, _api.updateVoucher)(_para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						}
					}).catch(function (error) {
						if (error !== 'cancel') {
							_this.$message({
								message: error.message ? error.message : error,
								type: 'error'
							});
						}
					});
				} else {
					return false;
				}
			});
		},

		exportExcel: function exportExcel() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {
				pageNum: 1,
				pageSize: _this.totalNum
			};

			if (!!_this.aagencyid) para['aagencyid'] = _this.aagencyid;

			if (!!_this.voucherStartStamp && !!_this.voucherEndStamp) {
				para['startime'] = _this.voucherStartStamp;
				para['endtime'] = _this.voucherEndStamp;
			}

			if (!!_this.used || _this.used === 0) para['used'] = _this.used;

			if (!!_this.fuzzyField && !!_this.vague) {
				if (_this.fuzzyField === 'id') {
					para['id'] = _this.vague;
				} else if (_this.fuzzyField === 'ordercaretername') {
					para['ordercaretername'] = _this.vague;
				} else if (_this.fuzzyField === 'franchisee') {
					para['franchisee'] = _this.vague;
				}
			}

			(0, _api.getVoucherList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data2 = data,
				    code = _data2.code,
				    msg = _data2.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data.list;
					_this.doExport(data);
				}
			});
		},

		doExport: function doExport(tabData) {
			var _this = this;

			if (!!tabData && tabData.length > 0) {
				var i = 1;
				tabData.forEach(function (item) {
					item.xid = i;
					item["gmtCreate1"] = _this.formatGmtCreate(item);
					item["gmtCreate2"] = _this.formatGmtCreatetime(item);
					item["isUsed"] = _this.formatUsed(item);
					i++;
				});

				var tHeader = ['序号', '返单券ID', '返单券金额', '赠送日期', '赠送时间', '客户编码', '客户姓名', '培训公司', '销售公司', '代理1', '代理2', '收货人姓名', '收货人电话', '省', '市', '县（区）', '收货人地址', '加盟商姓名', '是否已消费', '消费订单号', '备注'];
				var filterVal = ['xid', 'id', 'amount', 'gmtCreate1', 'gmtCreate2', 'ordercareter', 'ordercaretername', 'aagencyname', 'pagencyname', 'cagencyname', 'tagencyname', 'consignee', 'consigneePhone', 'province', 'city', 'district', 'address', 'franchisee', 'isUsed', 'usedOrderCode', 'remark'];

				var fileName = _this.sysCnName + "_" + _util2.default.formatDate.format(new Date(), "yyyy-MM-dd HH:mm:ss") + "_" + _this.$root.$route.name;
				_util2.default.exportJsonToExcel(fileName, (0, _stringify2.default)(tabData), tHeader, filterVal);
			} else {
				this.$message({
					message: "没有需要导出的数据",
					type: 'warning'
				});
			}
		},

		editCol: function editCol() {
			this.colDialogVisible = true;
		},

		closeColSet: function closeColSet() {
			this.fixedPos = "none";

			_util2.default.editStore.SetUnShowCols(this.pageName, this.colUnShowKeys);
			this.fixedPos = "right";
		},

		regionChange: function regionChange(val) {
			if (this.formData.region.province !== val.province) {
				this.formData.region.province = val.province;
				this.formData.region.city = '';
				this.formData.region.district = '';
			} else if (this.formData.region.city !== val.city) {
				this.formData.region.city = val.city;
				this.formData.region.district = '';
			} else if (this.formData.region.district !== val.district) {
				this.formData.region.district = val.district;
			}
		},

		getAllAgencys: function getAllAgencys() {
			var _this = this;
			_this.loading = true;
			var para = {};
			(0, _api.areabyroleList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				var code = data.code,
				    msg = data.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					var agencyData = data.data.list;
					var areaData = data.data.list2;

					_this.agencyDatas = agencyData;
					_this.loading = false;

					_this.getData();
				}
			});
		},
		handlePageSizeChange: function handlePageSizeChange(val) {
			this.pageSize = val;
			this.getData();
		},
		handlePageCurrentChange: function handlePageCurrentChange(val) {
			this.pageNum = val;
			this.getData();
		}
	},

	created: function created() {
		var unShowCols = _util2.default.editStore.GetUnShowCols(this.pageName);
		if (!!unShowCols && unShowCols !== 'none') {
			this.colUnShowKeys = unShowCols;
		}
	},

	mounted: function mounted() {
		var _this4 = this;

		var _this = this;
		_this.containerHeight = _this.$refs.ordercontainer.offsetHeight;

		_this.getAllAgencys();

		window.onresize = function () {
			return function () {
				if (!_this4.timer && !!_this.$refs.ordercontainer) {
					_this4.timer = true;
					_this.containerHeight = _this.$refs.ordercontainer.offsetHeight;
					var that = _this4;
					setTimeout(function () {
						that.timer = false;
					}, 100);
				}
			}();
		};
	}
};

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(11);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			sysCnName: _emEnum2.default.cnName,
			sysEnName: _emEnum2.default.enName,

			loading: false,
			containerHeight: 0,
			datas: [],

			statusOptions: _emEnum2.default.voucherStatusOptions,

			dialogTitle: '',
			editDialogVisible: false,
			formData: {
				id: '',
				title: '',
				status: '',
				remark: '' },
			rules: {
				title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				status: [{ required: true, message: '请选择是否发布', trigger: 'change' }]
			}
		};
	},

	methods: {
		formatStatus: function formatStatus(row, column) {
			var status = _emEnum2.default.voucherStatusOptions.find(function (item) {
				return item.key === row.status;
			});
			if (!status) return '';else return status.value;
		},

		getData: function getData() {
			var _this = this;

			_this.loading = true;
			_this.closeDialog();
			var para = {};
			(0, _api.getVoucherActivityList)(para, _this).then(function (res) {
				return res.data;
			}).then(function (data) {
				_this.loading = false;
				var _data = data,
				    code = _data.code,
				    msg = _data.msg;

				if (code !== "0") {
					_this.$message({
						message: msg,
						type: 'error'
					});
				} else {
					data = data.data;
					_this.datas = data;
				}
			});
		},

		delData: function delData(index, row) {
			var _this = this;
			_this.$confirm('确认删除该返单券活动？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					id: row.id
				};
				(0, _api.deleteVoucherActivity)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		enableData: function enableData(index, row) {
			var _this = this;
			_this.$confirm('确认' + (row.status === 'on' ? '下架' : '发布') + '该返单券活动？', '提示', {
				type: 'warning'
			}).then(function () {
				_this.loading = true;
				var para = {
					id: row.id,
					title: row.title,
					status: row.status === 'on' ? 'off' : 'on',
					remark: row.remark
				};
				(0, _api.updateVoucherActivity)(para, _this).then(function (res) {
					return res.data;
				}).then(function (data) {
					_this.loading = false;
					var msg = data.msg,
					    code = data.code;

					if (code !== "0") {
						_this.$message({
							message: msg,
							type: 'error'
						});
					} else {
						_this.$message({
							message: msg,
							type: 'success'
						});
						_this.getData();
					}
				});
			}).catch(function (error) {
				if (error !== 'cancel') {
					_this.$message({
						message: error.message ? error.message : error,
						type: 'error'
					});
				}
			});
		},

		editData: function editData(index, row) {
			var formName = 'formData';

			this.editDialogVisible = true;

			if (!row) {
				this.dialogTitle = "添加";
				if (this.$refs[formName]) this.$refs[formName].resetFields();
				this.formData.id = "";
				this.formData.title = "";
				this.formData.status = "on";
				this.formData.remark = "";
			} else {
				this.dialogTitle = "编辑";
				this.formData.id = row.id;
				this.formData.title = row.title;
				this.formData.status = row.status;
				this.formData.remark = row.remark;

				if (this.$refs[formName]) this.$refs[formName].validate();
			}
		},

		openDialog: function openDialog() {
			var ele = document.getElementById('focus-ele');
			if (!!ele) {
				ele.focus();
			}
		},

		closeDialog: function closeDialog() {
			this.editDialogVisible = false;
		},

		handleSubmit: function handleSubmit(formName) {
			var _this2 = this;

			this.$refs[formName].validate(function (valid) {
				if (valid) {
					var _this = _this2;
					_this.$confirm('确认' + _this.dialogTitle + '返单券活动？', '提示', {
						type: 'warning'
					}).then(function () {
						_this.loading = true;
						if (!_this.formData.id) {
							var para = {
								title: _this.formData.title,
								status: _this.formData.status,
								remark: _this.formData.remark
							};

							(0, _api.addVoucherActivity)(para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						} else {
							var _para = {
								id: _this.formData.id,
								title: _this.formData.title,
								status: _this.formData.status,
								remark: _this.formData.remark
							};
							(0, _api.updateVoucherActivity)(_para, _this).then(function (res) {
								return res.data;
							}).then(function (data) {
								_this.loading = false;
								var msg = data.msg,
								    code = data.code;

								if (code !== "0") {
									_this.$message({
										message: msg,
										type: 'error'
									});
								} else {
									_this.$message({
										message: msg,
										type: 'success'
									});
									_this.getData();
								}
							});
						}
					}).catch(function (error) {
						if (error !== 'cancel') {
							_this.$message({
								message: error.message ? error.message : error,
								type: 'error'
							});
						}
					});
				} else {
					return false;
				}
			});
		}
	},

	created: function created() {},

	mounted: function mounted() {
		var _this3 = this;

		var _this = this;
		_this.containerHeight = _this.$refs.vouchercontainer.offsetHeight;

		_this.getData();

		window.onresize = function () {
			return function () {
				if (!_this3.timer && !!_this.$refs.vouchercontainer) {
					_this3.timer = true;
					_this.containerHeight = _this.$refs.vouchercontainer.offsetHeight;
					var that = _this3;
					setTimeout(function () {
						that.timer = false;
					}, 100);
				}
			}();
		};
	}
};

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(186);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(75);

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__(183);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(184);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(185);

var _createClass3 = _interopRequireDefault(_createClass2);

var _is = __webpack_require__(182);

var _is2 = _interopRequireDefault(_is);

var _promise = __webpack_require__(88);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(170);

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__(87);

var _store2 = _interopRequireDefault(_store);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var httpThis;

var instance = _axios2.default.create({
    baseURL: _emEnum2.default.url.baseURL,
    timeout: 180000 });

instance.interceptors.request.use(function (config) {
    var TOKEN = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.token, undefined);
    if (!!TOKEN) {
        config.headers['Content-Type'] = 'application/json';
        config.headers['token'] = TOKEN;
    }
    return config;
}, function (error) {
    console.warn(error);

    return _promise2.default.reject(error);
});

instance.interceptors.response.use(function (response) {
    var code = response.data.code;

    if ((0, _is2.default)(code, '-9')) {
        _util2.default.userData.reLogin(httpThis, false);
    }
    return response;
}, function (error) {
    httpThis.$message({
        message: '请求出错：' + error.message,
        type: 'error'
    });
    httpThis.loading = false;
    return _promise2.default.reject(error);
});

function isShowLoading(payload) {
    var loading = document.getElementById('loading');
    payload ? loading.style.display = 'block' : loading.style.display = 'none';
}

var http = function () {
    function http() {
        (0, _classCallCheck3.default)(this, http);
    }

    (0, _createClass3.default)(http, null, [{
        key: 'get',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(url, params, _this) {
                var CancelToken;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                httpThis = _this;
                                CancelToken = _axios2.default.CancelToken;
                                _context.next = 4;
                                return instance.get(url, {
                                    params: (0, _extends3.default)({}, params),

                                    cancelToken: new CancelToken(function executor(c) {
                                        _store2.default.state.httpRequestList.push(c);
                                    })
                                });

                            case 4:
                                return _context.abrupt('return', _context.sent);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function get(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            }

            return get;
        }()
    }, {
        key: 'post',
        value: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(url, params, _this) {
                var CancelToken;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                httpThis = _this;

                                params['channel'] = 'pc';
                                CancelToken = _axios2.default.CancelToken;
                                _context2.next = 5;
                                return instance.post(url, params, {
                                    cancelToken: new CancelToken(function executor(c) {
                                        _store2.default.state.httpRequestList.push(c);
                                    })
                                });

                            case 5:
                                return _context2.abrupt('return', _context2.sent);

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function post(_x4, _x5, _x6) {
                return _ref2.apply(this, arguments);
            }

            return post;
        }()
    }]);
    return http;
}();

exports.default = http;

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(186);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(75);

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__(183);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(184);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(185);

var _createClass3 = _interopRequireDefault(_createClass2);

var _is = __webpack_require__(182);

var _is2 = _interopRequireDefault(_is);

var _promise = __webpack_require__(88);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(170);

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__(87);

var _store2 = _interopRequireDefault(_store);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var httpThis;

var instance = _axios2.default.create({
    baseURL: _emEnum2.default.url.baseURL2,
    timeout: 180000 });

instance.interceptors.request.use(function (config) {
    var TOKEN = _util2.default.userData.getLoginUserFieldValue(_emEnum2.default.loginUserFileds.token, undefined);
    if (!!TOKEN) {
        config.headers['Content-Type'] = 'application/json';
        config.headers['token'] = TOKEN;
    }
    return config;
}, function (error) {
    console.warn(error);

    return _promise2.default.reject(error);
});

instance.interceptors.response.use(function (response) {
    var code = response.data.code;

    if ((0, _is2.default)(code, '-9')) {
        _util2.default.userData.reLogin(httpThis, false);
    }
    return response;
}, function (error) {
    httpThis.$message({
        message: '请求出错：' + error.message,
        type: 'error'
    });
    httpThis.loading = false;
    return _promise2.default.reject(error);
});

function isShowLoading(payload) {
    var loading = document.getElementById('loading');
    payload ? loading.style.display = 'block' : loading.style.display = 'none';
}

var http2 = function () {
    function http2() {
        (0, _classCallCheck3.default)(this, http2);
    }

    (0, _createClass3.default)(http2, null, [{
        key: 'get',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(url, params, _this) {
                var CancelToken;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                httpThis = _this;
                                CancelToken = _axios2.default.CancelToken;
                                _context.next = 4;
                                return instance.get(url, {
                                    params: (0, _extends3.default)({}, params),

                                    cancelToken: new CancelToken(function executor(c) {
                                        _store2.default.state.httpRequestList.push(c);
                                    })
                                });

                            case 4:
                                return _context.abrupt('return', _context.sent);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function get(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            }

            return get;
        }()
    }, {
        key: 'post',
        value: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(url, params, _this) {
                var CancelToken;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                httpThis = _this;

                                params['channel'] = 'pc';
                                CancelToken = _axios2.default.CancelToken;
                                _context2.next = 5;
                                return instance.post(url, params, {
                                    cancelToken: new CancelToken(function executor(c) {
                                        _store2.default.state.httpRequestList.push(c);
                                    })
                                });

                            case 5:
                                return _context2.abrupt('return', _context2.sent);

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function post(_x4, _x5, _x6) {
                return _ref2.apply(this, arguments);
            }

            return post;
        }()
    }]);
    return http2;
}();

exports.default = http2;

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(259);

var _vue = __webpack_require__(15);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(168);

var _vuex2 = _interopRequireDefault(_vuex);

var _vueRouter = __webpack_require__(271);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vueClipboard = __webpack_require__(267);

var _vueClipboard2 = _interopRequireDefault(_vueClipboard);

var _vueRegionPicker = __webpack_require__(270);

var _vueRegionPicker2 = _interopRequireDefault(_vueRegionPicker);

var _chinaAreaData = __webpack_require__(260);

var _chinaAreaData2 = _interopRequireDefault(_chinaAreaData);

var _routes = __webpack_require__(258);

var _routes2 = _interopRequireDefault(_routes);

var _store = __webpack_require__(87);

var _store2 = _interopRequireDefault(_store);

var _util = __webpack_require__(7);

var _util2 = _interopRequireDefault(_util);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _App = __webpack_require__(268);

var _App2 = _interopRequireDefault(_App);

var _Test = __webpack_require__(269);

var _Test2 = _interopRequireDefault(_Test);

var _elementUi = __webpack_require__(261);

var _elementUi2 = _interopRequireDefault(_elementUi);

var _afTableColumn = __webpack_require__(257);

var _afTableColumn2 = _interopRequireDefault(_afTableColumn);

__webpack_require__(264);

__webpack_require__(262);

__webpack_require__(263);

__webpack_require__(266);

__webpack_require__(265);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vuex2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vueClipboard2.default);
_vue2.default.use(_vueRegionPicker2.default, {
    region: _chinaAreaData2.default,
    vueVersion: 2
});

_vue2.default.use(_afTableColumn2.default);

var originalPush = _vueRouter2.default.prototype.push;
_vueRouter2.default.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(function (err) {
        return err;
    });
};

var router = new _vueRouter2.default({
    mode: 'history',
    routes: _routes2.default
});

router.beforeEach(function (to, from, next) {
    if (_store2.default.state.httpRequestList.length > 0) {
        _store2.default.state.httpRequestList.forEach(function (item) {
            item();
        });
        _store2.default.state.httpRequestList = [];
    }

    if (to.path == '/login') {
        _util2.default.userData.clearSessionStorage();
    }
    var user = JSON.parse(sessionStorage.getItem('user'));
    if (!user && to.path != '/login') {
        next({ path: '/login' });
    } else {
        next();
    }
});

new _vue2.default({
    router: router,
    store: _store2.default,

    render: function render(h) {
        return h(_App2.default);
    }
}).$mount('#app');

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(180);

var _assign2 = _interopRequireDefault(_assign);

exports.export_table_to_excel = export_table_to_excel;
exports.export_json_to_excel = export_json_to_excel;
exports.export_json_to_excel_mult = export_json_to_excel_mult;
exports.export_json_to_excel_multth = export_json_to_excel_multth;

var _fileSaver = __webpack_require__(251);

var _xlsx = __webpack_require__(254);

var _xlsx2 = _interopRequireDefault(_xlsx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generateArray(table) {
    var out = [];
    var rows = table.querySelectorAll('tr');
    var ranges = [];
    for (var R = 0; R < rows.length; ++R) {
        var outRow = [];
        var row = rows[R];
        var columns = row.querySelectorAll('td');
        for (var C = 0; C < columns.length; ++C) {
            var cell = columns[C];
            var colspan = cell.getAttribute('colspan');
            var rowspan = cell.getAttribute('rowspan');
            var cellValue = cell.innerText;
            if (cellValue !== "" && cellValue == +cellValue) cellValue = +cellValue;

            ranges.forEach(function (range) {
                if (R >= range.s.r && R <= range.e.r && outRow.length >= range.s.c && outRow.length <= range.e.c) {
                    for (var i = 0; i <= range.e.c - range.s.c; ++i) {
                        outRow.push(null);
                    }
                }
            });

            if (rowspan || colspan) {
                rowspan = rowspan || 1;
                colspan = colspan || 1;
                ranges.push({ s: { r: R, c: outRow.length }, e: { r: R + rowspan - 1, c: outRow.length + colspan - 1 } });
            }
            ;

            outRow.push(cellValue !== "" ? cellValue : null);

            if (colspan) for (var k = 0; k < colspan - 1; ++k) {
                outRow.push(null);
            }
        }
        out.push(outRow);
    }
    return [out, ranges];
};

function datenum(v, date1904) {
    if (date1904) v += 1462;
    var epoch = Date.parse(v);
    return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}

function sheet_from_array_of_arrays(data, opts) {
    var ws = {};
    var range = { s: { c: 10000000, r: 10000000 }, e: { c: 0, r: 0 } };
    for (var R = 0; R != data.length; ++R) {
        for (var C = 0; C != data[R].length; ++C) {
            if (range.s.r > R) range.s.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.r < R) range.e.r = R;
            if (range.e.c < C) range.e.c = C;
            var cell = { v: data[R][C] };
            if (cell.v == null) continue;
            var cell_ref = _xlsx2.default.utils.encode_cell({ c: C, r: R });

            if (typeof cell.v === 'number') cell.t = 'n';else if (typeof cell.v === 'boolean') cell.t = 'b';else if (cell.v instanceof Date) {
                cell.t = 'n';
                cell.z = _xlsx2.default.SSF._table[14];
                cell.v = datenum(cell.v);
            } else cell.t = 's';

            ws[cell_ref] = cell;
        }
    }
    if (range.s.c < 10000000) ws['!ref'] = _xlsx2.default.utils.encode_range(range);
    return ws;
}

function Workbook() {
    if (!(this instanceof Workbook)) return new Workbook();
    this.SheetNames = [];
    this.Sheets = {};
}

function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xFF;
    }return buf;
}

function export_table_to_excel(id) {
    var theTable = document.getElementById(id);
    var oo = generateArray(theTable);
    var ranges = oo[1];

    var data = oo[0];
    var ws_name = "SheetJS";

    var wb = new Workbook(),
        ws = sheet_from_array_of_arrays(data);

    ws['!merges'] = ranges;

    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;

    var wbout = _xlsx2.default.write(wb, { bookType: 'xlsx', bookSST: false, type: 'binary' });

    (0, _fileSaver.saveAs)(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), "test.xlsx");
}

function formatJson(jsonData) {
    console.log(jsonData);
}

function export_json_to_excel(th, jsonData, defaultTitle) {
    var data = jsonData;
    data.unshift(th);
    var ws_name = "SheetJS";

    var wb = new Workbook(),
        ws = sheet_from_array_of_arrays(data);

    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;

    var wbout = _xlsx2.default.write(wb, { bookType: 'xlsx', bookSST: false, type: 'binary' });
    var title = defaultTitle || '列表';
    (0, _fileSaver.saveAs)(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), title + ".xlsx");
}

function export_json_to_excel_mult(th, jsonData, sheetName, defaultTitle) {
    var wb = new Workbook();
    jsonData.forEach(function (item, index) {
        var ws_name = sheetName[index] || "SheetJS" + index;
        wb.SheetNames.push(ws_name);

        var data = item;
        data.unshift(th[index]);
        var ws = sheet_from_array_of_arrays(data);
        wb.Sheets[ws_name] = ws;
    });

    var wbout = _xlsx2.default.write(wb, { bookType: 'xlsx', bookSST: false, type: 'binary' });
    var title = defaultTitle || '列表';
    (0, _fileSaver.saveAs)(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), title + ".xlsx");
}

function getCharCol(n) {
    var s = '';
    var m = 0;
    while (n > 0) {
        m = n % 26 + 1;
        s = String.fromCharCode(m + 64) + s;
        n = (n - m) / 26;
    }
    return s;
}

function isRealNum(val) {
    if (val === "" || val == null) {
        return false;
    }
    if (!isNaN(val)) {
        return true;
    } else {
        return false;
    }
}

function s2ab_th(s) {
    if (typeof ArrayBuffer !== 'undefined') {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) {
            view[i] = s.charCodeAt(i) & 0xFF;
        }return buf;
    } else {
        var buf = new Array(s.length);
        for (var i = 0; i != s.length; ++i) {
            buf[i] = s.charCodeAt(i) & 0xFF;
        }return buf;
    }
}

function export_json_to_excel_multth(ths, jsonData, defaultTitle) {
    var data = jsonData;
    ths.forEach(function (th) {
        data.unshift(th);
    });
    var keyMap = [];
    for (var k in data) {
        keyMap.push(k);
    }
    var tmpdata = [];
    data.map(function (v, i) {
        return keyMap.map(function (k, j) {
            return (0, _assign2.default)({}, {
                v: v[k],
                position: (j > 25 ? getCharCol(j) : String.fromCharCode(65 + j)) + (i + 1)
            });
        });
    }).reduce(function (prev, next) {
        return prev.concat(next);
    }).forEach(function (v, i) {
        return tmpdata[v.position] = {
            v: v.v
        };
    });
    var outputPos = (0, _keys2.default)(tmpdata);
    tmpdata["!merges"] = [{
        s: { c: 3, r: 0 },
        e: { c: 5, r: 0 } }, {
        s: { c: 1, r: 1 },
        e: { c: 2, r: 1 } }, {
        s: { c: 4, r: 1 },
        e: { c: 6, r: 1 } }, {
        s: { c: 1, r: 2 },
        e: { c: 2, r: 2 } }, {
        s: { c: 4, r: 2 },
        e: { c: 6, r: 2 } }, {
        s: { c: 5, r: 3 },
        e: { c: 6, r: 3 } }, {
        s: { c: 3, r: 4 },
        e: { c: 8, r: 4 } }, {
        s: { c: 1, r: 5 },
        e: { c: 8, r: 5 } }, {
        s: { c: 1, r: 6 },
        e: { c: 8, r: 6 } }, {
        s: { c: 0, r: 7 },
        e: { c: 8, r: 7 } }];

    var tmpWB = {
        SheetNames: ["SheetJS"],
        Sheets: {
            "SheetJS": (0, _assign2.default)({}, tmpdata, {
                '!ref': outputPos[0] + ':' + outputPos[outputPos.length - 1] })
        }
    };
    var tmpDown = new Blob([s2ab_th(_xlsx2.default.write(tmpWB, { bookType: 'xlsx', bookSST: false, type: 'binary' }))], {});
    var title = defaultTitle || '列表';
    saveAs_th(tmpDown, title + ".xlsx");
}

function saveAs_th(obj, fileName) {
    if ('msSaveOrOpenBlob' in navigator) {
        window.navigator.msSaveOrOpenBlob(obj, fileName);
        return;
    }
    var tmpa = document.createElement("a");
    tmpa.download = fileName || "下载";
    tmpa.href = URL.createObjectURL(obj);
    tmpa.click();
    setTimeout(function () {
        URL.revokeObjectURL(obj);
    }, 100);
}

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var increment = exports.increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = exports.decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCount = exports.getCount = function getCount(state) {
    return state.count;
};

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(645)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(710),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(629)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(693),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    cnName: '韩旭化妆品管理平台',
    enName: 'han xu cosmetics management platform',
    version: '24.09.12.01',
    url: {
        baseURL: 'https://ybn.api.hyfun.net/shhzp',
        baseURL2: 'https://ybnv2.api.hyfun.net/api/v2',
        clientsTemplateURL: 'https://hx-new-shop-1256701284.cos.ap-shanghai.myqcloud.com/%E5%AE%A2%E6%88%B7%E5%AF%BC%E5%85%A5%E6%A0%B7%E8%A1%A8.xlsx',
        logisticsTemplateURL: 'https://hx-new-shop-1256701284.cos.ap-shanghai.myqcloud.com/%E7%89%A9%E6%B5%81%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx' },

    rootMenuArray: [{ key: 1, value: '广告管理' }, { key: 2, value: '广告清单' }, { key: 3, value: '视频清单' }, { key: 4, value: '客户管理' }, { key: 5, value: '商品管理' }, { key: 6, value: '商品分类' }, { key: 7, value: '商品清单' }, { key: 9, value: '订单管理' }, { key: 10, value: '促销管理' }, { key: 11, value: '系统管理' }, { key: 12, value: '用户管理' }, { key: 13, value: '区域管理' }, { key: 14, value: '修改密码' }, { key: 15, value: '退出登录' }, { key: 16, value: '物流管理' }, { key: 17, value: '返单券管理' }, { key: 18, value: '返单券活动' }, { key: 19, value: '返单券明细' }],
    adminMenuArray: [{ key: 9, value: '订单管理' }, { key: 11, value: '系统管理' }, { key: 14, value: '修改密码' }, { key: 15, value: '退出登录' }, { key: 16, value: '物流管理' }],
    receptionMenuArray: [{ key: 9, value: '订单管理' }, { key: 11, value: '系统管理' }, { key: 14, value: '修改密码' }, { key: 15, value: '退出登录' }],
    logisticsMenuArray: [{ key: 16, value: '物流管理' }, { key: 11, value: '系统管理' }, { key: 14, value: '修改密码' }, { key: 15, value: '退出登录' }],

    allowLoginRole: [1, 2, 3, 4],
    roleOptions: [{ key: 1, value: "超级管理员" }, { key: 2, value: "区域管理员" }, { key: 3, value: "订单管理员" }, { key: 4, value: "物流管理员" }],
    agencyRoleOptions: [{ key: 1, value: "培训公司" }, { key: 2, value: "销售公司" }, { key: 3, value: "代理1" }, { key: 4, value: "代理2" }],
    statusOptions: [{ key: 0, value: "启用" }, { key: 1, value: "禁用" }, { key: 2, value: "待审核" }],
    stepTypeOptions: [{ key: 4, value: "主选购" }, { key: 1, value: "产品促销" }, { key: 2, value: "其他促销" }, { key: 3, value: "特别促销" }],
    promotionTypeOptions: [{ key: 1, value: "普通促销" }],
    useVoucherOptions: [{ key: 1, value: "可用" }, { key: 0, value: "不可用" }],
    orderTypeOptions: [{ key: '1', value: "活动订单" }, { key: '2', value: "促销订单" }],
    orderStatusOptions: [{ key: '0', value: "待支付" }, { key: '1', value: "已付款" }, { key: '2', value: "已发货" }, { key: '3', value: "已完成" }, { key: '-3', value: "同步失败" }],
    inventoryStatusOptions: [{ key: '0', value: "启用" }, { key: '1', value: "禁用" }],
    isreportedOptions: [{ key: '0', value: "已报备" }, { key: '1', value: "未报备" }],
    fuzzyFieldOptions: [{ key: 'consignee', value: "收货人" }, { key: 'ordercaretername', value: "下单人" }, { key: 'pagencyname', value: "销售公司" }, { key: 'cagencyname', value: "代理1" }, { key: 'tagencyname', value: "代理2" }],
    loginUserFileds: {
        "uid": "id",
        "username": "username",
        "role": "role",
        "areaid": "areaid",
        "creattime": "creattime",
        "token": "token",
        "pwdOriginal": "pwdOriginal",
        "status": "status",
        "wxaccount": "wxaccount" },

    voucherStatusOptions: [{ key: 'on', value: "发布" }, { key: 'off', value: "下架" }],
    usedOptions: [{ key: 0, value: "未消费" }, { key: 1, value: "已消费" }],
    voucherFuzzyFieldOptions: [{ key: 'id', value: "返单券ID" }, { key: 'ordercaretername', value: "客户姓名" }, { key: 'franchisee', value: "加盟商姓名" }] };

/***/ }),

/***/ 628:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 629:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 630:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 631:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 632:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 633:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 634:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 635:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 636:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 637:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 638:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 639:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 640:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 641:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 642:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 644:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 645:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 646:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 647:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 648:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 649:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 651:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 652:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 653:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 654:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 655:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.3081d95.png";

/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(632)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(697),
  /* scopeId */
  "data-v-0e9fdaaa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(642)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(707),
  /* scopeId */
  "data-v-4bc6247d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(641)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(706),
  /* scopeId */
  "data-v-4ae351bb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(655)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(720),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(631)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(696),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(640)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(705),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(633)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(698),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(654)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(719),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(651)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(716),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(637)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(702),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(635)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(700),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(650)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(715),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(634)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(699),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(647)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(712),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(628)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(692),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(649)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(714),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(638)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(703),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(639)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(704),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(630)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(694),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(636)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(701),
  /* scopeId */
  "data-v-2e2561ce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  null,
  /* template */
  __webpack_require__(695),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(644)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(709),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(653)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(718),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(648)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(713),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 692:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "processlabelcontainer",
    staticClass: "processlabel-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.preStep
    }
  }, [_vm._v("返回到促销步骤")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary",
      "disabled": _vm.submitSortDisabled
    },
    on: {
      "click": _vm.submitSort
    }
  }, [_vm._v("提交排序")]), _vm._v(" "), _c('LayerPath', {
    ref: "LayerPath",
    staticClass: "layerPath",
    on: {
      "promotionStepChange": _vm.promotionStepChange
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 55,
      "highlight-current-row": "",
      "id": "out-table",
      "border": "",
      "row-key": "id"
    },
    on: {
      "row-click": _vm.handleRowChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "labelname",
      "label": "名称",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "steptitle",
      "label": "父级促销步骤",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.delData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]), _vm._v("|\n\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.enableData(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status === 0 ? '禁用' : '启用'))]), _vm._v("|\n\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 693:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-image', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.fileUrl,
      "fit": "cover"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('a', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "file",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.btnText) + "\n    \t\t\t"), _c('input', {
    attrs: {
      "id": "file",
      "type": "file",
      "accept": "image/gif, image/jpg, image/jpeg, image/png, image/bmp"
    },
    on: {
      "change": function($event) {
        return _vm.uploadFile($event)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticStyle: {
      "display": "block",
      "margin-left": "20px"
    }
  }, [_vm._v("300x100  最大3M")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 694:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "areacontainer",
    staticClass: "area-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 55,
      "highlight-current-row": "",
      "id": "out-table",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "areaname",
      "label": "团队名",
      "align": "center",
      "min-width": "50%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isinternal",
      "label": "是否内部员工",
      "formatter": _vm.formatIsinternal,
      "align": "center",
      "min-width": "25%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "creattime",
      "label": "创建时间",
      "formatter": _vm.formatCreatTime,
      "align": "center",
      "min-width": "50%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.delData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.enableData(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status === 0 ? '禁用' : '启用'))]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.searchData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查找客户")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "120px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "团队名",
      "prop": "areaName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "id": "focus-ele"
    },
    model: {
      value: (_vm.formData.areaName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "areaName", $$v)
      },
      expression: "formData.areaName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否内部员工",
      "prop": "isinternal"
    }
  }, [
    [_c('el-radio', {
      staticStyle: {
        "margin-left": "70px"
      },
      attrs: {
        "label": "yes"
      },
      model: {
        value: (_vm.formData.isinternal),
        callback: function($$v) {
          _vm.$set(_vm.formData, "isinternal", $$v)
        },
        expression: "formData.isinternal"
      }
    }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "no"
      },
      model: {
        value: (_vm.formData.isinternal),
        callback: function($$v) {
          _vm.$set(_vm.formData, "isinternal", $$v)
        },
        expression: "formData.isinternal"
      }
    }, [_vm._v("否")])]
  ], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 695:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),

/***/ 696:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "bannercontainer",
    staticClass: "banner-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary",
      "disabled": _vm.submitSortDisabled
    },
    on: {
      "click": _vm.submitSort
    }
  }, [_vm._v("提交排序")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 55,
      "highlight-current-row": "",
      "id": "out-table",
      "border": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "thumimage",
      "label": "图片",
      "align": "center",
      "min-width": "20%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-image', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!!scope.row.thumimage),
            expression: "!!scope.row.thumimage"
          }],
          staticStyle: {
            "width": "50px",
            "height": "50px"
          },
          attrs: {
            "src": scope.row.thumimage,
            "fit": "cover"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "formatter": _vm.formatStatus,
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.delData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.enableData(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status === 0 ? '禁用' : '启用'))]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "图片",
      "prop": ""
    }
  }, [_c('UploadFile', {
    ref: "UploadFile",
    attrs: {
      "imgUrl": _vm.formData.thumimage
    },
    on: {
      "getFileUrl": _vm.getFileUrl
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 697:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page-container"
  }, [_c('p', {
    staticClass: "page-header"
  }, [_vm._v("404")]), _vm._v(" "), _c('p', {
    staticClass: "page-body"
  }, [_vm._v("抱歉！您访问的页面不存在，请重新加载......")]), _vm._v(" "), _c('el-link', {
    staticClass: "page-return",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.returnHomePage
    }
  }, [_vm._v("< 返回主页")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 698:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "clientcontainer",
    staticClass: "client-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6,
      "align": "left"
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editCol
    }
  }, [_vm._v("设置显示列")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "left"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "98%"
    },
    attrs: {
      "placeholder": "请选择区域"
    },
    on: {
      "change": _vm.areaFilter
    },
    model: {
      value: (_vm.sortAreaId),
      callback: function($$v) {
        _vm.sortAreaId = $$v
      },
      expression: "sortAreaId"
    }
  }, _vm._l((_vm.allAreaDatas), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.areaname,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "align": "right"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "98%"
    },
    attrs: {
      "clearable": "",
      "type": "date",
      "placeholder": "注册时间起",
      "picker-options": _vm.startPickerOptions
    },
    on: {
      "change": _vm.createTimeChange
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "align": "left"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "98%"
    },
    attrs: {
      "clearable": "",
      "type": "date",
      "placeholder": "注册时间止",
      "picker-options": _vm.endPickerOptions
    },
    on: {
      "change": _vm.createTimeChange
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "right"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "98%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择启用、禁用状态"
    },
    on: {
      "change": _vm.areaFilter
    },
    model: {
      value: (_vm.statusKey),
      callback: function($$v) {
        _vm.statusKey = $$v
      },
      expression: "statusKey"
    }
  }, _vm._l((_vm.statusOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "align": "right"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "98%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "快速搜索"
    },
    on: {
      "change": _vm.searchList
    },
    model: {
      value: (_vm.vagueContent),
      callback: function($$v) {
        _vm.vagueContent = $$v
      },
      expression: "vagueContent"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "align": "right"
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.downloadTemplate
    }
  }, [_vm._v("下载导入模板")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "center"
    }
  }, [_c('a', {
    staticClass: "file importFile",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("导入Excel\n\t\t\t\t\t\t"), _c('input', {
    attrs: {
      "id": "file",
      "type": "file",
      "accept": ".xlsx, .xls, .csv"
    },
    on: {
      "change": function($event) {
        return _vm.importExcel($event)
      }
    }
  })])])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 85,
      "highlight-current-row": "",
      "id": "out-table",
      "border": ""
    }
  }, [_c('af-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNum - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), (_vm.colUnShowKeys.indexOf('code') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "code",
      "label": "客户编码",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('reallyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "reallyname",
      "label": "客户姓名",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('areaname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "areaname",
      "label": "所属团队",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('aagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "aagencyname",
      "label": "培训公司",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('pagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "pagencyname",
      "label": "销售公司",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('cagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "cagencyname",
      "label": "代理1",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('tagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "tagencyname",
      "label": "代理2",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('province') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "province",
      "label": "省",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('city') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "city",
      "label": "市",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('district') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "district",
      "label": "县（区）",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('address') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "address",
      "label": "详细地址",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('linkphone') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "linkphone",
      "label": "联系电话",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('agencyrole') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "agencyrole",
      "label": "代理级别",
      "formatter": _vm.formatAgencyRole,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('status') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "status",
      "label": " 状态 ",
      "formatter": _vm.formatStatus,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('creattime') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "creattime",
      "label": "注册时间",
      "formatter": _vm.formatCreatTime,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), _c('af-table-column', {
    key: Math.random(),
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.role === 1 || (scope.row.status !== 0 && scope.row.status !== 1)) ? _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.delData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), (_vm.role === 1 || (scope.row.status !== 0 && scope.row.status !== 1)) ? _c('span', [_vm._v("|")]) : _vm._e(), _vm._v(" "), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.enableData(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s((scope.row.status === 1 || scope.row.status === 2 ? '启用' : '禁用')))]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "pageSize": _vm.pageSize,
      "pageNum": _vm.pageNum,
      "totalNum": _vm.totalNum
    },
    on: {
      "handlePageSizeChange": _vm.handlePageSizeChange,
      "handlePageCurrentChange": _vm.handlePageCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": "设置显示列",
      "visible": _vm.colDialogVisible,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.colDialogVisible = $event
      },
      "close": _vm.closeColSet
    }
  }, [_c('el-transfer', {
    staticStyle: {
      "width": "500px",
      "margin": "15px auto"
    },
    attrs: {
      "data": _vm.colDatas,
      "titles": ['显示列', '不显示列']
    },
    model: {
      value: (_vm.colUnShowKeys),
      callback: function($$v) {
        _vm.colUnShowKeys = $$v
      },
      expression: "colUnShowKeys"
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "500px",
      "height": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户编码",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.codeDisabled
    },
    model: {
      value: (_vm.formData.code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "code", $$v)
      },
      expression: "formData.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客户姓名",
      "prop": "reallyname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "id": "focus-ele"
    },
    model: {
      value: (_vm.formData.reallyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "reallyname", $$v)
      },
      expression: "formData.reallyname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属团队",
      "prop": "areaid"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formData.areaid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "areaid", $$v)
      },
      expression: "formData.areaid"
    }
  }, _vm._l((_vm.areaDatas), function(item) {
    return _c('el-option', {
      key: item.areaId,
      attrs: {
        "label": item.areaName,
        "value": item.areaId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理级别",
      "prop": "agencyrole"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.roleChange
    },
    model: {
      value: (_vm.formData.agencyrole),
      callback: function($$v) {
        _vm.$set(_vm.formData, "agencyrole", $$v)
      },
      expression: "formData.agencyrole"
    }
  }, _vm._l((_vm.agencyRoleOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.agencyShow),
      expression: "agencyShow"
    }],
    attrs: {
      "label": "培训公司",
      "prop": "aagencyid"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formData.aagencyid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "aagencyid", $$v)
      },
      expression: "formData.aagencyid"
    }
  }, _vm._l((_vm.agencyDatas), function(item) {
    return _c('el-option', {
      key: item.aagencyid,
      attrs: {
        "label": item.aagencyname,
        "value": item.aagencyid
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pagencyShow),
      expression: "pagencyShow"
    }],
    attrs: {
      "label": "销售公司",
      "prop": "pagencyname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.pagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "pagencyname", $$v)
      },
      expression: "formData.pagencyname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cagencyShow),
      expression: "cagencyShow"
    }],
    attrs: {
      "label": "代 理 1",
      "prop": "cagencyname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.cagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cagencyname", $$v)
      },
      expression: "formData.cagencyname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tagencyShow),
      expression: "tagencyShow"
    }],
    attrs: {
      "label": "代 理 2",
      "prop": "tagencyname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.tagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tagencyname", $$v)
      },
      expression: "formData.tagencyname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "prop": "linkphone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.linkphone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "linkphone", $$v)
      },
      expression: "formData.linkphone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "省市县(区)",
      "prop": ""
    }
  }, [_c('region-picker', {
    attrs: {
      "placeholder": {
        province: '选择省份',
        city: '选择市',
        district: '选择县（区）'
      },
      "province": _vm.formData.region.province,
      "city": _vm.formData.region.city,
      "district": _vm.formData.region.district
    },
    on: {
      "onchange": _vm.regionChange
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 699:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "ordercontainer",
    staticClass: "order-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8,
      "align": "left"
    }
  }, [_c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editCol
    }
  }, [_vm._v("设置显示列")]), _vm._v(" "), (_vm.loginRole !== 2) ? _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出订单")]) : _vm._e(), _vm._v(" "), (_vm.loginRole !== 2) ? _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportDetailExcelByPageNum
    }
  }, [_vm._v("导出明细")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "left"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "98%"
    },
    attrs: {
      "placeholder": "按区域搜索"
    },
    on: {
      "change": _vm.searchList
    },
    model: {
      value: (_vm.sortAreaId),
      callback: function($$v) {
        _vm.sortAreaId = $$v
      },
      expression: "sortAreaId"
    }
  }, _vm._l((_vm.allAreaDatas), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.areaname,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "left"
    }
  }, [(_vm.loginRole === 1) ? _c('el-select', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "按培训公司搜索"
    },
    on: {
      "change": _vm.searchList
    },
    model: {
      value: (_vm.aagencyid),
      callback: function($$v) {
        _vm.aagencyid = $$v
      },
      expression: "aagencyid"
    }
  }, _vm._l((_vm.agencyDatas), function(item) {
    return _c('el-option', {
      key: item.aagencyid,
      attrs: {
        "label": item.aagencyname,
        "value": item.aagencyid
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "left"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "按订单状态搜索"
    },
    on: {
      "change": _vm.searchList
    },
    model: {
      value: (_vm.paystatus),
      callback: function($$v) {
        _vm.paystatus = $$v
      },
      expression: "paystatus"
    }
  }, _vm._l((_vm.orderStatusOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "center"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "clearable": "",
      "placeholder": "订单日期起",
      "picker-options": _vm.startPickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.orderTimeChange('start')
      }
    },
    model: {
      value: (_vm.orderStartime),
      callback: function($$v) {
        _vm.orderStartime = $$v
      },
      expression: "orderStartime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "center"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "clearable": "",
      "placeholder": "订单日期止",
      "picker-options": _vm.endPickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.orderTimeChange('end')
      }
    },
    model: {
      value: (_vm.orderEndtime),
      callback: function($$v) {
        _vm.orderEndtime = $$v
      },
      expression: "orderEndtime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "right"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "搜索字段"
    },
    on: {
      "change": _vm.searchColumn
    },
    model: {
      value: (_vm.fuzzyField),
      callback: function($$v) {
        _vm.fuzzyField = $$v
      },
      expression: "fuzzyField"
    }
  }, _vm._l((_vm.fuzzyFieldOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "align": "ceter"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "搜索内容"
    },
    on: {
      "change": _vm.searchList
    },
    model: {
      value: (_vm.vague),
      callback: function($$v) {
        _vm.vague = $$v
      },
      expression: "vague"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 85,
      "highlight-current-row": "",
      "id": "out-table",
      "border": "",
      "row-key": "id"
    }
  }, [_c('af-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNum - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), (_vm.colUnShowKeys.indexOf('code') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "code",
      "label": "订单单号",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('creatdate') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "creattime1",
      "label": " 订单日期 ",
      "formatter": _vm.formatCreatdate,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('creattime') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "creattime2",
      "label": "订单时间",
      "formatter": _vm.formatCreattime,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('ordercaretername') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "ordercaretername",
      "label": "下单人",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('aagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "aagencyname",
      "label": "培训公司",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('pagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "pagencyname",
      "label": "销售公司",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('cagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "cagencyname",
      "label": "代理1",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('tagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "tagencyname",
      "label": "代理2",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('consignee') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "consignee",
      "label": "收货人",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('linkphone') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "linkphone",
      "label": "收货电话",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('province') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "province",
      "label": "省",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('city') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "city",
      "label": "市",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('district') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "district",
      "label": "县（区）",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('promotiontitle') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "promotiontitle",
      "label": "促销标题",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('totalamount') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "totalamount",
      "label": "实际总金额",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('voucherid') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "voucherid",
      "label": "返单券ID",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('voucheramount') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "voucheramount",
      "label": "返单券金额",
      "formatter": _vm.formatVoucherAmount,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('paystatus') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "paystatus",
      "label": "订单状态",
      "formatter": _vm.formatPaystatus,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('u8id') === -1) ? _c('af-table-column', {
    attrs: {
      "label": "U8ID",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.paystatus === '-3') ? _c('label', {
          staticStyle: {
            "text-decoration": "underline",
            "color": "#d0326c",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.checkU8idPayfailreason(scope.$index, scope.row)
            }
          }
        }, [_vm._v("同步失败！")]) : _vm._e(), _vm._v(" "), (scope.row.paystatus !== '-3') ? _c('label', [_vm._v(_vm._s(scope.row.u8id))]) : _vm._e()]
      }
    }], null, false, 910277675)
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('franchisee') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "franchisee",
      "label": "加盟商姓名",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('finaladdress') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "finaladdress",
      "label": "收货地址",
      "align": "left"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('remark') === -1) ? _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center",
      "min-width": "150"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('isreported') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "isreported",
      "label": "是否报备",
      "formatter": _vm.formatIsreported,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('storename') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "storename",
      "label": "店铺名称",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('notreportreason') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "notreportreason",
      "label": "未报备原因",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('ordertype') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "ordertype",
      "label": "订单类型",
      "formatter": _vm.formatOrderType,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), _c('af-table-column', {
    key: Math.random(),
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "130",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.currentOpDataList.indexOf(scope.row.code) >= 0),
            expression: "currentOpDataList.indexOf(scope.row.code) >= 0"
          }],
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.nextStep(scope.$index, scope.row)
            }
          }
        }, [_vm._v("详情")]), _vm._v("|\n\t\t\t\t\t"), _c('el-dropdown', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.currentOpDataList.indexOf(scope.row.code) >= 0),
            expression: "currentOpDataList.indexOf(scope.row.code) >= 0"
          }],
          staticStyle: {
            "line-height": "0"
          },
          attrs: {
            "trigger": "hover"
          }
        }, [_c('label', {
          staticClass: "edit-content edit-more"
        }, [_vm._v("更多")]), _vm._v(" "), _c('el-dropdown-menu', {
          staticClass: "edit-more-content",
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [(scope.row.paystatus === '0' || !scope.row.paystatus || (_vm.loginRole === 1 && scope.row.paystatus === '-3')) ? _c('el-dropdown-item', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.loading),
            expression: "loading"
          }],
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editPaystatusData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("付款")]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), (_vm.loginRole === 1 || scope.row.paystatus === '0') ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.delData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e()], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "pageSize": _vm.pageSize,
      "pageNum": _vm.pageNum,
      "totalNum": _vm.totalNum
    },
    on: {
      "handlePageSizeChange": _vm.handlePageSizeChange,
      "handlePageCurrentChange": _vm.handlePageCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": "设置显示列",
      "visible": _vm.colDialogVisible,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.colDialogVisible = $event
      },
      "close": _vm.closeColSet
    }
  }, [_c('el-transfer', {
    staticStyle: {
      "width": "500px",
      "margin": "15px auto"
    },
    attrs: {
      "data": _vm.colDatas,
      "titles": ['显示列', '不显示列']
    },
    model: {
      value: (_vm.colUnShowKeys),
      callback: function($$v) {
        _vm.colUnShowKeys = $$v
      },
      expression: "colUnShowKeys"
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "800px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单编号",
      "prop": "code"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "code", $$v)
      },
      expression: "formData.code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单日期",
      "prop": "creattime"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.creattime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "creattime", $$v)
      },
      expression: "formData.creattime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "下单人",
      "prop": "ordercaretername"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.ordercaretername),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ordercaretername", $$v)
      },
      expression: "formData.ordercaretername"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "培训公司",
      "prop": ""
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择",
      "id": "focus-ele"
    },
    model: {
      value: (_vm.formData.aagencyid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "aagencyid", $$v)
      },
      expression: "formData.aagencyid"
    }
  }, _vm._l((_vm.agencyDatas), function(item) {
    return _c('el-option', {
      key: item.aagencyid,
      attrs: {
        "label": item.aagencyname,
        "value": item.aagencyid
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "销售公司",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.pagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "pagencyname", $$v)
      },
      expression: "formData.pagencyname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代理1",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.cagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cagencyname", $$v)
      },
      expression: "formData.cagencyname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代理2",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.tagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tagencyname", $$v)
      },
      expression: "formData.tagencyname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货人",
      "prop": "consignee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.consignee),
      callback: function($$v) {
        _vm.$set(_vm.formData, "consignee", $$v)
      },
      expression: "formData.consignee"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货电话",
      "prop": "linkphone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.linkphone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "linkphone", $$v)
      },
      expression: "formData.linkphone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "省市县(区)",
      "prop": "province"
    }
  }, [_c('region-picker', {
    attrs: {
      "placeholder": {
        province: '选择省份',
        city: '选择市',
        district: '选择县（区）'
      },
      "province": _vm.formData.region.province,
      "city": _vm.formData.region.city,
      "district": _vm.formData.region.district
    },
    on: {
      "onchange": _vm.regionChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备    注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "加盟商姓名",
      "prop": "franchisee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.franchisee),
      callback: function($$v) {
        _vm.$set(_vm.formData, "franchisee", $$v)
      },
      expression: "formData.franchisee"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否报备",
      "prop": "isreported"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formData.isreported),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isreported", $$v)
      },
      expression: "formData.isreported"
    }
  }, _vm._l((_vm.isreportedOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "店铺名称",
      "prop": "storename"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.storename),
      callback: function($$v) {
        _vm.$set(_vm.formData, "storename", $$v)
      },
      expression: "formData.storename"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "未报备原因",
      "prop": "notreportreason"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "maxlength": "18"
    },
    model: {
      value: (_vm.formData.notreportreason),
      callback: function($$v) {
        _vm.$set(_vm.formData, "notreportreason", $$v)
      },
      expression: "formData.notreportreason"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单类型",
      "prop": "ordertype"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.editDisabled
    },
    on: {
      "change": _vm.ordertypeChange
    },
    model: {
      value: (_vm.formData.ordertype),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ordertype", $$v)
      },
      expression: "formData.ordertype"
    }
  }, _vm._l((_vm.orderTypeOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "促销标题",
      "prop": "promotiontitle"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.promotiontitleDisabled
    },
    model: {
      value: (_vm.formData.promotiontitle),
      callback: function($$v) {
        _vm.$set(_vm.formData, "promotiontitle", $$v)
      },
      expression: "formData.promotiontitle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实际总金额",
      "prop": "totalamount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.editDisabled
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.cash.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.formData.totalamount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "totalamount", $$v)
      },
      expression: "formData.totalamount"
    }
  })], 1)], 1), _vm._v(" "), (_vm.formData.paystatus === '0') ? _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单状态",
      "prop": ""
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickPaystatus
    }
  }, [_vm._v("付款")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": '查看物流',
      "visible": _vm.logisticsDialogVisible,
      "width": "700px"
    },
    on: {
      "update:visible": function($event) {
        _vm.logisticsDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.logisticsDatas,
      "stripe": true,
      "height": 400,
      "highlight-current-row": "",
      "id": "out-table",
      "border": "",
      "row-key": "id"
    }
  }, [_c('af-table-column', {
    attrs: {
      "prop": "name",
      "label": "订单单号",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "code",
      "label": "下单时间",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "type",
      "label": "下单人",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "unit",
      "label": "物流信息",
      "align": "center",
      "min-width": "40%"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center",
      "min-width": "20%"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": '导出订单明细进度',
      "visible": _vm.progressDialogVisible,
      "width": "700px",
      "before-close": _vm.beforeCloseProgressDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.progressDialogVisible = $event
      },
      "opened": _vm.openProgressDialog
    }
  }, [_c('el-row', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-progress', {
    staticStyle: {
      "margin": "15px 20px"
    },
    attrs: {
      "text-inside": true,
      "stroke-width": 24,
      "percentage": _vm.progressPercentage,
      "status": "success"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('span', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "font-size": "35px",
      "line-height": "65px"
    },
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": '同步U8ID失败原因',
      "visible": _vm.u8idDialogVisible,
      "width": "700px"
    },
    on: {
      "update:visible": function($event) {
        _vm.u8idDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "200px",
      "margin": "30px",
      "color": "red",
      "font-size": "20px",
      "line-height": "30px"
    }
  }, [_vm._v(_vm._s(_vm.u8idPayfailreason))])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(88);

var _promise2 = _interopRequireDefault(_promise);

var _store = __webpack_require__(87);

var _store2 = _interopRequireDefault(_store);

var _emEnum = __webpack_require__(6);

var _emEnum2 = _interopRequireDefault(_emEnum);

var _fileSaver = __webpack_require__(251);

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _xlsx = __webpack_require__(254);

var _xlsx2 = _interopRequireDefault(_xlsx);

var _Export2Excel = __webpack_require__(341);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SIGN_REGEXP = /([yMdHhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

var yyyyMMdd2DateRegex = /^(\d{4})(\d{2})(\d{2})$/;

exports.default = {
    Regex: {
        yyyyMMdd2DateRegex: yyyyMMdd2DateRegex,
        longDateRegex: /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/
    },

    getQueryStringByName: function getQueryStringByName(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null) context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },

    formatDate: {
        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'H':
                        return padding(date.getHours(), $0.length);
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },

        yyyyMMdd2Caption: function yyyyMMdd2Caption(prefix, dateString) {
            var dateStr = this.yyyyMMdd2Date(dateString);
            var week = this.date2Week(prefix, dateStr);
            var formatStr = this.format(new Date(dateStr), "M月d日");
            return week + ' ' + formatStr;
        },

        date2Caption: function date2Caption(prefix, dateString) {
            var week = this.date2Week(prefix, dateString);
            var formatStr = this.format(new Date(dateString), "M月d日");
            return week + ' ' + formatStr;
        },

        dateIsBlongRange: function dateIsBlongRange(dateString, dateRange) {
            var date = this.format(new Date(dateString.replace(/-/g, '/')), "yyyy-MM-dd HH:mm:ss");
            var dateDate = new Date(date.replace(/-/g, '/'));

            var begin = dateRange.substr(0, dateRange.indexOf("~"));
            var end = dateRange.substr(dateRange.indexOf("~") + 1);
            var dateStr = this.format(new Date(dateString.replace(/-/g, '/')), "yyyy-MM-dd");
            var beginDate = new Date(dateStr.replace(/-/g, '/') + " " + begin + ":00");
            var endDate = new Date(dateStr.replace(/-/g, '/') + " " + end + ":00");

            return !!dateDate && !!beginDate && !!endDate && beginDate <= dateDate && endDate > dateDate;
        },

        yyyyMMdd2Date: function yyyyMMdd2Date(dateString) {
            if (!!dateString) {
                return dateString.replace(yyyyMMdd2DateRegex, "$1-$2-$3");
            }
            return null;
        },

        date2Week: function date2Week(prefix, dateString) {
            if (!!dateString) {
                var date = new Date(dateString.replace(/-/g, '/'));
                return prefix + "日一二三四五六".charAt(date.getDay());
            }
            return prefix;
        },

        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);break;
                        case 'M':
                            _date.setMonth(_int - 1);break;
                        case 'd':
                            _date.setDate(_int);break;
                        case 'H':
                            _date.setHours(_int);break;
                        case 'h':
                            _date.setHours(_int);break;
                        case 'm':
                            _date.setMinutes(_int);break;
                        case 's':
                            _date.setSeconds(_int);break;
                    }
                }
                return _date;
            }
            return null;
        }
    },

    importExcel: function importExcel(file) {},
    file2Xce: function file2Xce(file) {
        return new _promise2.default(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function (e) {
                var _this2 = this;

                var data = e.target.result;
                this.wb = _xlsx2.default.read(data, {
                    type: 'binary'
                });
                var result = [];
                this.wb.SheetNames.forEach(function (sheetName) {
                    result.push({
                        sheetName: sheetName,
                        sheet: _xlsx2.default.utils.sheet_to_json(_this2.wb.Sheets[sheetName], { defval: "" })
                    });
                });
                resolve(result);
            };

            reader.readAsBinaryString(file);
        });
    },

    exportExcel: function exportExcel(fileName, outTable) {
        var xlsxParam = { raw: true };

        var wb = _xlsx2.default.utils.table_to_book(outTable, xlsxParam);

        var wbout = _xlsx2.default.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
        try {
            _fileSaver2.default.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), fileName + '.xlsx');
        } catch (e) {
            if (typeof console !== 'undefined') console.log(e, wbout);
        }
        return wbout;
    },

    exportJsonToExcel: function exportJsonToExcel(fileName, outJson, tHeader, filterVal) {
        outJson = JSON.parse(outJson);
        var data = this.formatJson(outJson, filterVal);
        (0, _Export2Excel.export_json_to_excel)(tHeader, data, fileName);
    },
    exportJsonToExcelMult: function exportJsonToExcelMult(fileName, outJson, heads, filters, sheetName) {
        var _this = this;
        var outData = [];
        outJson = JSON.parse(outJson);
        outJson.forEach(function (item, index) {
            var data = _this.formatJson(item, filters[index]);
            outData.push(data);
        });
        (0, _Export2Excel.export_json_to_excel_mult)(heads, outData, sheetName, fileName);
    },
    exportJsonToExcelMultTh: function exportJsonToExcelMultTh(fileName, outJson, tHeader, filterVal) {
        outJson = JSON.parse(outJson);
        var data = this.formatJson(outJson, filterVal);
        (0, _Export2Excel.export_json_to_excel_multth)(tHeader, data, fileName);
    },

    formatJson: function formatJson(jsonData, filterVal) {
        return jsonData.map(function (v) {
            return filterVal.map(function (j) {
                return v[j];
            });
        });
    },

    userData: {
        getLoginUserFieldValue: function getLoginUserFieldValue(filed, _this) {
            if (!_store2.default.state.loginUser || _store2.default.state.loginUser === undefined) {

                var user = sessionStorage.getItem('user');
                if (user) {
                    _store2.default.state.loginUser = JSON.parse(user);
                } else {
                    if (!!_this && _emEnum2.default.unLoginPathArray.indexOf(_this.$route.path) < 0) {
                        this.reLogin(_this);
                    } else {
                        return '';
                    }
                }
            }

            return _store2.default.state.loginUser[filed];
        },

        reLogin: function reLogin(_this) {
            var tip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var msg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '用户失效，请重新登录！';

            if (tip) {
                _this.$message({
                    message: msg,
                    type: 'error'
                });
            }
            this.clearSessionStorage();

            _this.$router.push({ path: '/login' });
        },

        clearSessionStorage: function clearSessionStorage() {
            sessionStorage.removeItem('user');
            _store2.default.state.loginUser = null;
        }
    },

    editStore: {
        GetEditObject: function GetEditObject() {
            return _store2.default.state.editObject;
        },

        GetEditedToPath: function GetEditedToPath() {
            return _store2.default.state.editedToPath;
        },

        SetEditValue: function SetEditValue(obj, path) {
            _store2.default.state.editObject = obj;
            _store2.default.state.editedToPath = path;
        },

        ClearEditValue: function ClearEditValue() {
            _store2.default.state.editObject = null;
            _store2.default.state.editedToPath = '/home';
        },

        SetUnShowCols: function SetUnShowCols(page, UnShowCols) {
            var bFind = false;
            _store2.default.state.UnShowColObj.forEach(function (item) {
                if (item.name == page) {
                    item.cols = UnShowCols;
                    bFind = true;
                    return true;
                }
            });
            if (!bFind) {
                _store2.default.state.UnShowColObj.push({ name: page, cols: UnShowCols });
            }
        },

        GetUnShowCols: function GetUnShowCols(page) {
            var UnShowCols = "none";
            if (!!_store2.default.state.UnShowColObj) {
                _store2.default.state.UnShowColObj.forEach(function (item) {
                    if (item.name == page) {
                        UnShowCols = item.cols;
                        return UnShowCols;
                    }
                });
            }
            return UnShowCols;
        }
    },

    string2Dom: function string2Dom(arg) {
        var objE = document.createElement("div");
        objE.innerHTML = arg;
        return objE.childNodes;
    },

    array: {
        addElement: function addElement(array, ele) {
            array.push(ele);
            return array;
        },

        removeElement: function removeElement(array, ele) {
            var index = -1;
            for (var i = 0; i < array.length; i++) {
                if (array[i] == ele) {
                    index = i;
                }
            }
            if (index > -1) {
                array.splice(index, 1);
            }
            return array;
        }
    },

    compareDateTime: function compareDateTime(propertyName) {
        return function (object1, object2) {
            var value1 = new Date(object1[propertyName]);
            var value2 = new Date(object2[propertyName]);
            if (value2 > value1) {
                return -1;
            } else if (value2 < value1) {
                return 1;
            } else {
                return 0;
            }
        };
    },

    compareID: function compareID(propertyName) {
        return function (object1, object2) {
            var value1 = parseInt(object1[propertyName]);
            var value2 = parseInt(object2[propertyName]);
            if (value2 > value1) {
                return -1;
            } else if (value2 < value1) {
                return 1;
            } else {
                return 0;
            }
        };
    }
};

/***/ }),

/***/ 700:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "inventoryclasscontainer",
    staticClass: "inventoryclass-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 85,
      "highlight-current-row": "",
      "id": "out-table",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNum - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "align": "center",
      "min-width": "50%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "编号",
      "align": "center",
      "min-width": "50%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.searchData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查找商品")])]
      }
    }])
  })], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "pageSize": _vm.pageSize,
      "pageNum": _vm.pageNum,
      "totalNum": _vm.totalNum
    },
    on: {
      "handlePageSizeChange": _vm.handlePageSizeChange,
      "handlePageCurrentChange": _vm.handlePageCurrentChange
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 701:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "form-container"
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-switch', {
    staticStyle: {
      "display": "block",
      "left": "240px"
    },
    attrs: {
      "active-text": "密码明文显示"
    },
    model: {
      value: (_vm.plaintextShow),
      callback: function($$v) {
        _vm.plaintextShow = $$v
      },
      expression: "plaintextShow"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "  原密码",
      "prop": "oldPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入原密码",
      "type": _vm.plaintextShow ? 'text' : 'password',
      "id": "focus-ele"
    },
    model: {
      value: (_vm.formData.oldPwd),
      callback: function($$v) {
        _vm.$set(_vm.formData, "oldPwd", $$v)
      },
      expression: "formData.oldPwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "  新密码",
      "prop": "newPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入新密码",
      "type": _vm.plaintextShow ? 'text' : 'password'
    },
    model: {
      value: (_vm.formData.newPwd),
      callback: function($$v) {
        _vm.$set(_vm.formData, "newPwd", $$v)
      },
      expression: "formData.newPwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "prop": "confirmPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请再次输入新密码",
      "type": _vm.plaintextShow ? 'text' : 'password'
    },
    model: {
      value: (_vm.formData.confirmPwd),
      callback: function($$v) {
        _vm.$set(_vm.formData, "confirmPwd", $$v)
      },
      expression: "formData.confirmPwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "-30px",
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('formData')
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "50px",
      "width": "100px"
    },
    on: {
      "click": _vm.returnManagePage
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('el-link', {
    staticClass: "tip-content",
    attrs: {
      "type": "danger"
    }
  }, [_vm._v(_vm._s(_vm.tipContent))])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 702:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "inventorycontainer",
    staticClass: "inventory-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-input', {
    staticStyle: {
      "float": "right",
      "width": "300px"
    },
    attrs: {
      "placeholder": "快速搜索",
      "clearable": ""
    },
    on: {
      "change": _vm.searchList
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.searchList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.vagueContent),
      callback: function($$v) {
        _vm.vagueContent = $$v
      },
      expression: "vagueContent"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    slot: "append"
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "300px",
      "margin-right": "20px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择禁用、启用状态"
    },
    on: {
      "change": _vm.classFilter
    },
    model: {
      value: (_vm.inventoryStatus),
      callback: function($$v) {
        _vm.inventoryStatus = $$v
      },
      expression: "inventoryStatus"
    }
  }, _vm._l((_vm.inventoryStatusOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "300px",
      "margin-right": "20px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择商品分类"
    },
    on: {
      "change": _vm.classFilter
    },
    model: {
      value: (_vm.sortCode),
      callback: function($$v) {
        _vm.sortCode = $$v
      },
      expression: "sortCode"
    }
  }, _vm._l((_vm.allClassDatas), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.syncCommodity
    }
  }, [_vm._v("同步商品")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 85,
      "highlight-current-row": "",
      "id": "out-table",
      "border": ""
    }
  }, [_c('af-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(((!!_vm.pageNum && !!_vm.pageSize) ? ((_vm.pageNum - 1) * _vm.pageSize) : 0) + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "name",
      "label": "商品名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "code",
      "label": "  商品编号  ",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "sortCode",
      "label": "商品分类",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "图片",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-image', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!!scope.row.thumimage),
            expression: "!!scope.row.thumimage"
          }],
          staticStyle: {
            "width": "50px",
            "height": "50px"
          },
          attrs: {
            "src": scope.row.thumimage,
            "fit": "cover"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "ccomunitname",
      "label": "单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "refsaleprice",
      "label": "零售价",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "150",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.enableData(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status === 0 ? '禁用' : '启用'))]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "pageSize": _vm.pageSize,
      "pageNum": _vm.pageNum,
      "totalNum": _vm.totalNum
    },
    on: {
      "handlePageSizeChange": _vm.handlePageSizeChange,
      "handlePageCurrentChange": _vm.handlePageCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品名称",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "id": "focus-ele",
      "disabled": _vm.codeDisabled
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品编号",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.codeDisabled
    },
    model: {
      value: (_vm.formData.code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "code", $$v)
      },
      expression: "formData.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图片",
      "prop": ""
    }
  }, [_c('UploadFile', {
    ref: "UploadFile",
    attrs: {
      "imgUrl": _vm.formData.thumimage
    },
    on: {
      "getFileUrl": _vm.getFileUrl
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 703:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "promotioncontainer",
    staticClass: "promotion-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary",
      "disabled": _vm.copyDisabled
    },
    on: {
      "click": _vm.copyData
    }
  }, [_vm._v("复制")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary",
      "disabled": _vm.submitSortDisabled
    },
    on: {
      "click": _vm.submitSort
    }
  }, [_vm._v("提交排序")]), _vm._v(" "), _c('LayerPath', {
    ref: "LayerPath",
    staticClass: "layerPath"
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 55,
      "highlight-current-row": "",
      "id": "out-table",
      "border": "",
      "row-key": "id"
    },
    on: {
      "row-click": _vm.handleRowChange
    }
  }, [_c('af-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "title",
      "label": "标题",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "thumimage",
      "label": "背景图",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-image', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!!scope.row.thumimage),
            expression: "!!scope.row.thumimage"
          }],
          staticStyle: {
            "width": "50px",
            "height": "50px"
          },
          attrs: {
            "src": scope.row.thumimage,
            "fit": "cover"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "promotiontype",
      "label": "促销类型",
      "formatter": _vm.formatPromotionType,
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "startime",
      "label": "开始时间",
      "formatter": _vm.formatStartime,
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "endtime",
      "label": "结束时间",
      "formatter": _vm.formatEndtime,
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "cashpromote",
      "label": "现金促销金额",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "usevoucher",
      "label": "可用返单券",
      "formatter": _vm.formatUseVoucher,
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "voucherrate",
      "label": "返单券比例",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "voucheramount",
      "label": "返单券金额",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "status",
      "label": "是否发布",
      "formatter": _vm.formatStatus,
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "270",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.delData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.enableData(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status === 0 ? '下架' : '发布'))]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.nextStep(scope.$index, scope.row)
            }
          }
        }, [_vm._v("促销步骤")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标    题",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "id": "focus-ele"
    },
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "促销类型",
      "prop": "promotiontype"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formData.promotiontype),
      callback: function($$v) {
        _vm.$set(_vm.formData, "promotiontype", $$v)
      },
      expression: "formData.promotiontype"
    }
  }, _vm._l((_vm.promotionTypeOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现金促销",
      "prop": "cashpromote"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.cashpromote),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cashpromote", $$v)
      },
      expression: "formData.cashpromote"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图    片",
      "prop": ""
    }
  }, [_c('UploadFile', {
    ref: "UploadFile",
    attrs: {
      "imgUrl": _vm.formData.thumimage
    },
    on: {
      "getFileUrl": _vm.getFileUrl
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "可用返单券",
      "prop": "usevoucher"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.usevoucherChange
    },
    model: {
      value: (_vm.formData.usevoucher),
      callback: function($$v) {
        _vm.$set(_vm.formData, "usevoucher", $$v)
      },
      expression: "formData.usevoucher"
    }
  }, _vm._l((_vm.useVoucherOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "返单券金额",
      "prop": "voucheramount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.voucherUnEditable
    },
    model: {
      value: (_vm.formData.voucheramount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "voucheramount", $$v)
      },
      expression: "formData.voucheramount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "返单券比例",
      "prop": "voucherrate"
    }
  }, [_c('el-slider', {
    attrs: {
      "disabled": _vm.voucherUnEditable,
      "max": 1000,
      "show-input": ""
    },
    model: {
      value: (_vm.formData.voucherrate),
      callback: function($$v) {
        _vm.$set(_vm.formData, "voucherrate", $$v)
      },
      expression: "formData.voucherrate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开始时间",
      "prop": "startime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "format": "yyyy-MM-dd HH:mm:ss",
      "placeholder": "请选择开始时间"
    },
    model: {
      value: (_vm.formData.startime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "startime", $$v)
      },
      expression: "formData.startime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结束时间",
      "prop": "endtime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "format": "yyyy-MM-dd HH:mm:ss",
      "placeholder": "请选择结束时间"
    },
    model: {
      value: (_vm.formData.endtime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "endtime", $$v)
      },
      expression: "formData.endtime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 704:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "promotionstepcontainer",
    staticClass: "promotionstep-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.preStep
    }
  }, [_vm._v("返回到促销管理")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary",
      "disabled": _vm.submitSortDisabled
    },
    on: {
      "click": _vm.submitSort
    }
  }, [_vm._v("提交排序")]), _vm._v(" "), _c('LayerPath', {
    ref: "LayerPath",
    staticClass: "layerPath",
    on: {
      "promotionChange": _vm.promotionChange
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 55,
      "highlight-current-row": "",
      "id": "out-table",
      "border": "",
      "row-key": "id"
    },
    on: {
      "row-click": _vm.handleRowChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "steptitle",
      "label": "名称",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "steptype",
      "label": "类型",
      "formatter": _vm.formatStepType,
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "stepamount",
      "label": "促销区间",
      "formatter": _vm.formatStepAmount,
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "monthoverdate",
      "label": "过期日",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "270"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.delData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.enableData(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status === 0 ? '禁用' : '启用'))]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.nextStep(scope.$index, scope.row)
            }
          }
        }, [_vm._v("促销标签")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名    称",
      "prop": "steptitle"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "id": "focus-ele"
    },
    model: {
      value: (_vm.formData.steptitle),
      callback: function($$v) {
        _vm.$set(_vm.formData, "steptitle", $$v)
      },
      expression: "formData.steptitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类    型",
      "prop": "steptype"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.steptypeChange
    },
    model: {
      value: (_vm.formData.steptype),
      callback: function($$v) {
        _vm.$set(_vm.formData, "steptype", $$v)
      },
      expression: "formData.steptype"
    }
  }, _vm._l((_vm.stepTypeOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stepamountShow),
      expression: "stepamountShow"
    }],
    attrs: {
      "label": "促销区间",
      "prop": "minstepamount"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "placeholder": "请输入区间最小值"
    },
    on: {
      "change": function($event) {
        return _vm.cashChange('Min')
      }
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.cashMin.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.formData.minstepamount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "minstepamount", $$v)
      },
      expression: "formData.minstepamount"
    }
  }), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "placeholder": "请输入区间最大值"
    },
    on: {
      "change": function($event) {
        return _vm.cashChange('Max')
      }
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.cashMax.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.formData.maxstepamount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "maxstepamount", $$v)
      },
      expression: "formData.maxstepamount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.monthoverdateShow),
      expression: "monthoverdateShow"
    }],
    attrs: {
      "label": "过期日",
      "prop": "monthoverdate"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formData.monthoverdate),
      callback: function($$v) {
        _vm.$set(_vm.formData, "monthoverdate", $$v)
      },
      expression: "formData.monthoverdate"
    }
  }, _vm._l((31), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备    注",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 705:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "combinationcontainer",
    staticClass: "combination-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 85,
      "highlight-current-row": "",
      "id": "out-table",
      "border": "",
      "row-key": "id"
    },
    on: {
      "cell-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNum - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "视频名称",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "url",
      "label": "视频",
      "align": "center",
      "min-width": "20%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!!scope.row.url),
            expression: "!!scope.row.url"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "点击查看视频",
            "placement": "top"
          }
        }, [_c('video', {
          staticStyle: {
            "width": "50px",
            "height": "50px"
          },
          attrs: {
            "src": scope.row.url
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "thumimage",
      "label": "图片",
      "align": "center",
      "min-width": "20%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-image', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!!scope.row.thumimage),
            expression: "!!scope.row.thumimage"
          }],
          staticStyle: {
            "width": "50px",
            "height": "50px"
          },
          attrs: {
            "src": scope.row.thumimage,
            "fit": "cover"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "留言",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "formatter": _vm.formatStatus,
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.delData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.enableData(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status === "0" ? '禁用' : '启用'))]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "pageSize": _vm.pageSize,
      "pageNum": _vm.pageNum,
      "totalNum": _vm.totalNum
    },
    on: {
      "handlePageSizeChange": _vm.handlePageSizeChange,
      "handlePageCurrentChange": _vm.handlePageCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "视频名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "id": "focus-ele"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "视    频",
      "prop": ""
    }
  }, [_c('UploadFileVideo', {
    ref: "UploadFileVideo",
    attrs: {
      "videoUrl": _vm.formData.url
    },
    on: {
      "getVideoUrl": _vm.getVideoUrl
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图    片",
      "prop": ""
    }
  }, [_c('UploadFile', {
    ref: "UploadFile",
    attrs: {
      "imgUrl": _vm.formData.thumimage
    },
    on: {
      "getFileUrl": _vm.getFileUrl
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "留    言",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "type": "textarea",
      "rows": 4,
      "maxlength": "100"
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.videoDialogTitle,
      "visible": _vm.videoDialogVisible,
      "width": "600px",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.videoDialogVisible = $event
      }
    }
  }, [_c('section', {
    staticStyle: {
      "width": "90%",
      "margin": "10px auto"
    }
  }, [_c('video', {
    staticStyle: {
      "width": "100%",
      "height": "304px",
      "margin-bottom": "10px"
    },
    attrs: {
      "id": "videoSec",
      "src": _vm.videoUrl,
      "controls": "controls"
    }
  }, [_vm._v("\n\t\t\t\t\tYour browser does not support the video tag.\n\t\t\t\t")]), _vm._v(" "), _c('section', [_c('strong', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("留言：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v(_vm._s(_vm.videoRemark))])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 706:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm",
    staticClass: "login-container",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-position": "left",
      "label-width": "0px",
      "loading": _vm.logining
    }
  }, [_c('div', {
    staticClass: "login-title"
  }, [_c('div', {
    staticClass: "login-platname"
  }, [_c('div', {
    staticClass: "login-cn-platname"
  }, [_vm._v(_vm._s(_vm.sysCnName))]), _vm._v(" "), _c('div', {
    staticClass: "login-en-platname"
  }, [_vm._v(_vm._s(_vm.sysEnName))])])]), _vm._v(" "), _c('div', {
    staticClass: "login-content"
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "35px"
    },
    attrs: {
      "prop": "account"
    }
  }, [_c('i', {
    staticClass: "el-icon-user login-icon"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "login-input",
    attrs: {
      "placeholder": "账户",
      "id": "focus-ele"
    },
    model: {
      value: (_vm.ruleForm.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "account", $$v)
      },
      expression: "ruleForm.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('i', {
    staticClass: "el-icon-lock login-icon"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "login-input",
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.ruleForm.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "checkPass", $$v)
      },
      expression: "ruleForm.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": ""
    }
  }, [_c('el-checkbox', {
    staticClass: "login-auto",
    model: {
      value: (_vm.ruleForm.autoLogin),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "autoLogin", $$v)
      },
      expression: "ruleForm.autoLogin"
    }
  }, [_vm._v("自动登录")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticClass: "login-btn",
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("登 录")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 707:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "platinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('div', {
    staticClass: "platname"
  }, [_c('el-image', {
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "src": _vm.logoUrl,
      "fit": "cover"
    }
  })], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("退出登录")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.changePwd.apply(null, arguments)
      }
    }
  }, [_vm._v("修改密码")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20,
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "sysinfo"
  }, [_c('div', [_vm._v("版本号：" + _vm._s(_vm.version))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.baseURL))])])])], 1), _vm._v(" "), _c('el-col', {
    ref: "main",
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    staticClass: "menu-expanded",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.spreadOrCollapse($event)
      }
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": "",
      "background-color": "#414141",
      "text-color": "#97a0a8",
      "active-text-color": "#fff",
      "collapse": _vm.isCollapse
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return [(!item.hidden && !item.leaf && item.children.length > 0 && _vm.menuArray.some(function (a) { return a.value === item.name; })) ? _c('el-submenu', {
      key: index,
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return [(_vm.menuArray.some(function (a) { return a.value === child.name; })) ? _c('el-menu-item', {
        key: child.path,
        staticClass: "submenu-content",
        attrs: {
          "index": child.path
        }
      }, [_c('span', {
        attrs: {
          "slot": "title"
        },
        slot: "title"
      }, [_vm._v(_vm._s(child.name))])]) : _vm._e()]
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0 && _vm.menuArray.some(function (a) { return a.value === item.children[0].name; })) ? _c('el-menu-item', {
      key: item.children[0].name,
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.children[0].name))])]) : _vm._e()]
  })], 2)], 1), _vm._v(" "), _c('section', {
    ref: "container",
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": "感谢使用本系统",
      "visible": _vm.dialogVisible,
      "width": "400px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "logOutTip"
  }, [_vm._v("期待您的再次使用，正在退出......")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 708:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 709:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "usercontainer",
    staticClass: "user-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 85,
      "highlight-current-row": "",
      "id": "out-table",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNum - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "用户账号",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "role",
      "label": "用户角色",
      "formatter": _vm.formatRole,
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "areaname",
      "label": "所属区域",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "creattime",
      "label": "创建时间",
      "formatter": _vm.formatCreatTime,
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "wxaccount",
      "label": "微信手机号",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v("|\n\t\t\t\t\t"), _c('el-dropdown', {
          staticStyle: {
            "line-height": "0"
          },
          attrs: {
            "trigger": "hover"
          }
        }, [_c('label', {
          staticClass: "edit-content edit-more"
        }, [_vm._v("更多")]), _vm._v(" "), _c('el-dropdown-menu', {
          staticClass: "edit-more-content",
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [(scope.row.role !== 1) ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.enableData(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status === 0 ? '禁用' : '启用'))]) : _vm._e(), _vm._v(" "), (scope.row.role !== 1) ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.delData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.resetPassword(scope.$index, scope.row)
            }
          }
        }, [_vm._v("重置密码")])], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "pageSize": _vm.pageSize,
      "pageNum": _vm.pageNum,
      "totalNum": _vm.totalNum
    },
    on: {
      "handlePageSizeChange": _vm.handlePageSizeChange,
      "handlePageCurrentChange": _vm.handlePageCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户账号",
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "id": "focus-ele"
    },
    model: {
      value: (_vm.formData.username),
      callback: function($$v) {
        _vm.$set(_vm.formData, "username", $$v)
      },
      expression: "formData.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户角色",
      "prop": "role"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.roleDisabled
    },
    on: {
      "change": _vm.roleChange
    },
    model: {
      value: (_vm.formData.role),
      callback: function($$v) {
        _vm.$set(_vm.formData, "role", $$v)
      },
      expression: "formData.role"
    }
  }, _vm._l((_vm.roleOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属区域",
      "prop": "areaid"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "value-key": "id",
      "placeholder": "请选择",
      "disabled": _vm.areaDisabled
    },
    model: {
      value: (_vm.formData.areaid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "areaid", $$v)
      },
      expression: "formData.areaid"
    }
  }, _vm._l((_vm.areaDatas), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.areaname,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "微信手机号",
      "prop": "wxaccount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.areaDisabled
    },
    model: {
      value: (_vm.formData.wxaccount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "wxaccount", $$v)
      },
      expression: "formData.wxaccount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备       注",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 710:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block pagination"
  }, [_c('label', {
    staticClass: "pagin-tip"
  }, [_vm._v("显示第 " + _vm._s(_vm.pTotal === 0 ? 0 : ((_vm.pNum - 1) * _vm.pSize + 1)) + " 条至第 " + _vm._s((_vm.pNum * _vm.pSize) > _vm.pTotal ? _vm.pTotal : (_vm.pNum * _vm.pSize)) + " 条记录")]), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.pNum,
      "page-sizes": [5, 10, 20, 50, 100, 150, 200],
      "page-size": _vm.pSize,
      "layout": "total, prev, pager, next, sizes, jumper",
      "total": _vm.pTotal = _vm.totalNum
    },
    on: {
      "size-change": _vm.handlePageSizeChange,
      "current-change": _vm.handlePageCurrentChange
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 711:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "usercontainer",
    staticClass: "test-container"
  }, [
    [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.tableData,
        "height": _vm.containerHeight - 30,
        "id": "out-table"
      }
    }, _vm._l((_vm.tableHead), function(item, index) {
      return _c('el-table-column', {
        key: index,
        attrs: {
          "label": item.label,
          "property": item.property,
          "align": "center"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(scope) {
            return [_vm._v("\n\t\t\t\t\t" + _vm._s(scope.row[scope.column.property]) + "\n\t\t\t\t")]
          }
        }], null, true)
      })
    }), 1)], _vm._v(" "), _c('el-button', {
      on: {
        "click": _vm.exportExcel
      }
    }, [_vm._v("导出")]), _vm._v(" "), _c('pagination', {
      attrs: {
        "pageSize": _vm.pageSize,
        "pageNum": _vm.pageNum,
        "totalNum": _vm.totalNum
      },
      on: {
        "handlePageSizeChange": _vm.handlePageSizeChange,
        "handlePageCurrentChange": _vm.handlePageCurrentChange
      }
    })
  ], 2)
},staticRenderFns: []}

/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "orderViewcontainer",
    staticClass: "orderView-container common-container"
  }, [_c('el-row', {
    staticStyle: {
      "width": "100%",
      "height": "30px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "hzpbtn-primary",
    staticStyle: {
      "height": "35px",
      "line-height": "10px",
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.preStep
    }
  }, [_vm._v("返回到订单管理")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    staticStyle: {
      "height": "35px",
      "line-height": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    staticStyle: {
      "padding": "20px 0 0 0"
    },
    attrs: {
      "model": _vm.formData,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    on: {
      "change": _vm.collapseChange
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": '订单【' + _vm.formData.code + '】详情（点击' + _vm.orderColl + '）',
      "name": "coll"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "auto 10px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单编号",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "code", $$v)
      },
      expression: "formData.code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单日期",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.creattime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "creattime", $$v)
      },
      expression: "formData.creattime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "下单人",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.ordercareter),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ordercareter", $$v)
      },
      expression: "formData.ordercareter"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "培训公司",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.aagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "aagencyname", $$v)
      },
      expression: "formData.aagencyname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "销售公司",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.pagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "pagencyname", $$v)
      },
      expression: "formData.pagencyname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代理1",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.cagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cagencyname", $$v)
      },
      expression: "formData.cagencyname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代理2",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.tagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tagencyname", $$v)
      },
      expression: "formData.tagencyname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货人",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.consignee),
      callback: function($$v) {
        _vm.$set(_vm.formData, "consignee", $$v)
      },
      expression: "formData.consignee"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货电话",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.linkphone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "linkphone", $$v)
      },
      expression: "formData.linkphone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货地址",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.finaladdress),
      callback: function($$v) {
        _vm.$set(_vm.formData, "finaladdress", $$v)
      },
      expression: "formData.finaladdress"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "汇款人姓名",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.remittername),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remittername", $$v)
      },
      expression: "formData.remittername"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实际总金额",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.totalamount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "totalamount", $$v)
      },
      expression: "formData.totalamount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备    注",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单类型",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.ordertype),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ordertype", $$v)
      },
      expression: "formData.ordertype"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "促销标题",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.promotiontitle),
      callback: function($$v) {
        _vm.$set(_vm.formData, "promotiontitle", $$v)
      },
      expression: "formData.promotiontitle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "U8ID",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.u8id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "u8id", $$v)
      },
      expression: "formData.u8id"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单状态",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.paystatus),
      callback: function($$v) {
        _vm.$set(_vm.formData, "paystatus", $$v)
      },
      expression: "formData.paystatus"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "运单号",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": _vm.editDisabled
    },
    model: {
      value: (_vm.formData.waybillcode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "waybillcode", $$v)
      },
      expression: "formData.waybillcode"
    }
  })], 1)], 1), _vm._v(" "), ( false) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": ""
    }
  }, [(!!_vm.formData.waybillcode) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.checkWaybill
    }
  }, [_vm._v("查看物流 >")]) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "height": _vm.containerHeight - _vm.orderHeight,
      "highlight-current-row": "",
      "border": "",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "stepname",
      "label": "促销类别",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spcode",
      "label": "商品编号",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spname",
      "label": "商品名称",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spccomunitname",
      "label": "单位",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spsize",
      "label": "数量",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spmoney",
      "label": "单价(元)",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spamount",
      "label": "合计(元)",
      "formatter": _vm.formatAmount,
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zpcode",
      "label": "是否赠品",
      "formatter": _vm.formatType,
      "align": "center",
      "width": "100"
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": '运单号',
      "visible": _vm.wayBillDialogVisible,
      "width": "700px"
    },
    on: {
      "update:visible": function($event) {
        _vm.wayBillDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('section', {
    staticClass: "wbsec"
  }, _vm._l((_vm.wayBillDatas), function(wb) {
    return _c('el-tag', {
      key: wb,
      staticClass: "wbtag",
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.clickWayBill(wb)
        }
      }
    }, [_vm._v(_vm._s(wb) + " "), _c('i', {
      staticClass: "el-icon-aim"
    })])
  }), 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": '物流信息',
      "visible": _vm.logisticsDialogVisible,
      "width": "700px",
      "height": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.logisticsDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('section', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('label', {
    staticClass: "billNo"
  }, [_vm._v("运单号：" + _vm._s(_vm.logisticsBillNo))]), _vm._v(" "), _c('label', {
    staticClass: "billState"
  }, [_vm._v(_vm._s(_vm.logisticsStatu))]), _vm._v(" "), _c('section', {
    staticClass: "billContent"
  }, [_c('ul', {
    staticClass: "bcul"
  }, _vm._l((_vm.logisticsDatas), function(lo, index) {
    return _c('li', {
      key: lo.operatetime,
      staticClass: "bcli",
      style: (index == 0 ? 'color: #E3A53F;' : '')
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('span', {
      staticClass: "el-icon-location"
    })]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.formatTitle(lo.date, lo.time)))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', {
      staticClass: "bccon",
      domProps: {
        "innerHTML": _vm._s(lo.content)
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(lo.content) + "\n\t\t\t\t\t\t\t\t\t")])])], 1)], 1)
  }), 0)])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 713:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "vouchercontainer",
    staticClass: "voucher-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 55,
      "highlight-current-row": "",
      "id": "out-table",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "标题",
      "align": "center",
      "min-width": "40%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "是否发布",
      "formatter": _vm.formatStatus,
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center",
      "min-width": "40%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.enableData(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status === 'on' ? '下架' : '发布'))]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.delData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标       题",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "id": "focus-ele"
    },
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备       注",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v(_vm._s(_vm.dialogTitle === '添加' ? '发 布' : '保 存'))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 714:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "processLabelInventorycontainer",
    staticClass: "processLabelInventory-container common-container"
  }, [_c('el-row', {
    staticStyle: {
      "width": "100%",
      "height": "30px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "hzpbtn-primary",
    staticStyle: {
      "height": "35px",
      "line-height": "10px",
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.preStep
    }
  }, [_vm._v("返回到促销标签")]), _vm._v(" "), _c('label', {
    staticClass: "plTitle"
  }, [_vm._v("编辑促销标签")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('LayerPath', {
    ref: "LayerPath",
    staticClass: "layerPath",
    on: {
      "promotionLabelChange": _vm.promotionLabelChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "labelFormData",
    staticClass: "form-data-nopadding",
    staticStyle: {
      "padding": "0px 20px",
      "padding-top": "20px",
      "border-bottom": "1px solid"
    },
    attrs: {
      "model": _vm.labelFormData,
      "rules": _vm.labelRules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-row', {
    staticStyle: {
      "width": "100%",
      "height": "40px",
      "line-height": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名    称",
      "prop": "labelname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.labelFormData.labelname),
      callback: function($$v) {
        _vm.$set(_vm.labelFormData, "labelname", $$v)
      },
      expression: "labelFormData.labelname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "步骤名称",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.steptitleDisabled
    },
    model: {
      value: (_vm.steptitle),
      callback: function($$v) {
        _vm.steptitle = $$v
      },
      expression: "steptitle"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备    注",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.labelFormData.remark),
      callback: function($$v) {
        _vm.$set(_vm.labelFormData, "remark", $$v)
      },
      expression: "labelFormData.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "align": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": ""
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary",
      "disabled": _vm.submitDisabled
    },
    on: {
      "click": function($event) {
        return _vm.handleLabelSubmit('labelFormData')
      }
    }
  }, [_vm._v(_vm._s(!!_vm.labelFormData.plid ? '提交' : '添加'))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "addFormData",
    staticClass: "form-data-nopadding",
    attrs: {
      "model": _vm.addFormData,
      "rules": _vm.addRules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-row', {
    staticStyle: {
      "width": "100%",
      "height": "40px",
      "line-height": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.steptype == 1 || _vm.steptype == 4),
      expression: "steptype == 1 || steptype == 4"
    }],
    attrs: {
      "label": "选择商品",
      "prop": "icode"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchSpList
    },
    model: {
      value: (_vm.addFormData.icode),
      callback: function($$v) {
        _vm.$set(_vm.addFormData, "icode", $$v)
      },
      expression: "addFormData.icode"
    }
  }, _vm._l((_vm.spDatas), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "清除选择的商品",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-close"
    },
    on: {
      "click": function($event) {
        return _vm.clearInventory('sp')
      }
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.steptype == 1 || _vm.steptype == 4),
      expression: "steptype == 1 || steptype == 4"
    }],
    attrs: {
      "label": "商品数量",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        return _vm.codeSizeChange('add')
      }
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.number.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.addFormData.icodesize),
      callback: function($$v) {
        _vm.$set(_vm.addFormData, "icodesize", $$v)
      },
      expression: "addFormData.icodesize"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": (_vm.steptype == 1 || _vm.steptype == 4) ? 8 : 15
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择赠品",
      "prop": "zpcode"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchZpList,
      "disabled": _vm.addZpDisabled
    },
    model: {
      value: (_vm.addFormData.zpcode),
      callback: function($$v) {
        _vm.$set(_vm.addFormData, "zpcode", $$v)
      },
      expression: "addFormData.zpcode"
    }
  }, _vm._l((_vm.zpDatas), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "清除选择的赠品",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-close",
      "disabled": _vm.addZpDisabled
    },
    on: {
      "click": function($event) {
        return _vm.clearInventory('zp')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.steptype == 1 || _vm.steptype == 4),
      expression: "steptype == 1 || steptype == 4"
    }],
    attrs: {
      "span": 5
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "赠品跟随商品",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.addZpDisabled
    },
    on: {
      "click": function($event) {
        return _vm.followInventory('zp')
      }
    }
  }, [_vm._v("跟随商品")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": (_vm.steptype == 1 || _vm.steptype == 4) ? 5 : 9
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "赠品数量",
      "prop": "zpcodesize"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.addZpDisabled
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.zpnumber.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.addFormData.zpcodesize),
      callback: function($$v) {
        _vm.$set(_vm.addFormData, "zpcodesize", $$v)
      },
      expression: "addFormData.zpcodesize"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "100%",
      "height": "40px",
      "line-height": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备    注",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.addFormData.remark),
      callback: function($$v) {
        _vm.$set(_vm.addFormData, "remark", $$v)
      },
      expression: "addFormData.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": ""
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary",
      "disabled": !_vm.labelFormData.plid
    },
    on: {
      "click": function($event) {
        return _vm.handleAddSubmit('addFormData')
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    staticStyle: {
      "margin-left": "50px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品快速搜索",
      "clearable": ""
    },
    on: {
      "change": _vm.searchList
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.searchList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.vagueContent),
      callback: function($$v) {
        _vm.vagueContent = $$v
      },
      expression: "vagueContent"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    slot: "append"
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 55 - 158,
      "highlight-current-row": "",
      "id": "out-table",
      "border": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "商品名称",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "thumimage",
      "label": "图片",
      "align": "center",
      "min-width": "20%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-image', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!!scope.row.thumimage),
            expression: "!!scope.row.thumimage"
          }],
          staticStyle: {
            "width": "50px",
            "height": "50px"
          },
          attrs: {
            "src": scope.row.thumimage,
            "fit": "cover"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "refsaleprice",
      "label": "单价",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "icodesize",
      "label": "数量",
      "formatter": _vm.formatIcodesize,
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zpname",
      "label": "赠品商品",
      "formatter": _vm.formatZpname,
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zpcodesize",
      "label": "赠品数量",
      "formatter": _vm.formatZpcodesize,
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.delData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.enableData(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status === 0 ? '禁用' : '启用'))]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.steptype == 1 || _vm.steptype == 4),
      expression: "steptype == 1 || steptype == 4"
    }],
    attrs: {
      "label": "选择商品",
      "prop": "icode"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchSpList
    },
    model: {
      value: (_vm.formData.icode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "icode", $$v)
      },
      expression: "formData.icode"
    }
  }, _vm._l((_vm.spDatas), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "width": "20px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "清除选择的商品",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-close"
    },
    on: {
      "click": function($event) {
        return _vm.clearInventory('editsp')
      }
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.steptype == 1 || _vm.steptype == 4),
      expression: "steptype == 1 || steptype == 4"
    }],
    attrs: {
      "label": "商品数量",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        return _vm.codeSizeChange('edit')
      }
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.editnumber.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.formData.icodesize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "icodesize", $$v)
      },
      expression: "formData.icodesize"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择赠品",
      "prop": "zpcode"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchZpList,
      "disabled": _vm.editZpDisabled
    },
    model: {
      value: (_vm.formData.zpcode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "zpcode", $$v)
      },
      expression: "formData.zpcode"
    }
  }, _vm._l((_vm.zpDatas), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "width": "20px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "清除选择的赠品",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-close",
      "disabled": _vm.editZpDisabled
    },
    on: {
      "click": function($event) {
        return _vm.clearInventory('editzp')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.steptype == 1 || _vm.steptype == 4),
      expression: "steptype == 1 || steptype == 4"
    }],
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "赠品跟随商品",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.editZpDisabled
    },
    on: {
      "click": function($event) {
        return _vm.followInventory('editzp')
      }
    }
  }, [_vm._v("跟随商品")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "赠品数量",
      "prop": "zpcodesize"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.editZpDisabled
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.editzpnumber.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.formData.zpcodesize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "zpcodesize", $$v)
      },
      expression: "formData.zpcodesize"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备    注",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 715:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "logisticscontainer",
    staticClass: "logistics-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 10,
      "align": "left"
    }
  }, [(_vm.loginRole !== 2) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("添加")]) : _vm._e(), _vm._v(" "), (_vm.loginRole !== 2) ? _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")]) : _vm._e(), _vm._v(" "), (_vm.loginRole !== 2) ? _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchDel
    }
  }, [_vm._v("批量删除")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "align": "left"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "98%"
    },
    attrs: {
      "placeholder": "按区域搜索"
    },
    on: {
      "change": _vm.getData
    },
    model: {
      value: (_vm.sortAreaId),
      callback: function($$v) {
        _vm.sortAreaId = $$v
      },
      expression: "sortAreaId"
    }
  }, _vm._l((_vm.allAreaDatas), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.areaname,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "align": "right"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "快速搜索"
    },
    on: {
      "change": _vm.getData
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.getData.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.vague),
      callback: function($$v) {
        _vm.vague = $$v
      },
      expression: "vague"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "align": "right"
    }
  }, [(_vm.loginRole !== 2) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.downloadTemplate
    }
  }, [_vm._v("下载导入模板")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "align": "center"
    }
  }, [(_vm.loginRole !== 2) ? _c('a', {
    staticClass: "file importFile",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("导入Excel\n\t\t\t\t\t\t"), _c('input', {
    attrs: {
      "id": "file",
      "type": "file",
      "accept": ".xlsx, .xls, .csv"
    },
    on: {
      "change": function($event) {
        return _vm.importExcel($event)
      }
    }
  })]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 85,
      "highlight-current-row": "",
      "id": "out-table",
      "border": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('af-table-column', {
    attrs: {
      "type": "selection",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNum - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "logisticsid",
      "label": "快递单号",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "ordercode",
      "label": "订单编号",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "u8id",
      "label": "U8id",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "logisticsname",
      "label": "物流公司",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "u8orderid",
      "label": "U8系统发货单号",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "creattime",
      "label": "创建时间",
      "formatter": _vm.formatCreattime,
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "creatuser",
      "label": "创建人",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "updatetime",
      "label": "最后修改时间",
      "formatter": _vm.formatUpdatetime,
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "prop": "updateuser",
      "label": "修改人",
      "align": "center"
    }
  }), _vm._v(" "), _c('af-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "220",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.loginRole !== 2) ? _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.delData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), (_vm.loginRole !== 2) ? _c('span', [_vm._v("|")]) : _vm._e(), _vm._v(" "), (_vm.loginRole !== 2) ? _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (_vm.loginRole !== 2) ? _c('span', [_vm._v("|")]) : _vm._e(), _vm._v(" "), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.clickWayBill(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看物流")])]
      }
    }])
  })], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "pageSize": _vm.pageSize,
      "pageNum": _vm.pageNum,
      "totalNum": _vm.totalNum
    },
    on: {
      "handlePageSizeChange": _vm.handlePageSizeChange,
      "handlePageCurrentChange": _vm.handlePageCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "快递单号",
      "prop": "logisticsid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "id": "focus-ele"
    },
    model: {
      value: (_vm.formData.logisticsid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "logisticsid", $$v)
      },
      expression: "formData.logisticsid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单编号",
      "prop": "ordercode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.ordercode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ordercode", $$v)
      },
      expression: "formData.ordercode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "U8id",
      "prop": "u8id"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.u8id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "u8id", $$v)
      },
      expression: "formData.u8id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物流公司",
      "prop": "logisticsname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.logisticsname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "logisticsname", $$v)
      },
      expression: "formData.logisticsname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "U8系统发货单号",
      "prop": "u8orderid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.u8orderid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "u8orderid", $$v)
      },
      expression: "formData.u8orderid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": '物流信息',
      "visible": _vm.logisticsDialogVisible,
      "width": "700px",
      "height": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.logisticsDialogVisible = $event
      }
    }
  }, [_c('section', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('label', {
    staticClass: "billNo"
  }, [_vm._v("运单号：" + _vm._s(_vm.logisticsBillNo))]), _vm._v(" "), _c('label', {
    staticClass: "billState"
  }, [_vm._v(_vm._s(_vm.logisticsStatu))]), _vm._v(" "), _c('section', {
    staticClass: "billContent"
  }, [_c('ul', {
    staticClass: "bcul"
  }, _vm._l((_vm.logisticsDatas), function(lo, index) {
    return _c('li', {
      key: lo.operatetime,
      staticClass: "bcli",
      style: (index == 0 ? 'color: #E3A53F;' : '')
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('span', {
      staticClass: "el-icon-location"
    })]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('span', [_vm._v(_vm._s((!!lo.date ? _vm.formatTitle(lo.date, lo.time) : lo.acceptTime)))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', {
      staticClass: "bccon",
      domProps: {
        "innerHTML": _vm._s(lo.content)
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(lo.content) + "\n\t\t\t\t\t\t\t\t\t")])])], 1)], 1)
  }), 0)]), _vm._v(" "), _c('section', [_c('label', {
    staticClass: "billState consignmentState"
  }, [_vm._v("发货单状态：" + _vm._s(_vm.consignment.define14))])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 716:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "combinationInventorycontainer",
    staticClass: "combinationInventory-container common-container"
  }, [_c('el-row', {
    staticStyle: {
      "width": "100%",
      "height": "30px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "hzpbtn-primary",
    staticStyle: {
      "height": "35px",
      "line-height": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.preStep
    }
  }, [_vm._v("返回到组合清单")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "hzpbtn-info",
    staticStyle: {
      "float": "right",
      "height": "35px",
      "line-height": "10px",
      "margin-right": "2px"
    },
    attrs: {
      "type": "info",
      "plain": ""
    },
    on: {
      "click": _vm.pagePositionClick
    }
  }, [_vm._v(_vm._s(_vm.pagePosition))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "100px",
      "font-size": "20px",
      "margin-top": "4px",
      "margin-right": "-5px"
    }
  }, [_c('label', [_vm._v("上级位置：")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "addFormData",
    staticClass: "form-data-nopadding",
    attrs: {
      "model": _vm.addFormData,
      "rules": _vm.addRules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-row', {
    staticStyle: {
      "width": "100%",
      "height": "40px",
      "line-height": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择商品",
      "prop": "spcode"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchSpList
    },
    model: {
      value: (_vm.addFormData.spcode),
      callback: function($$v) {
        _vm.$set(_vm.addFormData, "spcode", $$v)
      },
      expression: "addFormData.spcode"
    }
  }, _vm._l((_vm.spDatas), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "清除选择的商品",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-close"
    },
    on: {
      "click": function($event) {
        return _vm.clearInventory('sp')
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "100%",
      "height": "40px",
      "line-height": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": ""
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary",
      "disabled": !_vm.cid
    },
    on: {
      "click": function($event) {
        return _vm.handleAddSubmit('addFormData')
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    staticStyle: {
      "margin-left": "50px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品快速搜索"
    },
    on: {
      "change": _vm.searchList
    },
    model: {
      value: (_vm.vagueContent),
      callback: function($$v) {
        _vm.vagueContent = $$v
      },
      expression: "vagueContent"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    slot: "append"
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 55 - 95,
      "highlight-current-row": "",
      "id": "out-table",
      "border": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNum - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spcode",
      "label": "商品编码",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spname",
      "label": "商品名称",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spmoney",
      "label": "商品价格",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.enableData(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status === '0' ? '禁用' : '启用'))]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择商品",
      "prop": "spcode"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchSpList,
      "id": "focus-ele"
    },
    model: {
      value: (_vm.formData.spcode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "spcode", $$v)
      },
      expression: "formData.spcode"
    }
  }, _vm._l((_vm.spDatas), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "width": "20px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "清除选择的商品",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-close"
    },
    on: {
      "click": function($event) {
        return _vm.clearInventory('editsp')
      }
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 717:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('label', {
    staticClass: "layer",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.rootClick.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.rootLayer))])]), _vm._v(" "), _c('el-col', {
    staticClass: "layer-partition",
    attrs: {
      "span": 1
    }
  }, [_c('span', [_vm._v(">>")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    staticClass: "layer promLayer",
    attrs: {
      "disabled": !_vm.firstLayerData || _vm.firstLayerData.length === 0,
      "placeholder": "请选择促销活动"
    },
    on: {
      "change": _vm.firstLayerChange
    },
    model: {
      value: (_vm.firstLayerVal),
      callback: function($$v) {
        _vm.firstLayerVal = $$v
      },
      expression: "firstLayerVal"
    }
  }, _vm._l((_vm.firstLayerData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.title,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "layer-partition",
    attrs: {
      "span": 1
    }
  }, [_c('span', [_vm._v(">>")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    staticClass: "layer promLayer",
    attrs: {
      "disabled": !_vm.secondLayerData || _vm.secondLayerData.length === 0,
      "placeholder": "请选择促销步骤"
    },
    on: {
      "change": _vm.secondLayerChange
    },
    model: {
      value: (_vm.secondLayerVal),
      callback: function($$v) {
        _vm.secondLayerVal = $$v
      },
      expression: "secondLayerVal"
    }
  }, _vm._l((_vm.secondLayerData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.steptitle,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "layer-partition",
    attrs: {
      "span": 1
    }
  }, [_c('span', [_vm._v(">>")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    staticClass: "layer promLayer",
    attrs: {
      "disabled": !_vm.thirdLayerData || _vm.thirdLayerData.length === 0,
      "placeholder": "请选择促销标签"
    },
    on: {
      "change": _vm.thirdLayerChange
    },
    model: {
      value: (_vm.thirdLayerVal),
      callback: function($$v) {
        _vm.thirdLayerVal = $$v
      },
      expression: "thirdLayerVal"
    }
  }, _vm._l((_vm.thirdLayerData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.labelname,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 718:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "ordercontainer",
    staticClass: "order-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8,
      "align": "left"
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editCol
    }
  }, [_vm._v("设置显示列")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "align": "left"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "按培训公司搜索"
    },
    on: {
      "change": _vm.searchList
    },
    model: {
      value: (_vm.aagencyid),
      callback: function($$v) {
        _vm.aagencyid = $$v
      },
      expression: "aagencyid"
    }
  }, _vm._l((_vm.agencyDatas), function(item) {
    return _c('el-option', {
      key: item.aagencyid,
      attrs: {
        "label": item.aagencyname,
        "value": item.aagencyid
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "center"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "clearable": "",
      "placeholder": "日期起",
      "picker-options": _vm.startPickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.voucherTimeChange('start')
      }
    },
    model: {
      value: (_vm.voucherStartime),
      callback: function($$v) {
        _vm.voucherStartime = $$v
      },
      expression: "voucherStartime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "center"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "clearable": "",
      "placeholder": "日期止",
      "picker-options": _vm.endPickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.voucherTimeChange('end')
      }
    },
    model: {
      value: (_vm.voucherEndtime),
      callback: function($$v) {
        _vm.voucherEndtime = $$v
      },
      expression: "voucherEndtime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "align": "center"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "按消费筛选"
    },
    on: {
      "change": _vm.searchList
    },
    model: {
      value: (_vm.used),
      callback: function($$v) {
        _vm.used = $$v
      },
      expression: "used"
    }
  }, _vm._l((_vm.usedOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "right"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "搜索字段"
    },
    on: {
      "change": _vm.searchColumn
    },
    model: {
      value: (_vm.fuzzyField),
      callback: function($$v) {
        _vm.fuzzyField = $$v
      },
      expression: "fuzzyField"
    }
  }, _vm._l((_vm.fuzzyFieldOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "align": "ceter"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "搜索内容"
    },
    on: {
      "change": _vm.searchList
    },
    model: {
      value: (_vm.vague),
      callback: function($$v) {
        _vm.vague = $$v
      },
      expression: "vague"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 85,
      "highlight-current-row": "",
      "id": "out-table",
      "border": "",
      "row-key": "id"
    }
  }, [_c('af-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNum - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), (_vm.colUnShowKeys.indexOf('id') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "id",
      "label": "返单券ID",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('amount') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "amount",
      "label": "返单券金额",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('gmtCreate') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "gmtCreate1",
      "label": " 赠送日期",
      "formatter": _vm.formatGmtCreate,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('gmtCreatetime') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "gmtCreate2",
      "label": " 赠送时间",
      "formatter": _vm.formatGmtCreatetime,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('ordercareter') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "ordercareter",
      "label": "客户编码",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('ordercaretername') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "ordercaretername",
      "label": "客户姓名",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('aagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "aagencyname",
      "label": "培训公司",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('pagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "pagencyname",
      "label": "销售公司",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('cagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "cagencyname",
      "label": "代理1",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('tagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "tagencyname",
      "label": "代理2",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('consignee') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "consignee",
      "label": "收货人姓名",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('consigneePhone') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "consigneePhone",
      "label": "收货人电话",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('province') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "province",
      "label": "省",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('city') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "city",
      "label": "市",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('district') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "district",
      "label": "县（区）",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('address') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "address",
      "label": "收货人地址",
      "align": "left"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('franchisee') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "franchisee",
      "label": "加盟商姓名",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('used') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "used",
      "label": "是否已消费",
      "formatter": _vm.formatUsed,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('usedOrderCode') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "usedOrderCode",
      "label": "消费订单号",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('remark') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "left"
    }
  }) : _vm._e(), _vm._v(" "), _c('af-table-column', {
    key: Math.random(),
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "130",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.used === 0) ? _c('span', [_c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v("|\n\t\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.delData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "pageSize": _vm.pageSize,
      "pageNum": _vm.pageNum,
      "totalNum": _vm.totalNum
    },
    on: {
      "handlePageSizeChange": _vm.handlePageSizeChange,
      "handlePageCurrentChange": _vm.handlePageCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": "设置显示列",
      "visible": _vm.colDialogVisible,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.colDialogVisible = $event
      },
      "close": _vm.closeColSet
    }
  }, [_c('el-transfer', {
    staticStyle: {
      "width": "500px",
      "margin": "15px auto"
    },
    attrs: {
      "data": _vm.colDatas,
      "titles": ['显示列', '不显示列']
    },
    model: {
      value: (_vm.colUnShowKeys),
      callback: function($$v) {
        _vm.colUnShowKeys = $$v
      },
      expression: "colUnShowKeys"
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "800px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "返单券ID",
      "prop": "id"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": true
    },
    model: {
      value: (_vm.formData.id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id", $$v)
      },
      expression: "formData.id"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单编号",
      "prop": "orderCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.unEditEnable
    },
    on: {
      "change": _vm.searchData
    },
    model: {
      value: (_vm.formData.orderCode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "orderCode", $$v)
      },
      expression: "formData.orderCode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('label', {
    staticClass: "hzpedit",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchData.apply(null, arguments)
      }
    }
  }, [_vm._v("搜索")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "下单人姓名",
      "prop": "ordercaretername"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.unEditEnable
    },
    model: {
      value: (_vm.formData.ordercaretername),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ordercaretername", $$v)
      },
      expression: "formData.ordercaretername"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "下单人编号",
      "prop": "ordercareter"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.unEditEnable
    },
    model: {
      value: (_vm.formData.ordercareter),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ordercareter", $$v)
      },
      expression: "formData.ordercareter"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "培训公司",
      "prop": "aagencyid"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.searchAgencyname($event)
      }
    },
    model: {
      value: (_vm.formData.aagencyid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "aagencyid", $$v)
      },
      expression: "formData.aagencyid"
    }
  }, _vm._l((_vm.agencyDatas), function(item) {
    return _c('el-option', {
      key: item.aagencyid,
      attrs: {
        "label": item.aagencyname,
        "value": item.aagencyid
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "销售公司",
      "prop": "pagencyname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.pagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "pagencyname", $$v)
      },
      expression: "formData.pagencyname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代理1",
      "prop": "cagencyname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.cagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cagencyname", $$v)
      },
      expression: "formData.cagencyname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代理2",
      "prop": "tagencyname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.tagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tagencyname", $$v)
      },
      expression: "formData.tagencyname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货人姓名",
      "prop": "consignee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.consignee),
      callback: function($$v) {
        _vm.$set(_vm.formData, "consignee", $$v)
      },
      expression: "formData.consignee"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "返单券金额",
      "prop": "amount",
      "id": "focus-ele"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.amount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "amount", $$v)
      },
      expression: "formData.amount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "加盟商姓名",
      "prop": "franchisee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.franchisee),
      callback: function($$v) {
        _vm.$set(_vm.formData, "franchisee", $$v)
      },
      expression: "formData.franchisee"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货人电话",
      "prop": "consigneePhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.consigneePhone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "consigneePhone", $$v)
      },
      expression: "formData.consigneePhone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "省市县(区)",
      "prop": "province"
    }
  }, [_c('region-picker', {
    attrs: {
      "placeholder": {
        province: '选择省份',
        city: '选择市',
        district: '选择县（区）'
      },
      "province": _vm.formData.region.province,
      "city": _vm.formData.region.city,
      "district": _vm.formData.region.district
    },
    on: {
      "onchange": _vm.regionChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货人地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备    注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 719:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "combinationcontainer",
    staticClass: "combination-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-info",
    staticStyle: {
      "float": "right",
      "margin-right": "2px"
    },
    attrs: {
      "type": "info",
      "plain": ""
    },
    on: {
      "click": _vm.pagePositionClick
    }
  }, [_vm._v(_vm._s(_vm.pagePosition))]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 85,
      "highlight-current-row": "",
      "id": "out-table",
      "border": "",
      "row-key": "id"
    },
    on: {
      "row-click": _vm.handleRowChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNum - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "thumimage",
      "label": "图片",
      "align": "center",
      "min-width": "20%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-image', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!!scope.row.thumimage),
            expression: "!!scope.row.thumimage"
          }],
          staticStyle: {
            "width": "50px",
            "height": "50px"
          },
          attrs: {
            "src": scope.row.thumimage,
            "fit": "cover"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "formatter": _vm.formatStatus,
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.enableData(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status === "0" ? '禁用' : '启用'))]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.nextStep(scope.$index, scope.row)
            }
          }
        }, [_vm._v("组合商品")])]
      }
    }])
  })], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "pageSize": _vm.pageSize,
      "pageNum": _vm.pageNum,
      "totalNum": _vm.totalNum
    },
    on: {
      "handlePageSizeChange": _vm.handlePageSizeChange,
      "handlePageCurrentChange": _vm.handlePageCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名    称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "id": "focus-ele"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图    片",
      "prop": ""
    }
  }, [_c('UploadFile', {
    ref: "UploadFile",
    attrs: {
      "imgUrl": _vm.formData.thumimage
    },
    on: {
      "getFileUrl": _vm.getFileUrl
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备    注",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "width": "100px",
      "font-size": "20px",
      "margin-top": "8px",
      "margin-right": "-15px"
    }
  }, [_c('label', [_vm._v("上级位置：")])])
}]}

/***/ }),

/***/ 720:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [(!!_vm.fileUrl && _vm.fileUrl !== _vm.addImg) ? _c('video', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.fileUrl
    }
  }, [_vm._v("\n\t\t\t\tYour browser does not support the video tag.\n\t\t\t")]) : _c('el-image', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.fileUrl,
      "fit": "cover"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('a', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "file",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.btnText) + "\n    \t\t\t"), _c('input', {
    attrs: {
      "id": "file",
      "type": "file",
      "accept": "video/mp4, video/rm, video/rmvb, video/mov, video/m4v, video/avi, video/flv, video/wmv"
    },
    on: {
      "change": function($event) {
        return _vm.uploadFile($event)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticStyle: {
      "display": "block",
      "margin-left": "50px"
    }
  }, [_vm._v("最大20M")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 726:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 727:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(15);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(168);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(342);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(343);

var getters = _interopRequireWildcard(_getters);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    count: 10,
    loginUser: null,
    httpRequestList: [],
    editObject: null,
    editedToPath: '/home',
    UnShowColObj: [],

    addCourseSchedule: [],
    delCourseSchedule: [] };

var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    }
};

exports.default = new _vuex2.default.Store({
    actions: actions,
    getters: getters,
    state: state,
    mutations: mutations
});

/***/ })

},[340]);


// WEBPACK FOOTER //
// static/js/app.b06d21e95e5511299575.js